// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/NeueHaasDisplay-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/NeueHaasDisplay-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/NeueHaasDisplay-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/NeueHaasDisplay-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/NeueHaasDisplay-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/NeueHaasDisplay-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/NeueHaasDisplay-Mediu.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/NeueHaasDisplay-Mediu.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/NeueHaasDisplay-Roman.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/NeueHaasDisplay-Roman.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/NeueHaasDisplay-XXThin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/NeueHaasDisplay-XXThin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/NeueHaasDisplay-XThin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/NeueHaasDisplay-XThin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/NeueHaasDisplay-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/NeueHaasDisplay-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/NeueHaasDisplay-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/NeueHaasDisplay-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/NeueHaasDisplay-RomanItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/NeueHaasDisplay-RomanItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/Manrope-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/Manrope-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/Manrope-ExtraLight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/Manrope-ExtraLight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/Manrope-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/Manrope-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/Manrope-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/Manrope-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/Manrope-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../fonts/Manrope-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../fonts/Manrope-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../fonts/Manrope-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../fonts/Manrope-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../fonts/Manrope-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../fonts/DMSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../fonts/DMSans-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../fonts/DMSans-MediumItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../fonts/DMSans-MediumItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../fonts/DMSans-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../fonts/DMSans-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../fonts/DMSans-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../fonts/DMSans-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../fonts/DMSans-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../fonts/DMSans-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../fonts/DMSans-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("../fonts/DMSans-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../images/social.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../images/video.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../images/games2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../images/ads2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../images/web.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../images/metaverse.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../images/ads.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../images/animation-&-motion-graphics.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../images/Rikki.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../images/Dia.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("../images/Dooj.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("../images/Khushboo.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("../images/Michell.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("../images/Prerna.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("../images/Mobile-BG.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("../images/hero_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("../images/Playbutton.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("../images/ad-images/arrowRight.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("../images/ad-images/leftArrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("../images/ad-images/backMeta.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("../images/ad-images/google_ads.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("../images/ad-images/Tiktok.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("../images/ad-images/Taboola.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("../images/ad-images/Snap.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("../images/ad-images/footerback.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("../images/blinkecom-images/gredient.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Neue Haas Grotesk Display Pro Black";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro XXThin";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff");
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro XThin";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff");
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro Thin";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff");
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro light italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff");
  font-weight: 300;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro roman italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff");
  font-weight: 500;
  font-style: italic;
  font-display: swap;
}
/* VARIABLES */
/* Color */
@font-face {
  font-family: "Manrope Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Manrope Extralight";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("woff");
  font-weight: 200;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Manrope Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Manrope Extrabold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Manrope Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("woff");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Manrope Semibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("woff");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Manrope Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
/* VARIABLES */
@font-face {
  font-family: "DM Sans Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "DM Sans MedItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format("woff");
  font-weight: 500;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: "DM Sans Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_38___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format("woff");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "DM Sans Italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_40___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_41___}) format("woff");
  font-weight: normal;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: "DM Sans Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_42___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_43___}) format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "DM Sans BoldItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_44___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_45___}) format("woff");
  font-weight: bold;
  font-style: italic;
  font-display: swap;
}
/* VARIABLES */
/* MIXINS */
/* RESET CSS */
/* http://meyerweb.com/eric/tools/css/reset/
     v2.0 | 20110126
     License: none (public domain)
  */
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  color: inherit;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

* {
  box-sizing: border-box;
}

a {
  text-decoration: none;
}
a, a:hover, a:active, a:visited, a:focus {
  color: inherit;
}

i,
em,
.italic-text {
  font-style: italic;
}

.left {
  float: left;
}

.right {
  float: right;
}

.wrap-clear::after {
  content: "";
  display: block;
  clear: both;
}

.clearfix {
  zoom: 1;
  display: table;
  clear: both;
}
.clearfix:before, .clearfix:after {
  content: "";
  display: table;
}
.clearfix:after {
  clear: both;
}

:focus {
  outline: none;
}

input,
button,
textarea {
  border-radius: 0;
  appearance: none;
}

select {
  border-radius: 0;
}

textarea {
  resize: none;
}

/* COMMONS */
body {
  -webkit-font-smoothing: antialiased;
  letter-spacing: 0.6px;
}

ol,
ul {
  margin: 0px;
}

button,
input,
select,
textarea {
  -webkit-appearance: none;
  outline: none;
  border-radius: 0;
  background-color: transparent;
}

input,
textarea {
  background: transparent;
  border: none;
}

input:focus,
select:focus,
textarea:focus,
button:focus,
a:focus {
  outline: none;
}

a {
  color: inherit;
  cursor: pointer;
}

.h1,
.h2,
.h3,
.h4,
h1,
h2,
h3,
h4 {
  line-height: 1.4;
}

p {
  line-height: 1.6;
}

img {
  display: block;
  max-width: 100%;
  height: auto;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.slick-slider.reverse {
  transform: rotate(180deg);
}

.slick-slider.reverse .slick-slide {
  transform: rotate(180deg);
}

@media only screen and (min-width: 1025px) {
  .hidden-lg {
    display: none !important;
  }
}

@media (max-width: 767px) {
  .hidden-xs {
    display: none !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .hidden-md {
    display: none !important;
  }
}

.img-responsive {
  width: 100%;
  height: auto;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  width: 90%;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .container {
    max-width: 768px;
  }
}
@media (max-width: 767px) {
  .container {
    width: 100%;
    padding: 0 20px;
  }
}

/* MAIN CSS */
main {
  position: relative;
}

body {
  scroll-behavior: smooth;
}

.dark-footer {
  background-color: black;
  color: white;
}

.white-footer {
  background-color: white;
  color: black;
}

/* Header styles */
.header {
  padding: 16px 0px;
  position: fixed;
  top: 0px;
  left: 50%;
  /* position the left edge of the element at the middle of the parent */
  transform: translate(-50%, 0);
  z-index: 100;
  width: 100%;
  background-color: transparent;
  transition: all 0.3s ease;
}
@media (max-width: 767px) {
  .header {
    padding: 10px 0;
  }
}

.header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
}
@media (max-width: 767px) {
  .header-wrapper {
    padding-top: 0;
    padding-bottom: 0;
  }
}

.logo img {
  width: 140px;
}
@media (max-width: 767px) {
  .logo img {
    width: 130px;
    /* Adjust according to your logo size */
  }
}

/* Desktop nav styles */
.nav-links {
  display: flex;
  align-items: center;
}
@media (max-width: 767px) {
  .nav-links {
    width: 100%;
    position: absolute;
    top: -100vh;
    left: 0;
    background-color: rgb(233, 228, 228);
    display: flex;
    flex-direction: column;
  }
}
@media (max-width: 767px) {
  .nav-links .wrap-links {
    padding-top: 80px;
    padding-bottom: 80px;
    width: 100%;
    height: 100vh;
    background-color: white;
  }
}
.nav-links ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 52px;
}
@media (max-width: 767px) {
  .nav-links ul {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
}
.nav-links ul li a {
  transition: all 0.3s ease;
}
@media (max-width: 767px) {
  .nav-links ul li {
    margin: 0;
  }
  .nav-links ul li a {
    line-height: 1.4;
    font-size: 26px;
    font-family: "Neue Haas Grotesk Display Pro Roman";
  }
}

/* Mobile nav styles */
.menu-icon {
  display: none;
  cursor: pointer;
}
@media (max-width: 767px) {
  .menu-icon {
    position: relative;
    z-index: 20000;
  }
}

.hamburger {
  width: 30px;
  height: 21px;
  position: relative;
}

.hamburger span {
  display: block;
  width: 100%;
  height: 2px;
  background: #000;
  margin-bottom: 6px;
  transition: transform 0.3s, opacity 0.3s;
}

.hamburger.open span:nth-child(1) {
  transform: translateY(8px) rotate(45deg);
}

.hamburger.open span:nth-child(2) {
  opacity: 0;
}

.hamburger.open span:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg);
}

/* Sliding menu styles */
@keyframes italicAnimation {
  0% {
    font-variation-settings: "ital" 12;
  }
  100% {
    font-variation-settings: "ital" 0;
  }
}
li {
  text-align: right;
}
@media (max-width: 767px) {
  li {
    min-width: unset;
  }
}
li a {
  text-decoration: none;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  color: black;
  font-size: 18px;
  transition: all 0.3s ease;
  display: block;
  transition: transform 0.2s ease;
}
li a:hover {
  transform: skew(-15deg);
}
li a:not(:hover) {
  animation-name: italics-animation-reverse;
}

li:last-child {
  margin-right: 0;
}

/* Media query for mobile */
@media (max-width: 768px) {
  .nav-links {
    text-align: center;
  }
  .menu-icon {
    display: block;
  }
}
.header.scroll-top {
  background: white;
}
.header.scroll-top .header-wrapper .nav-links ul li a:hover {
  color: #516beb;
}

#hero {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
@media (max-width: 767px) {
  #hero {
    padding-top: 160px;
    padding-bottom: 100px;
    height: auto;
  }
}
#hero .headings .top-copy-container p {
  color: white;
}
#hero .headings .head-copy-container h1 {
  color: white;
}
#hero .headings p {
  font-family: "Neue Haas Grotesk Display Pro Light";
  text-align: center;
  font-size: 100px;
  line-height: 1;
  text-transform: lowercase;
}
@media (max-width: 767px) {
  #hero .headings p {
    font-size: 40px;
    line-height: 1.1;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #hero .headings p {
    font-size: 70px;
  }
}
#hero .headings h1 {
  font-family: "Neue Haas Grotesk Display Pro Light";
  text-align: center;
  font-size: 200px;
  line-height: 1;
  text-transform: lowercase;
}
@media (max-width: 767px) {
  #hero .headings h1 {
    font-size: 60px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #hero .headings h1 {
    font-size: 140px;
  }
}
#hero .headings .bottom-copy {
  margin-top: 2rem;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 20px;
  z-index: 10;
  text-align: center;
  color: black;
}
@media (max-width: 767px) {
  #hero .headings .bottom-copy {
    text-align: center;
    margin-top: 20px;
    font-size: 13px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #hero .headings .bottom-copy {
    font-size: 26px;
  }
}
#hero .top-copy-container,
#hero .bottom-copy-container,
#hero .head-copy-container {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 100%;
}

.image-at-cursor {
  position: absolute;
  pointer-events: none;
  z-index: 1000;
  transition: transform 0.3s ease;
}

#about {
  padding-top: 20px;
}
@media (max-width: 767px) {
  #about {
    padding-bottom: 0;
    padding-top: 70px;
  }
}
#about .about-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
}
@media (max-width: 767px) {
  #about .about-wrapper {
    gap: 180px;
    gap: 2rem;
  }
}
#about .about-wrapper .top-img-wrap .about-image {
  padding: 15px;
}
@media (max-width: 767px) {
  #about .about-wrapper .top-img-wrap .about-image {
    padding: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #about .about-wrapper .top-img-wrap .about-image {
    width: 350px;
    height: 240px;
  }
}
#about .about-wrapper .top-img-wrap .about-image img {
  object-fit: cover;
}
#about .about-wrapper .top-img-wrap .about-image p {
  background-color: white;
  border-radius: 20px;
  padding: 0px 10px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 14px;
}
@media (max-width: 767px) {
  #about .about-wrapper .top-img-wrap .about-image p {
    font-size: 10px;
    line-height: 100%;
    padding: 3px 10px;
    font-size: 10px;
    line-height: 100%;
    padding: 3px 0px;
  }
}
#about .about-wrapper .top-img-wrap .intro {
  max-width: 500px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 1.5rem;
  line-height: 1.25;
}
@media (max-width: 767px) {
  #about .about-wrapper .top-img-wrap .intro {
    font-size: 1rem;
  }
}
#about .about-wrapper .about-image {
  border-radius: 30px;
}
#about .about-wrapper .about-image .img-wrap {
  position: relative;
}
#about .about-wrapper .about-image .img-wrap .black-overlay {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 40%;
  padding: 10px;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image .img-wrap .black-overlay {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
}
#about .about-wrapper .about-image .img-wrap .copy-below {
  position: absolute;
  bottom: 15px;
  right: 10px;
  color: white;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image .img-wrap .copy-below {
    bottom: 5px;
    right: 10px;
  }
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image {
    border-radius: 10px;
  }
}
#about .about-wrapper .about-image img {
  object-fit: cover;
}
#about .about-wrapper .about-image.about-image-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-top {
    max-width: 200px;
  }
}
#about .about-wrapper .about-image.about-image-top img {
  margin-bottom: 0px;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-top img {
    margin-bottom: 0px;
  }
}
#about .about-wrapper .about-image.about-image-top p {
  background-color: unset;
}
#about .about-wrapper .about-image.about-image-top .copy-below {
  font-size: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1.2;
  left: 10px;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-top .copy-below {
    font-size: 14px;
  }
}
#about .about-wrapper .about-image.about-image-center {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  align-self: flex-end;
  justify-content: flex-end;
  align-items: flex-end;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-center {
    flex-direction: column;
  }
}
#about .about-wrapper .about-image.about-image-center p {
  border-radius: 20px;
  padding: 0px 10px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 14px;
  max-width: -moz-fit-content;
  max-width: fit-content;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-center p {
    font-size: 10px;
    font-size: 10px;
    line-height: 100%;
    padding: 0px;
  }
}
#about .about-wrapper .about-image.about-image-center .copy-below {
  font-size: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1.2;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-center .copy-below {
    font-size: 14px;
  }
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-center {
    align-self: flex-end;
    position: static;
    max-width: 200px;
    padding: 0px;
    background-size: cover;
    margin-top: -10px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #about .about-wrapper .about-image.about-image-center {
    width: 350px;
    height: 240px;
  }
}
#about .about-wrapper .about-image.about-image-bottom {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
}
#about .about-wrapper .about-image.about-image-bottom img {
  object-fit: cover;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-bottom {
    width: 200px;
    padding: 0;
    margin-top: -10px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #about .about-wrapper .about-image.about-image-bottom {
    width: 350px;
    height: 240px;
  }
}
#about .about-wrapper .about-image.about-image-bottom p {
  border-radius: 20px;
  padding: 0px 10px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 14px;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-bottom p {
    font-size: 10px;
    font-size: 10px;
    line-height: 100%;
    padding: 0px;
  }
}
#about .about-wrapper .about-image.about-image-bottom .copy-below {
  font-size: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1.2;
  left: 10px;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-bottom .copy-below {
    font-size: 14px;
  }
}
#about .about-wrapper .center-copy {
  width: 100%;
  position: absolute;
  top: 50%;
  /* position the top  edge of the element at the middle of the parent */
  left: 50%;
  /* position the left edge of the element at the middle of the parent */
  transform: translate(-50%, -50%);
  font-family: "Neue Haas Grotesk Display Pro Light";
  font-size: 100px;
  z-index: 50;
  line-height: 1;
  color: white;
  will-change: transform;
  -webkit-font-smoothing: antialiased;
  text-align: center;
}
@media (max-width: 767px) {
  #about .about-wrapper .center-copy {
    font-size: 34px;
    position: static;
    transform: unset;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    margin-bottom: 0px;
    font-size: 40px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #about .about-wrapper .center-copy {
    font-size: 60px;
  }
}

.back-constant {
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}

#work {
  padding: 120px 0;
}
@media (max-width: 767px) {
  #work {
    padding: 40px 0;
    padding-top: 80px;
  }
}
#work .work-copy {
  max-width: 100%;
}
@media (max-width: 767px) {
  #work .work-copy {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }
}
#work .work-copy h3 {
  font-size: 100px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 100%;
  color: white;
}
@media (max-width: 767px) {
  #work .work-copy h3 {
    font-size: 34px;
    font-family: "Neue Haas Grotesk Display Pro Roman";
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #work .work-copy h3 {
    font-size: 60px;
  }
}
#work .work-copy p {
  font-size: 1rem;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1.4;
  font-size: 18px;
}
@media (max-width: 767px) {
  #work .work-copy p {
    font-size: 15px;
  }
}
#work .sliders-wrap {
  z-index: 7;
  position: relative;
  display: flex;
  gap: 90px;
  flex-direction: column;
}
@media (max-width: 767px) {
  #work .sliders-wrap {
    gap: 3rem;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #work .sliders-wrap {
    gap: 80px;
  }
}
#work .sliders-wrap .work-slider-top {
  max-width: 100%;
}
#work .sliders-wrap .work-slider-top .slick-slider .slick-prev {
  display: none;
}
#work .sliders-wrap .work-slider-top .slick-slider .slick-next {
  display: none;
}
#work .sliders-wrap .work-slider-top .card-item {
  width: 360px;
  height: 250px;
  margin: 0 80px;
  overflow: hidden;
  border-radius: 10px;
  position: relative;
  display: flex;
  justify-content: end;
  align-items: flex-start;
  padding: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  justify-content: flex-start;
  align-items: flex-end;
}
@media (max-width: 767px) {
  #work .sliders-wrap .work-slider-top .card-item {
    margin: 0 30px;
    padding: 10px;
    width: 90%;
    height: 150px;
    background-size: cover;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #work .sliders-wrap .work-slider-top .card-item {
    width: 320px;
    height: 220px;
  }
}
#work .sliders-wrap .work-slider-top .card-item img {
  object-fit: cover;
  display: block;
}
#work .sliders-wrap .work-slider-top .card-item p {
  line-height: 1.2;
  padding: 1px 10px;
  border-radius: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  color: white;
  font-size: 22px;
}
@media (max-width: 767px) {
  #work .sliders-wrap .work-slider-top .card-item p {
    font-size: 16px;
  }
}
#work .sliders-wrap .work-slider-top .card-item.card-1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
#work .sliders-wrap .work-slider-top .card-item.card-2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
#work .sliders-wrap .work-slider-top .card-item.card-3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
#work .sliders-wrap .work-slider-top .card-item.card-4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
#work .sliders-wrap .work-slider-bottom {
  max-width: 100%;
}
#work .sliders-wrap .work-slider-bottom .slick-slider .slick-prev {
  display: none;
}
#work .sliders-wrap .work-slider-bottom .slick-slider .slick-next {
  display: none;
}
#work .sliders-wrap .work-slider-bottom .card-item {
  width: 360px;
  height: 250px;
  margin: 0 80px;
  overflow: hidden;
  border-radius: 10px;
  position: relative;
  display: flex;
  justify-content: end;
  align-items: flex-start;
  padding: 10px;
  justify-content: flex-start;
  align-items: flex-end;
}
@media (max-width: 767px) {
  #work .sliders-wrap .work-slider-bottom .card-item {
    margin: 0 10px;
    width: 90%;
    height: 150px;
    background-size: cover;
    padding: 10px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #work .sliders-wrap .work-slider-bottom .card-item {
    width: 320px;
    height: 220px;
  }
}
#work .sliders-wrap .work-slider-bottom .card-item img {
  object-fit: cover;
  display: block;
}
#work .sliders-wrap .work-slider-bottom .card-item p {
  line-height: 1.2;
  padding: 1px 10px;
  border-radius: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  color: white;
  font-size: 22px;
}
@media (max-width: 767px) {
  #work .sliders-wrap .work-slider-bottom .card-item p {
    font-size: 16px;
  }
}
#work .sliders-wrap .work-slider-bottom .card-item.card-1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
#work .sliders-wrap .work-slider-bottom .card-item.card-1 p {
  background-color: white;
  line-height: 1.2;
  padding: 0px 10px;
  border-radius: 8px;
}
#work .sliders-wrap .work-slider-bottom .card-item.card-2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
  background-color: rgb(100, 98, 124);
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
#work .sliders-wrap .work-slider-bottom .card-item.card-3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
#work .sliders-wrap .work-slider-bottom .card-item.card-4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  background-color: rgb(100, 98, 124);
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
#work .sliders-wrap .work_heading {
  position: absolute;
  font-size: 11rem;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  top: 50%;
  /* position the top  edge of the element at the middle of the parent */
  left: 50%;
  /* position the left edge of the element at the middle of the parent */
  transform: translate(-50%, -50%);
  color: white;
  z-index: 1;
}
@media (max-width: 767px) {
  #work .sliders-wrap .work_heading {
    font-size: 3rem;
  }
}

#team {
  pointer-events: none;
  position: relative;
}
@media (max-width: 767px) {
  #team {
    padding: 0px 0;
  }
}
#team .team-slider {
  z-index: 10;
}
@media (max-width: 767px) {
  #team .team-slider {
    padding: 0;
  }
}
#team .team-slider .slick-slider .slick-prev {
  display: none;
}
#team .team-slider .slick-slider .slick-next {
  display: none;
}
#team .team-slider .slick-slide {
  padding: 0 20px;
}
@media (max-width: 767px) {
  #team .team-slider .slick-slide {
    padding: 0 15px;
  }
}
#team .team-slider .team-card {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  border-radius: 15px;
  position: relative;
}
#team .team-slider .team-card .black-overlay {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 40%;
  padding: 10px;
}
#team .team-slider .team-card .team-name {
  position: absolute;
  margin-bottom: 15px;
  margin-left: 15px;
}
#team .team-slider .team-card p {
  color: white;
  font-size: 19px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1;
}
@media (max-width: 767px) {
  #team .team-slider .team-card p {
    font-size: 16px;
  }
}
#team .team-slider .team-card.team-card-0 {
  width: 130px;
  height: 350px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
}
#team .team-slider .team-card.team-card-1 {
  width: 130px;
  height: 350px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
}
#team .team-slider .team-card.team-card-2 {
  width: 150px;
  height: 400px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
}
#team .team-slider .team-card.team-card-3 {
  width: 130px;
  height: 350px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
}
#team .team-slider .team-card.team-card-4 {
  width: 110px;
  height: 400px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
}
#team .team-slider .team-card.team-card-5 {
  width: 140px;
  height: 350px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
}
#team .team-slider .team-card.team-card-6 {
  width: 140px;
  height: 400px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
}
#team .team-slider .team-card.team-card-7 {
  width: 200px;
  height: 500px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
}
#team .team-slider .team-card.team-card-8 {
  width: 120px;
  height: 400px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
}
#team .team-slider .team-card.team-card-9 {
  width: 140px;
  height: 400px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
}
#team .team-slider .team-card.team-card-10 {
  width: 130px;
  height: 400px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
}
#team .team-slider .team-card.team-card-11 {
  width: 120px;
  height: 400px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
}
#team .team-slider .m-50 {
  margin-top: 50px;
}
@media (max-width: 767px) {
  #team .team-slider .m-50 {
    margin-top: 0px;
  }
}
#team .team-slider .m-100 {
  margin-top: 100px;
}
@media (max-width: 767px) {
  #team .team-slider .m-100 {
    margin-top: 30px;
  }
}
#team .team-slider .m-150 {
  margin-top: 150px;
}
@media (max-width: 767px) {
  #team .team-slider .m-150 {
    margin-top: 120px;
  }
}
#team .team-slider .m-200 {
  margin-top: 200px;
}
@media (max-width: 767px) {
  #team .team-slider .m-200 {
    margin-top: 140px;
  }
}
#team .designation {
  margin-top: 6px;
  font-size: 13px !important;
}
@media (max-width: 767px) {
  #team .designation {
    font-size: 10px !important;
  }
}
#team .overlapped-copy-top {
  font-size: 100px;
  font-family: "Neue Haas Grotesk Display Pro Light";
  top: 0rem;
  left: 200px;
  line-height: 100%;
  color: white;
  z-index: 10;
}
@media (max-width: 767px) {
  #team .overlapped-copy-top {
    left: 20px;
    top: 4rem;
    font-size: 34px;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    font-size: 40px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #team .overlapped-copy-top {
    font-size: 60px;
  }
}
#team .overlapped-copy-bottom {
  font-size: 100px;
  font-family: "Neue Haas Grotesk Display Pro Light";
  bottom: -4rem;
  right: 200px;
  text-align: right;
  line-height: 100%;
  color: white;
}
@media (max-width: 767px) {
  #team .overlapped-copy-bottom {
    right: 20px;
    font-size: 2rem;
    bottom: 0rem;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    font-size: 40px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #team .overlapped-copy-bottom {
    font-size: 60px;
  }
}

.zIndex-box {
  display: none;
}
@media (max-width: 767px) {
  .zIndex-box {
    display: block;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    bottom: -20%;
    right: 0;
    z-index: -1;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
    background-repeat: repeat-y;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
}

.home-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
@media (max-width: 767px) {
  .home-page {
    background-image: unset;
  }
}
@media (max-width: 767px) and (max-width: 767px) {
  .home-page:before {
    content: "";
    display: block;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -10;
    background-size: cover;
  }
}

.home-page-all {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.work-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
@media (max-width: 767px) {
  .work-page {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
    background-repeat: repeat;
  }
}

#awards {
  padding: 135px 0;
}
@media (max-width: 767px) {
  #awards {
    padding: 0;
    padding: 80px 0;
  }
}
#awards .awards-heading {
  font-family: "Neue Haas Grotesk Display Pro Light";
  font-size: 100px;
  text-align: center;
  margin-bottom: 4rem;
  color: white;
  line-height: 1;
}
@media (max-width: 767px) {
  #awards .awards-heading {
    font-size: 34px;
    margin-bottom: 2rem;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    font-size: 40px;
    margin-bottom: 2rem;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    line-height: 1;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #awards .awards-heading {
    font-size: 60px;
  }
}
#awards .awards-wrapper {
  max-width: 900px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5rem;
}
#awards .awards-wrapper .custom-tooltip {
  background-color: red;
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  font-size: 14px;
}
#awards .awards-wrapper .custom-tooltip-arrow {
  color: #333; /* Matches the background color of the tooltip */
}
#awards .awards-wrapper .slick-slide {
  padding: 0 40px;
}
@media (max-width: 767px) {
  #awards .awards-wrapper .slick-slide {
    padding: 0 20px;
  }
}
@media (max-width: 767px) {
  #awards .awards-wrapper {
    max-width: unset;
    gap: 20px;
  }
}
#awards .awards-wrapper #tooltip {
  font-family: "Neue Haas Grotesk Display Pro Mediu";
}
#awards .awards-wrapper .tooltip {
  max-width: 83px;
}
#awards .awards-wrapper .tooltip p {
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  margin-top: 10px;
  text-align: center;
}
@media (max-width: 767px) {
  #awards .awards-wrapper .tooltip p {
    margin-top: 12px;
    font-size: 12px;
  }
}
#awards .awards-wrapper .tooltip .tooltiptext {
  visibility: hidden;
  width: -moz-fit-content;
  width: fit-content;
  white-space: nowrap;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 5px;
  bottom: 120%;
  left: 50%;
  /* margin-left: -60px; */
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 14px;
  transform: translate(-50%, 0%);
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}
#awards .awards-wrapper .tooltip:hover .tooltiptext {
  visibility: visible;
}
#awards .award-slider .slick-track {
  display: flex;
  padding: 0 10px;
}

#offices {
  padding-bottom: 120px;
}
@media (max-width: 767px) {
  #offices {
    padding: 0px 0;
    padding-bottom: 50px;
  }
}
#offices .offices-heading {
  max-width: 900px;
  font-family: "Neue Haas Grotesk Display Pro Light";
  font-size: 100px;
  line-height: 1;
  margin-bottom: 4rem;
  color: white;
}
@media (max-width: 767px) {
  #offices .offices-heading {
    margin-bottom: 2rem;
    font-size: 34px;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    line-height: 1;
    font-size: 40px;
    text-align: start;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #offices .offices-heading {
    font-size: 60px;
  }
}
#offices .card-wrapper {
  max-width: 900px;
  display: flex;
  justify-content: center;
  gap: 4rem;
}
@media (max-width: 767px) {
  #offices .card-wrapper {
    flex-direction: column;
    gap: 30px;
    padding: 0 70px;
  }
}
#offices .card-wrapper .card {
  background-color: rgba(255, 255, 255, 0.568627451);
  padding: 30px;
  flex: 1 1;
}
#offices .card-wrapper .card .city {
  font-size: 2.5rem;
  margin-bottom: 1.2rem;
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
@media (max-width: 767px) {
  #offices .card-wrapper .card .city {
    font-size: 26px;
    margin-bottom: 10px;
  }
}
#offices .card-wrapper .card .adj {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  border-bottom: 1px solid black;
  line-height: 1;
  max-width: -moz-fit-content;
  max-width: fit-content;
  margin-bottom: 10px;
}
#offices .card-wrapper .card .adj.adj1 {
  border-bottom: none;
  line-height: 1.3;
  margin-bottom: 3px;
}
@media (max-width: 767px) {
  #offices .card-wrapper .card .adj {
    font-size: 12px;
  }
  #offices .card-wrapper .card .adj.adj1 {
    font-size: 14px;
  }
}
#offices .card-wrapper .card .location {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 21px;
  line-height: 1;
  margin-bottom: 10px;
}
@media (max-width: 767px) {
  #offices .card-wrapper .card .location {
    font-size: 17px;
  }
}
#offices .card-wrapper .card .our-location {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  border-bottom: 1px solid black;
  line-height: 1;
  max-width: -moz-fit-content;
  max-width: fit-content;
  margin-bottom: 0.5rem;
}
#offices .card-wrapper .card .our-location.hgb {
  border-bottom: none;
}
#offices .card-wrapper .card .lets {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  border-bottom: 1px solid black;
  line-height: 1;
  max-width: -moz-fit-content;
  max-width: fit-content;
  margin-bottom: 0.5rem;
}
#offices .card-wrapper .card .name {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 21px;
  line-height: 1;
  margin-bottom: 1.4rem;
}
#offices .card-wrapper .card .post {
  line-height: 1;
  font-size: 1.2rem;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  margin-bottom: 5px;
}
#offices .card-wrapper .card .email {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 80%;
}
#offices .adr-slider-mobile {
  display: none;
}
@media (max-width: 767px) {
  #offices .adr-slider-mobile {
    display: block;
  }
  #offices .adr-slider-mobile .slick-list {
    padding: 0 50px; /* Optional: Adjust padding to control visibility of side slides */
  }
  #offices .adr-slider-mobile .slick-track {
    display: flex;
  }
  #offices .adr-slider-mobile .slick-slide {
    margin: 0 20px;
    max-width: 300px;
    transform: translateZ(0);
  }
  #offices .adr-slider-mobile .swiper-wrapper {
    display: flex;
  }
  #offices .adr-slider-mobile .card {
    background-color: rgba(255, 255, 255, 0.568627451);
    padding: 30px;
    flex: 1 1;
    height: 290px;
    margin: 0 20px;
  }
  #offices .adr-slider-mobile .card .city {
    font-size: 2.5rem;
    margin-bottom: 1.2rem;
    font-family: "Neue Haas Grotesk Display Pro Roman";
  }
}
@media (max-width: 767px) and (max-width: 767px) {
  #offices .adr-slider-mobile .card .city {
    font-size: 26px;
    margin-bottom: 10px;
  }
}
@media (max-width: 767px) {
  #offices .adr-slider-mobile .card .adj {
    font-family: "Neue Haas Grotesk Display Pro Roman";
    border-bottom: 1px solid black;
    line-height: 1;
    max-width: -moz-fit-content;
    max-width: fit-content;
    margin-bottom: 10px;
  }
  #offices .adr-slider-mobile .card .adj.adj1 {
    border-bottom: none;
    line-height: 1.3;
    margin-bottom: 3px;
  }
}
@media (max-width: 767px) and (max-width: 767px) {
  #offices .adr-slider-mobile .card .adj {
    font-size: 12px;
  }
  #offices .adr-slider-mobile .card .adj.adj1 {
    font-size: 14px;
  }
}
@media (max-width: 767px) {
  #offices .adr-slider-mobile .card .location {
    font-family: "Neue Haas Grotesk Display Pro Roman";
    font-size: 21px;
    line-height: 1;
    margin-bottom: 10px;
  }
}
@media (max-width: 767px) and (max-width: 767px) {
  #offices .adr-slider-mobile .card .location {
    font-size: 17px;
  }
}
@media (max-width: 767px) {
  #offices .adr-slider-mobile .card .our-location {
    font-family: "Neue Haas Grotesk Display Pro Roman";
    border-bottom: 1px solid black;
    line-height: 1;
    max-width: -moz-fit-content;
    max-width: fit-content;
    margin-bottom: 0.5rem;
  }
  #offices .adr-slider-mobile .card .our-location.hgb {
    border-bottom: none;
  }
  #offices .adr-slider-mobile .card .lets {
    font-family: "Neue Haas Grotesk Display Pro Roman";
    border-bottom: 1px solid black;
    line-height: 1;
    max-width: -moz-fit-content;
    max-width: fit-content;
    margin-bottom: 0.5rem;
  }
  #offices .adr-slider-mobile .card .name {
    font-family: "Neue Haas Grotesk Display Pro Roman";
    font-size: 21px;
    line-height: 1;
    margin-bottom: 1.4rem;
  }
  #offices .adr-slider-mobile .card .post {
    line-height: 1;
    font-size: 1.2rem;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    margin-bottom: 5px;
  }
  #offices .adr-slider-mobile .card .email {
    font-family: "Neue Haas Grotesk Display Pro Roman";
    line-height: 80%;
  }
}

#news {
  padding-top: 200px;
  padding-bottom: 60px;
}
#news .news-heading {
  font-size: 180px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 100%;
  text-transform: uppercase;
  line-height: 0.8;
  padding-bottom: 10px;
  margin-left: -5px;
}
@media (max-width: 767px) {
  #news .news-heading {
    line-height: 1.4;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #news .news-heading {
    font-size: 100px;
  }
}
@media only screen and (min-width: 1025px) {
  #news .news-heading {
    font-size: 140px;
  }
}
#news .news-item {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
@media (max-width: 767px) {
  #news .news-item {
    flex-direction: column;
    gap: 20px;
  }
}
#news .news-item .filter-wrapper {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  align-self: flex-end;
}
#news .news-item .filter-wrapper .label {
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
@media (max-width: 767px) {
  #news .news-item .filter-wrapper {
    gap: 10px;
  }
  #news .news-item .filter-wrapper span {
    font-size: 14px;
  }
}
#news .news-item .filter-wrapper .select-div {
  border: 1px black solid;
  border-radius: 50px;
  padding: 4px 20px;
  display: flex;
  align-items: center;
  gap: 2rem;
}
@media (max-width: 767px) {
  #news .news-item .filter-wrapper .select-div {
    padding: 4px 14px;
    display: flex;
    align-items: center;
    gap: 10px;
  }
}
#news .news-item .filter-wrapper .select-div select {
  text-transform: capitalize;
  border: none;
  font-size: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
@media (max-width: 767px) {
  #news .news-item .filter-wrapper .select-div select {
    font-size: 16px;
  }
}
#news .news-item.news-one {
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  padding-top: 17px;
}
@media (max-width: 767px) {
  #news .news-item.news-one {
    padding-top: 14px;
    padding-bottom: 40px;
  }
}
#news .news-item.news-one .news-individual {
  padding-top: 60px;
  padding-bottom: 60px;
  border-top: black 1px solid;
  display: flex;
  gap: 2rem;
  transition: all 0.3s ease;
}
#news .news-item.news-one .news-individual:hover p.copy {
  text-decoration: underline;
}
#news .news-item.news-one .news-individual .news-image {
  flex: 1 1;
  overflow: hidden;
}
#news .news-item.news-one .news-individual .news-image .news-img-class {
  border-radius: 20px;
  overflow: hidden;
  width: 100%;
}
#news .news-item.news-one .news-individual .news-image.news-image-copy {
  flex: 2 1;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
}
@media (max-width: 767px) {
  #news .news-item.news-one .news-individual .news-image.news-image-copy {
    gap: 20px;
  }
}
#news .news-item.news-one .news-individual .news-image.news-image-copy .award-copy-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
}
#news .news-item.news-one .news-individual .news-image.news-image-copy .award-copy-wrap .award {
  border: 1px black solid;
  border-radius: 50px;
  padding: 3px 20px;
  text-align: center;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  text-transform: capitalize;
}
#news .news-item.news-one .news-individual .news-image.news-image-copy .award-copy-wrap .copy {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 26px;
  line-height: 1.4;
}
@media (max-width: 767px) {
  #news .news-item.news-one .news-individual .news-image.news-image-copy .award-copy-wrap {
    gap: 20px;
  }
  #news .news-item.news-one .news-individual .news-image.news-image-copy .award-copy-wrap .copy {
    font-size: 18px;
    line-height: 1.4;
  }
}
#news .news-item.news-one .news-individual .news-image.news-image-copy .date {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 18px;
  line-height: 1.1;
}
@media (max-width: 767px) {
  #news .news-item.news-one .news-individual .news-image.news-image-copy .date {
    font-size: 16px;
  }
}
@media (max-width: 767px) {
  #news .news-item.news-one .news-individual {
    flex-direction: column;
    gap: 20px;
    padding-top: 40px;
    padding-bottom: 20px;
  }
}
#news .show-more {
  text-align: center;
  display: block;
  text-decoration: underline;
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
@media (max-width: 767px) {
  #news {
    padding-top: 140px;
    padding-bottom: 0;
  }
  #news .news-heading {
    font-size: 60px;
    margin: 0;
    padding: 0;
  }
}

#initatives {
  padding-top: 200px;
  padding-bottom: 60px;
}
@media (max-width: 767px) {
  #initatives {
    padding-top: 140px;
  }
}
#initatives .initatives-wrapper .initatives-flex {
  display: flex;
  flex-direction: column;
}
#initatives .initatives-wrapper .initatives-flex .flex-item {
  display: flex;
  justify-content: space-between;
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flx-center {
  align-items: center;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item {
    flex-direction: column;
    align-items: flex-start;
  }
  #initatives .initatives-wrapper .initatives-flex .flex-item.flx-center {
    align-items: flex-start;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item .it-copy {
  font-size: 23px;
  line-height: 1.4;
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item .it-copy {
    font-size: 22px;
    line-height: 1.3;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item .it-heading {
  font-size: 180px;
  font-family: "Neue Haas Grotesk Display Pro Light";
  line-height: 100%;
  text-transform: lowercase;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item .it-heading {
    font-size: 60px;
    line-height: 1.4;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item .it-heading {
    font-size: 100px;
  }
}
@media only screen and (min-width: 1025px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item .it-heading {
    font-size: 140px;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it {
  padding-top: 50px;
  gap: 20px;
  row-gap: 40px;
  min-height: 340px;
  display: flex;
  flex-direction: column;
  /* Apply flex-direction: row-reverse; to every second .it-card */
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it {
    padding-top: 20px;
    gap: 40px;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card {
  display: flex;
  background: rgba(255, 255, 255, 0.568627451);
  height: 380px;
  overflow: hidden;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card {
    flex: auto;
    flex-direction: column;
    height: unset;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card h3 {
  font-family: "Neue Haas Grotesk Display Pro Bold";
  font-size: 35px;
  margin-bottom: 0px;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card h3 {
    font-size: 24px;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card p {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 20px;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card p {
    font-size: 16px;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .img-wrap {
  display: flex;
  overflow: hidden;
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .img-wrap img {
  flex: 1 1;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .img-wrap {
    border-radius: 20px;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .hover-image-container {
  transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);
  border-radius: 0;
  flex: 70% 1;
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .hover-image-container {
    border-bottom-right-radius: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .hover-image-container {
    align-items: unset;
  }
}
@media only screen and (min-width: 1025px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .hover-image-container img {
    transition: all 0.2s ease-in-out;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .hover-image-container img {
    object-fit: cover;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card:hover img {
  transform: scale(1.02);
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .hover-image-container:nth-child(even) {
  border-radius: 0;
  overflow: hidden;
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .hover-image-container:nth-child(odd) {
  overflow: hidden;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .hover-image-container:nth-child(odd) {
    border-bottom-left-radius: 0;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .copy-wrapper {
  padding: 30px 40px;
  flex: 30% 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .copy-wrapper {
    padding: 20px 20px;
    gap: 40px;
    flex-direction: column;
    align-items: flex-start;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .top-copy .tags-container {
  font-size: 16px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  border: 1px black solid;
  padding: 5px 18px;
  border-radius: 50px;
  width: max-content;
  color: black;
  margin-bottom: 10px;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .top-copy .tags-container {
    font-size: 14px;
    padding: 5px 15px;
    margin-bottom: 10px;
    width: max-content;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .top-copy .tag {
  background-color: black;
  width: -moz-fit-content;
  width: fit-content;
  color: white;
  padding: 3px 10px;
  border-radius: 50px;
  margin-bottom: 20px;
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .top-copy .copy-discription {
  line-height: 1.25;
  font-size: 17px;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .top-copy .copy-discription {
    text-overflow: ellipsis;
    font-size: 13px;
  }
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .top-copy {
    flex: 1 1;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .more {
  display: flex;
  align-items: flex-end;
  gap: 10px;
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .more img {
  transform: translate(-10px, 10px); /* Move the arrow from bottom left */
  opacity: 0; /* Start with the arrow hidden */
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .more {
    gap: 5px;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .more p {
  font-size: 16px;
  padding-bottom: 2px;
  line-height: 1;
  width: max-content;
  position: relative;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .more p {
    font-size: 13px;
    flex: 2 0;
    width: max-content;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .more p::after {
  content: "";
  position: absolute;
  width: 0;
  height: 2px;
  background: black;
  left: 0;
  bottom: -1px; /* Adjust to position underline closer to text */
  transition: width 0.3s ease;
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .more img {
  width: 10px;
  padding-bottom: 5px;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .more img {
    width: 7px;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card:hover .more img {
  transform: translate(0, 0); /* Move to original position and reset rotation */
  opacity: 1;
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card:nth-child(even) {
  flex-direction: row-reverse;
  overflow: hidden;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card:nth-child(even) {
    flex-direction: column;
  }
}

#contact-page {
  padding-top: 200px;
  padding-bottom: 60px;
}
@media (max-width: 767px) {
  #contact-page {
    padding-top: 140px;
  }
}
#contact-page .contact-wrapper .world-contact-map {
  display: flex;
  flex-direction: column;
}
#contact-page .contact-wrapper .world-contact-map .heading-contact {
  font-size: 100px;
  font-family: "Neue Haas Grotesk Display Pro Light";
  line-height: 100%;
  text-transform: lowercase;
  margin-bottom: 50px;
  text-align: center;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .world-contact-map .heading-contact {
    font-size: 40px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #contact-page .contact-wrapper .world-contact-map .heading-contact {
    font-size: 60px;
  }
}
#contact-page .contact-wrapper .world-contact-map .world-map {
  width: 1180px;
  margin: auto;
}
#contact-page .contact-wrapper .world-contact-map .info-card {
  margin-top: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.568627451);
  padding: 30px 30px;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .world-contact-map .info-card {
    flex-direction: column;
    gap: 20px;
    align-items: stretch;
  }
}
#contact-page .contact-wrapper .world-contact-map .info-card .card-item {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-right: 1px solid black;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .world-contact-map .info-card .card-item {
    border-bottom: 1px solid black;
    border-right: none;
    padding-bottom: 20px;
  }
  #contact-page .contact-wrapper .world-contact-map .info-card .card-item:last-child {
    border-bottom: none;
  }
}
#contact-page .contact-wrapper .world-contact-map .info-card .card-item:last-child {
  border-right: none;
}
#contact-page .contact-wrapper .world-contact-map .info-card .card-item h4 {
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  font-size: 24px;
  margin-bottom: 5px;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .world-contact-map .info-card .card-item h4 {
    font-size: 20px;
  }
}
#contact-page .contact-wrapper .world-contact-map .info-card .card-item a {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 18px;
  transition: all 0.2s ease;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .world-contact-map .info-card .card-item a {
    font-size: 14px;
  }
}
#contact-page .contact-wrapper .world-contact-map .info-card .card-item a:hover {
  color: #516beb;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .world-contact-map .info-card .card-item:last-child {
    padding-bottom: 0;
  }
}
#contact-page .contact-wrapper .our-offices {
  margin-top: 50px;
}
#contact-page .contact-wrapper .our-offices .office-head {
  font-size: 90px;
  font-family: "Neue Haas Grotesk Display Pro Light";
  text-transform: lowercase;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .office-head {
    font-size: 40px;
  }
}
#contact-page .contact-wrapper .our-offices .filter {
  display: flex;
  gap: 30px;
  margin-top: 40px;
  margin-bottom: 60px;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .filter {
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-start;
    margin-top: 20px;
    margin-bottom: 0px;
  }
}
#contact-page .contact-wrapper .our-offices .filter .timezone-filter {
  border: 1px solid rgba(19, 19, 19, 0.737);
  padding: 10px 40px;
  border-radius: 30px;
  font-size: 18px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  transition: all 0.3s ease;
}
#contact-page .contact-wrapper .our-offices .filter .timezone-filter:hover {
  background: white;
  color: black;
  border: 1px solid white;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .filter .timezone-filter {
    font-size: 14px;
    padding: 8px 18px;
  }
}
#contact-page .contact-wrapper .our-offices .filter .reset-timezones {
  border: 1px solid rgba(19, 19, 19, 0.737);
  padding: 10px 40px;
  border-radius: 30px;
  font-size: 18px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  transition: all 0.3s ease;
}
#contact-page .contact-wrapper .our-offices .filter .reset-timezones:hover {
  background: white;
  color: black;
  border: 1px solid white;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .filter .reset-timezones {
    font-size: 14px;
    padding: 8px 35px;
  }
}
#contact-page .contact-wrapper .our-offices .filter .timezone-filter.active {
  background: white;
  color: black;
  border: 1px solid white;
}
#contact-page .contact-wrapper .our-offices .filter .reset-timezones {
  font-size: 18px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  align-self: center;
  transition: all 0.2s ease;
  background-color: white;
  color: black;
  border: white 1px solid;
}
#contact-page .contact-wrapper .our-offices .filter .reset-timezones:hover {
  color: gray;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .filter .reset-timezones {
    display: flex;
    flex: 1 1;
    justify-content: end;
  }
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item {
  display: none;
  padding: 80px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: black solid 1px;
  gap: 20px;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .adress-wrapper .address-item {
    flex-direction: column;
    align-items: flex-start;
    padding: 40px 0;
    gap: 20px;
  }
  #contact-page .contact-wrapper .our-offices .adress-wrapper .address-item:last-child {
    padding-bottom: 0;
  }
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .hover-image-container {
  transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);
  border-radius: 15px;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item:hover .hover-image-container {
  border-radius: 0;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item:hover .address-item {
  animation: upToDown 0.45s;
  transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item:hover img {
  transform: scale(1.1);
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .city {
  flex: 1.3 1;
  font-family: "Neue Haas Grotesk Display Pro Light";
  font-size: 80px;
  line-height: 0.8;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .city {
    font-size: 32px;
  }
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress {
  flex: 2 1;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  align-items: stretch;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress {
    width: 100%;
  }
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress h4 {
  display: none;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress h4 {
    font-size: 18px;
  }
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap .icon img {
  transform: translate(-30px, 30px); /* Move the arrow from bottom left */
  opacity: 0; /* Start with the arrow hidden */
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap .hover-image-container {
  transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);
  border-radius: 15px;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap:hover .hover-image-container {
  border-radius: 0;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap .rolling-copy-wrap {
  width: 100%;
  display: flex;
  align-items: flex-end;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap:hover .text {
  transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap:hover img {
  transform: translate(0, 0); /* Move to original position and reset rotation */
  opacity: 1;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap .icon {
  flex: 0.1 1;
  display: block;
  font-weight: 400;
  display: flex;
  justify-content: flex;
  padding-bottom: 8px;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap .icon img {
  width: 20px;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap .icon img {
    padding-bottom: 5px;
    width: 14px;
  }
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap .text {
  flex: 1.2 1;
  font-size: 30px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1.2;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap .text {
    font-size: 22px;
  }
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap {
    font-size: 16px;
  }
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item:last-child {
  border-bottom: none;
}
#contact-page .contact-wrapper .our-offices .filter-applied .address-item {
  border-bottom: 0;
}

#people {
  padding-top: 200px;
  padding-bottom: 150px;
}
@media (max-width: 767px) {
  #people {
    padding-top: 140px;
  }
}
#people .people-wrapper .people-head-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 767px) {
  #people .people-wrapper .people-head-wrap {
    flex-direction: column;
    align-items: flex-start;
  }
}
#people .people-wrapper .people-head-wrap p {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 23px;
  line-height: 1.4;
}
@media (max-width: 767px) {
  #people .people-wrapper .people-head-wrap p {
    font-size: 21px;
    line-height: 1.3;
  }
}
#people .people-wrapper .contact-heading {
  font-size: 180px;
  font-family: "Neue Haas Grotesk Display Pro Light";
  line-height: 100%;
  text-transform: lowercase;
}
@media (max-width: 767px) {
  #people .people-wrapper .contact-heading {
    font-size: 60px;
    line-height: 1.4;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #people .people-wrapper .contact-heading {
    font-size: 100px;
  }
}
@media only screen and (min-width: 1025px) {
  #people .people-wrapper .contact-heading {
    font-size: 140px;
  }
}
#people .people-wrapper .people-card-wrapper {
  padding-top: 50px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 100px;
  row-gap: 65px;
}
@media (max-width: 767px) {
  #people .people-wrapper .people-card-wrapper {
    grid-template-columns: repeat(1, 1fr);
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #people .people-wrapper .people-card-wrapper {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 35px;
    row-gap: 65px;
  }
}
#people .people-wrapper .img-wrap {
  flex: 1 1;
  overflow: hidden;
}
#people .people-wrapper .img-wrap img {
  transition: transform 0.3s ease-in-out; /* Smooth scaling transition */
  transform: scale(1); /* Start at normal size */
  will-change: transform; /* Optimize for smooth animations */
  transform-origin: center;
}
#people .people-wrapper .name {
  padding: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 28px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  line-height: 1.1;
  gap: 10px;
}
#people .people-wrapper .name .arrow-png {
  padding-bottom: 12px;
  transform: translate(-30px, 30px); /* Move the arrow from bottom left */
  opacity: 0; /* Start with the arrow hidden */
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
@media (max-width: 767px) {
  #people .people-wrapper .name .arrow-png {
    width: 20px;
    transform: translateY(0); /* Move to original position */
    opacity: 1;
    padding-bottom: 4px;
  }
}
#people .people-wrapper .name .arrow-png img {
  width: 50px;
}
@media (max-width: 767px) {
  #people .people-wrapper .name {
    font-size: 18px;
    padding: 10px;
  }
}
#people .people-wrapper .reverse {
  flex-direction: row-reverse; /* Apply reverse order */
}
@media (max-width: 767px) {
  #people .people-wrapper .reverse {
    flex-direction: row;
  }
}
@media (max-width: 767px) {
  #people .people-wrapper .reverse-mobile {
    flex-direction: row-reverse !important;
  }
}
@media (max-width: 767px) {
  #people .people-wrapper .normal-mobile {
    flex-direction: row !important;
  }
}
#people .people-wrapper .people-card {
  display: flex;
  background-color: rgba(255, 255, 255, 0.568627451);
}
#people .people-wrapper .people-card:hover {
  cursor: pointer;
}
#people .people-wrapper .people-card:hover .arrow-png {
  transform: translateY(0); /* Move to original position */
  opacity: 1; /* Fully visible */
}
#people .people-wrapper .people-card:hover .img-wrap {
  overflow: hidden;
}
#people .people-wrapper .people-card:hover .img-wrap img {
  transform: scale(1.03);
}
#people .people-wrapper .people-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
#people .people-wrapper .designation {
  padding: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 16px;
  line-height: 1.4;
}
@media (max-width: 767px) {
  #people .people-wrapper .designation {
    font-size: 12px;
    padding: 10px;
  }
}

.footer-home {
  padding: 100px 0;
}
@media (max-width: 767px) {
  .footer-home {
    padding: 40px 0;
  }
}
.footer-home .footer-wrapper {
  max-width: 1100px;
  display: flex;
  justify-content: space-between;
  gap: 2rem;
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 60px;
  }
}
.footer-home .footer-wrapper .internet-logo img {
  width: 120px;
}
.footer-home .footer-wrapper .footer-item img {
  width: 130px;
}
.footer-home .footer-wrapper .footer-item a {
  line-height: 1.2;
}
.footer-home .footer-wrapper .footer-item a:hover {
  color: #516beb;
}
.footer-home .footer-wrapper .footer-item h4 {
  line-height: 1.2;
}
.footer-home .footer-wrapper .footer-item .head {
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  font-size: 15px;
  max-width: -moz-fit-content;
  max-width: fit-content;
  text-transform: capitalize;
  margin-bottom: 0.5rem;
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item .head {
    font-size: 13px;
    margin-bottom: 0.3rem;
  }
}
.footer-home .footer-wrapper .footer-item .head-b {
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  font-size: 16px;
  max-width: -moz-fit-content;
  max-width: fit-content;
  text-transform: capitalize;
  margin-bottom: 0.5rem;
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item .head-b {
    font-size: 13px;
    margin-bottom: 0.3rem;
  }
}
.footer-home .footer-wrapper .footer-item .email {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  margin-bottom: 1rem;
  font-size: 16px;
  display: block;
  transition: all 0.2s ease;
  cursor: pointer;
}
.footer-home .footer-wrapper .footer-item .email:hover {
  color: #516beb;
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item .email {
    font-size: 13px;
  }
}
.footer-home .footer-wrapper .footer-item .city {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 16px;
  display: block;
  line-height: 1.6;
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item .city {
    font-size: 13px;
  }
}
.footer-home .footer-wrapper .footer-item .link {
  font-size: 16px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  margin-bottom: 0.3rem;
  transition: all 0.2s ease;
  cursor: pointer;
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item .link {
    font-size: 13px;
  }
}
.footer-home .footer-wrapper .footer-item .link:hover {
  color: #516beb;
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item .link:hover {
    color: unset;
  }
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item.order-2 {
    order: 1;
  }
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item.order-3 {
    order: 0;
  }
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item.order-0 {
    order: 0;
  }
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item.order-1 {
    order: 2;
  }
}
.cursor-circle {
  position: fixed;
  content: "drag";
  width: 50px;
  height: 50px;
  border-radius: 50%;
  top: 0;
  left: 0;
  background-color: rgb(185, 181, 181);
  z-index: 1000;
  cursor: none;
  will-change: transform;
}
.cursor-circle::after {
  content: "drag";
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 15px;
  text-transform: capitalize;
  left: 50%;
  top: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.work-page {
  padding-top: 200px;
  padding-bottom: 80px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
@media (max-width: 767px) {
  .work-page {
    padding-top: 140px;
  }
}
.work-page .work-wrapper .work-banner {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
  gap: 110px;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .work-page .work-wrapper .work-banner {
    flex-direction: column;
    align-items: flex-start;
    padding: 0px 0;
    gap: 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .work-page .work-wrapper .work-banner {
    align-items: flex-start;
    flex-direction: column;
  }
}
.work-page .work-wrapper .work-banner h2 {
  font-family: "Neue Haas Grotesk Display Pro Light";
  text-transform: lowercase;
  font-size: 180px;
  line-height: 0.85;
}
@media (max-width: 767px) {
  .work-page .work-wrapper .work-banner h2 {
    font-size: 60px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .work-page .work-wrapper .work-banner h2 {
    font-size: 100px;
  }
}
@media only screen and (min-width: 1025px) {
  .work-page .work-wrapper .work-banner h2 {
    font-size: 140px;
  }
}
.work-page .work-wrapper .work-banner p {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 23px;
  line-height: 1.4;
}
@media (max-width: 767px) {
  .work-page .work-wrapper .work-banner p {
    font-size: 16px;
  }
}
.work-page .work-ct .total-slide {
  color: black;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  position: absolute;
  right: 0;
  top: -65px;
  font-size: 20px;
}
@media (max-width: 767px) {
  .work-page .work-ct .total-slide {
    font-size: 15px;
    top: -50px;
  }
}
.work-page .select-ct {
  display: flex;
  align-items: center;
  gap: 20px;
}
.work-page .select-ct .btn-filter {
  border-radius: 50px;
  border: 1px solid black;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  padding: 7px 20px;
  cursor: pointer;
  font-size: 18px;
  color: black;
}
.work-page .select-ct .btn-filter:hover {
  border: white;
  background-color: white;
  color: black;
  border: 1px solid white;
}
.work-page .select-ct .btn-filter.active {
  background-color: white;
  color: black;
  border: 1px solid white;
}
@media (max-width: 767px) {
  .work-page .select-ct {
    gap: 10px;
    margin-bottom: 20px;
  }
}
.work-page .select-ct .label-select {
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
@media (max-width: 767px) {
  .work-page .select-ct .label-select {
    font-size: 13px;
  }
}
.work-page .select-ct .select-wrapper {
  display: flex;
  gap: 20px;
}
@media (max-width: 767px) {
  .work-page .select-ct .select-wrapper {
    gap: 5px;
  }
}
.work-page .select-ct .select-wrapper li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
@media (max-width: 767px) {
  .work-page .select-ct .select-wrapper li {
    padding: 5px 0px;
  }
}
.work-page .select-ct .select-wrapper li .custom-select {
  min-width: 180px;
  max-width: 200px;
  border: none;
  outline: none;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 16px;
}
.work-page .select-ct .select-wrapper li .custom-select .css-13cymwt-control {
  background-color: transparent;
  border: 1px solid black;
  border-radius: 50px;
  cursor: pointer;
}
.work-page .select-ct .select-wrapper li .custom-select .css-t3ipsp-control {
  background-color: transparent !important;
  border-color: black !important;
  border-radius: 50px;
  box-shadow: none;
}
.work-page .select-ct .select-wrapper li .custom-select .css-b62m3t-container {
  background-color: transparent;
}
.work-page .select-ct .select-wrapper li .custom-select .css-tipsp-control {
  background-color: transparent;
}
.work-page .select-ct .select-wrapper li .custom-select .css-1xc3v61-indicatorContainer {
  color: black;
  background-color: transparent;
}
.work-page .select-ct .select-wrapper li .custom-select .css-1y632ze-singleValue {
  padding-left: 5px;
}
@media (max-width: 767px) {
  .work-page .select-ct .select-wrapper li .custom-select {
    font-size: 13px;
    min-width: 90px;
    max-width: 200px;
  }
}
.work-page .select-ct .select-wrapper li span {
  position: absolute;
  right: 10px;
}
@media (max-width: 767px) {
  .work-page .select-ct .select-wrapper li span {
    font-size: 10px;
  }
}
.work-page .work-card {
  margin-top: 40px;
  margin-bottom: 40px;
  position: relative;
  min-height: 340px;
}
@media (max-width: 767px) {
  .work-page .work-card {
    margin-top: 20px;
    margin-bottom: 40px;
  }
}
.work-page .work-card .card-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 120px;
  row-gap: 60px;
}
@media (max-width: 1200px) {
  .work-page .work-card .card-wrapper.card-wrapper {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 900px) {
  .work-page .work-card .card-wrapper.card-wrapper {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 600px) {
  .work-page .work-card .card-wrapper.card-wrapper {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 767px) {
  .work-page .work-card .card-wrapper {
    gap: 40px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .work-page .work-card .card-wrapper {
    justify-content: space-between;
  }
}
.work-page .Slider-heading {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 26px;
  margin-top: 100px;
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .work-page .Slider-heading {
    margin-top: 50px;
    font-size: 20px;
  }
}
.work-page .slider-wrapper .work-card-wrapper {
  display: flex;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper .work-card-wrapper {
    gap: 10px;
  }
}
.work-page .slider-wrapper .work-card-wrapper .name {
  padding-left: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 18px;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper .work-card-wrapper .name {
    font-size: 14px;
    padding-left: 10px;
  }
}
.work-page .slider-wrapper .card-item .copy-wrap {
  padding: 0 20px;
  padding-bottom: 20px;
  flex: 1 1;
  display: flex;
  height: 130px;
  align-items: flex-end;
  justify-content: space-between;
}
.work-page .slider-wrapper .card-item .copy-wrap .img-wrapper {
  transform: translate(-30px, 30px); /* Move the arrow from bottom left */
  opacity: 0; /* Start with the arrow hidden */
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper .card-item .copy-wrap .img-wrapper {
    display: block;
  }
}
.work-page .slider-wrapper .card-item .copy-wrap .img-wrapper img {
  width: 50px;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper .card-item .copy-wrap .img-wrapper img {
    width: 30px;
  }
}
.work-page .slider-wrapper .card-item .copy-wrap .img-wrapper-1 {
  padding-bottom: 7px;
}
.work-page .slider-wrapper .card-item .copy-wrap .img-wrapper-1 img {
  width: 50px;
}
.work-page .slider-wrapper .card-item .copy-wrap .rolling-copy-wrap {
  padding-top: 0;
  width: 400px;
  display: flex;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper .card-item .copy-wrap {
    height: 70px;
    padding: 0 10px;
    padding-bottom: 10px;
  }
}
.work-page .slider-wrapper .card-item .hover-image-container {
  flex: 2.3 1;
  transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);
  display: flex;
  justify-content: flex-end;
  aspect-ratio: unset;
}
.work-page .slider-wrapper .card-item .hover-image-container .hover-img {
  transition: all 0.2s ease-in-out;
}
.work-page .slider-wrapper .card-item:hover .hover-image-container {
  border-radius: 0;
}
.work-page .slider-wrapper .card-item:hover .hover-img {
  transform: scale(1.02);
}
.work-page .slider-wrapper .card-item:hover {
  transition: all ease 0.2s;
}
.work-page .slider-wrapper .card-item:hover .img-wrapper {
  transform: translate(0, 0); /* Move to original position and reset rotation */
  opacity: 1;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper {
    flex: auto;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .work-page .slider-wrapper {
    flex: 0 0 340px;
  }
}
.work-page .slider-wrapper .name-wrap {
  margin-top: 20px;
}
.work-page .slider-wrapper .category {
  margin-top: 20px;
}
.work-page .slider-wrapper .name {
  flex: 1 1;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 34px;
  line-height: 1.2;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper .name {
    font-size: 22px;
    margin-top: 10px;
  }
}
.work-page .slider-wrapper .discr {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 40px;
  line-height: 1.2;
  word-wrap: break-word;
  white-space: normal;
}
.work-page .slider-wrapper button {
  border: none; /* Remove borders */
  border-radius: 5px; /* Rounded corners */
  cursor: pointer; /* Change cursor to pointer */
}
.work-page .slider-wrapper button.left-arrow {
  width: 55px;
  transform: rotate(180deg);
  position: absolute;
  top: -62px;
  right: 60px;
  padding: 10px;
  padding-right: 0;
  width: 40px;
  position: absolute;
  top: -45px;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper button.left-arrow {
    width: 25px;
    right: 50px;
    top: -30px;
    padding: 5px;
  }
}
.work-page .slider-wrapper button.right-arrow {
  width: 55px;
  position: absolute;
  top: -62px;
  right: 10px;
  padding: 10px;
  padding-right: 0;
  width: 40px;
  position: absolute;
  top: -45px;
  right: 0;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper button.right-arrow {
    width: 25px;
    top: -30px;
    padding: 5px;
  }
}
.work-page .show-more-btn {
  border-bottom: 1px solid black;
}
.work-page .empty-filter-result {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 20px;
}

.user-card .card-wrapper {
  display: flex;
}

.wrapper-player .player {
  padding: 5rem 0;
  padding-top: 140px;
  width: 90%;
}
@media only screen and (min-width: 1025px) {
  .wrapper-player .player {
    min-height: 100vh;
  }
}
@media (max-width: 767px) {
  .wrapper-player .player {
    padding-right: 15px;
    padding-left: 15px;
    padding-bottom: 40px;
    width: 100%;
  }
}
.wrapper-player .player .player-copy-wrapper {
  gap: 30px;
}
.wrapper-player .player .player-copy-wrapper .player-gif {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_62___}), auto;
  width: 100%;
  height: auto;
}
@media (max-width: 767px) {
  .wrapper-player .player .player-copy-wrapper {
    flex-direction: column;
    gap: 10px;
  }
}
.wrapper-player .player .player-copy-wrapper .page-copy {
  flex: 1.2 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .wrapper-player .player .player-copy-wrapper .page-copy {
    gap: 10px;
  }
}
.wrapper-player .player .player-copy-wrapper .page-copy .top-left-copy {
  font-size: 55px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1.2;
}
@media (max-width: 767px) {
  .wrapper-player .player .player-copy-wrapper .page-copy .top-left-copy {
    font-size: 28px;
  }
}
.wrapper-player .player .player-copy-wrapper .page-copy .top-bottom-copy {
  font-size: 22px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1;
}
@media (max-width: 767px) {
  .wrapper-player .player .player-copy-wrapper .page-copy .top-bottom-copy {
    font-size: 16px;
  }
}
.wrapper-player .player .player-container {
  flex: 2 1;
  margin: 0 auto;
}
@media (max-width: 767px) {
  .wrapper-player .player .player-container {
    margin: unset;
  }
}
.wrapper-player .player .player-head {
  font-size: 46px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
@media (max-width: 767px) {
  .wrapper-player .player .player-head {
    font-size: 30px;
  }
}
.wrapper-player .player .nav-work-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.wrapper-player .player .nav-work-wrapper a {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  text-decoration: underline;
}
.wrapper-player .player .player-para {
  font-size: 24px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
.wrapper-player .player .player-wrapper-small {
  position: relative;
  padding-top: 56.25%;
  background: #000;
  overflow: hidden;
}
.wrapper-player .player .player-wrapper-small .spinner span {
  border: 3px solid white;
  border-right-color: rgba(119, 119, 119, 0.702);
}
.wrapper-player .player .player-wrapper-small .react-player {
  position: absolute;
  top: 0;
  left: 0;
}
.wrapper-player .player .copy-thumbnail {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 22px;
  margin-top: 20px;
}
@media (max-width: 767px) {
  .wrapper-player .player .copy-thumbnail {
    font-size: 16px;
  }
}
.wrapper-player .player .video-thumbnails {
  margin-top: 20px;
  gap: 20px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
}
@media (max-width: 767px) {
  .wrapper-player .player .video-thumbnails {
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
  }
}
.wrapper-player .player .video-thumbnails .thumbnail-item {
  overflow: hidden;
  max-width: 140px;
  border: 1px solid transparent;
  transition: all 0.3s ease;
  position: relative;
}
.wrapper-player .player .video-thumbnails .thumbnail-item:hover {
  border: 1px solid white;
}
.wrapper-player .player .video-thumbnails .thumbnail-item .vimeo-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.3 ease;
  color: rgba(255, 255, 255, 0.7607843137);
  font-size: 24px;
}
.wrapper-player .player .video-thumbnails .thumbnail-item:hover .vimeo-play-icon {
  color: white;
}
@media (max-width: 767px) {
  .wrapper-player .player .video-thumbnails .thumbnail-item {
    flex: 0 0 24%;
  }
}
.wrapper-player .video-details {
  background-color: white;
  padding: 64px 0;
}
@media (max-width: 767px) {
  .wrapper-player .video-details {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
.wrapper-player .video-details .video-detail-wrapper {
  max-width: 1110px;
  display: flex;
  gap: 130px;
  flex-direction: row-reverse;
}
@media (max-width: 767px) {
  .wrapper-player .video-details .video-detail-wrapper {
    gap: 50px;
    flex-direction: column-reverse;
  }
}
.wrapper-player .video-details .video-detail-wrapper .detail-item {
  display: flex;
  flex-direction: column;
  flex: 1.2 1;
  gap: 2rem;
}
.wrapper-player .video-details .video-detail-wrapper .detail-item .client {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  width: max-content;
  line-height: 1;
  margin-bottom: 5px;
  font-size: 30px;
}
@media (max-width: 767px) {
  .wrapper-player .video-details .video-detail-wrapper .detail-item .client {
    font-size: 28px;
  }
}
.wrapper-player .video-details .video-detail-wrapper .detail-item .work-title {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  color: black;
  font-size: 17px;
  margin-top: 12px;
}
@media (max-width: 767px) {
  .wrapper-player .video-details .video-detail-wrapper .detail-item .work-title {
    font-size: 16px;
    margin-top: 7px;
  }
}
.wrapper-player .video-details .video-detail-wrapper .detail-item-2 {
  flex: 2 1;
}
.wrapper-player .shoot-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 64px 0;
  padding-bottom: 6rem;
}
@media (max-width: 767px) {
  .wrapper-player .shoot-image {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
.wrapper-player .shoot-image .head-copy {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 60px;
  margin-bottom: 32px;
  line-height: 1;
  text-align: center;
}
@media (max-width: 767px) {
  .wrapper-player .shoot-image .head-copy {
    font-size: 40px;
    margin-bottom: 20px;
  }
}
.wrapper-player .shoot-image .image-wrapper {
  position: relative;
}
.wrapper-player .shoot-image .image-wrapper .slick-slide {
  padding: 0 20px;
}
.wrapper-player .shoot-image .image-wrapper .img-flex-item {
  flex: 1 0 48%;
  overflow: hidden;
}
.wrapper-player .shoot-image .image-wrapper .img-flex-item img {
  width: 100%;
}
.wrapper-player .all-details {
  background-color: white;
  padding: 4rem 0;
  padding-top: 32px;
}
@media (max-width: 767px) {
  .wrapper-player .all-details {
    padding-top: 20px;
    padding-bottom: 20px;
  }
}
.wrapper-player .all-details .all-details-wrapper {
  max-width: 1110px;
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper {
  padding: 40px 0;
  display: flex;
  align-items: flex-start;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper {
    flex-direction: column;
    padding: 20px 0;
    row-gap: 10px;
    align-items: flex-start;
  }
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper:last-child {
  border-bottom: none;
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .title {
  flex: 1.5 0;
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .title h4 {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 34px;
  width: -moz-fit-content;
  width: fit-content;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .title h4 {
    font-size: 28px;
  }
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy {
  flex: 2 1;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item {
  flex: 1 1 28%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item {
    gap: 0px;
    width: 100%;
  }
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-head {
  font-size: 48px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  margin-bottom: 5px;
  line-height: 1.2;
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-head img {
  width: 100px;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-head {
    font-size: 38px;
    margin-bottom: 0;
    line-height: 1.2;
  }
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-head img {
    width: 80px;
  }
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-para {
  font-size: 14px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  color: black;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-para {
    text-align: start;
  }
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-meta {
  display: flex;
  align-items: center;
  column-gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-start;
  color: #808080;
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-meta p {
  font-size: 14px;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-meta {
    justify-content: center;
  }
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.copy-text {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1.4;
  font-size: 20px;
  color: black;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.copy-text {
    font-size: 16px;
    margin-top: 0px;
  }
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.award-mobile {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  justify-items: flex-start;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.award-mobile {
    width: 100%;
    margin-top: 20px;
    align-items: center;
    gap: 20px;
  }
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.award-mobile .copy-item {
    gap: 10px;
  }
}
@media (max-width: 1200px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.award-mobile {
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }
}
@media (max-width: 900px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.award-mobile {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 600px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.award-mobile {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    row-gap: 30px;
    width: 100%;
    align-items: flex-start;
  }
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.result-mobile {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-items: start;
  gap: 30px;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.result-mobile {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin-top: 20px;
    align-self: center;
    gap: 20px;
  }
}
@media (max-width: 1200px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.result-mobile.result-mobile {
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }
}
@media (max-width: 900px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.result-mobile.result-mobile {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 600px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.result-mobile.result-mobile {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    row-gap: 30px;
    width: 100%;
  }
}
.wrapper-player .related-work {
  padding: 64px 0;
}
@media (max-width: 767px) {
  .wrapper-player .related-work {
    padding: 40px 0;
  }
}
.wrapper-player .related-work .related-work-wrapper .head-copy {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 60px;
  margin-bottom: 2rem;
  text-align: center;
}
@media (max-width: 767px) {
  .wrapper-player .related-work .related-work-wrapper .head-copy {
    font-size: 40px;
  }
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}
@media (max-width: 767px) {
  .wrapper-player .related-work .related-work-wrapper .wrapper-flex {
    grid-template-columns: repeat(1, 1fr);
    gap: 40px;
  }
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item {
  flex: 1 0 48%;
  display: flex;
  flex-direction: column;
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .hover-image-container {
  transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item:hover .hover-image-container {
  border-radius: 0;
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item:hover .discr, .wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item:hover .arrow-wrapper > img {
  transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item:hover img {
  transform: scale(1.1);
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .main-image {
  margin-bottom: 10px;
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .img-title .name {
  margin-top: 0px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 16px;
}
@media (max-width: 767px) {
  .wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .img-title .name {
    font-size: 14px;
  }
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .img-title h4 {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 20px;
  line-height: 1.2;
  margin-bottom: 5px;
}
@media (max-width: 767px) {
  .wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .img-title h4 {
    font-size: 22px;
    margin-bottom: 0px;
  }
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .img-title .view-more {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 13px;
  border-bottom: 1px solid black;
  max-width: -moz-fit-content;
  max-width: fit-content;
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .rolling-copy-wrap .arrow-png {
  width: 20px;
  transform: translate(-10px, 10px); /* Move the arrow from bottom left */
  opacity: 0; /* Start with the arrow hidden */
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
@media (max-width: 767px) {
  .wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .rolling-copy-wrap .arrow-png-1 {
    width: 20px;
    padding-bottom: 5px;
  }
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item:hover .arrow-png {
  transform: translate(0, 0); /* Move to original position and reset rotation */
  opacity: 1;
}

.spinner {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.spinner span {
  display: block;
  width: 30px;
  height: 30px;
  border: 3px solid transparent;
  border-radius: 50%;
  border-right-color: rgba(0, 0, 0, 0.7019607843);
  animation: spinner-anim 0.8s linear infinite;
}
.spinner.spinner-int {
  top: 85%;
}
.spinner.spinner-news {
  top: 85%;
}

@keyframes spinner-anim {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.reset-btn {
  font-family: "Neue Haas Grotesk Display Pro Bold";
  text-decoration: underline;
}

.scroll-down-svg {
  left: 50%;
  transform: translateY(0%) rotate(45deg);
  opacity: 1;
}

.scroll-down-svg1 {
  width: 2em;
  height: 2em;
  background-color: transparent;
  z-index: 80;
  bottom: 40px;
  position: absolute;
  border-width: 0 0.25em 0.25em 0;
  border-style: solid;
  border-color: rgb(0, 0, 0);
  animation: scrolldown 1.2s ease-in-out infinite;
}

.scroll-down-svg2 {
  width: 2em;
  height: 2em;
  background-color: transparent;
  z-index: 80;
  bottom: 60px;
  position: absolute;
  border-width: 0 0.16em 0.16em 0;
  border-style: solid;
  border-color: white;
}
@media (max-width: 767px) {
  .scroll-down-svg2 {
    bottom: 20px;
    width: 1em;
    height: 1em;
    border-width: 0 0.14em 0.14em 0;
  }
}

@keyframes scrolldown {
  0% {
    transform: translateY(20%) rotate(45deg);
    opacity: 0.7;
  }
  50% {
    transform: translateY(0%) rotate(45deg);
    opacity: 0.1;
  }
  100% {
    transform: translateY(20%) rotate(45deg);
    opacity: 0.7;
  }
}
.hover-image-container {
  position: relative;
  margin-bottom: 10px;
  aspect-ratio: 16/9;
  overflow: hidden;
}
.hover-image-container::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #e5e5e5;
  opacity: 0;
  transition: 0.4s ease all;
}
.hover-image-container .main-image {
  transition: 0.4s ease all;
  width: 100%;
  object-fit: cover;
}

.rolling-copy-wrap {
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .rolling-copy-wrap {
    padding-top: 5px;
    padding-top: 5px;
    align-items: flex-end;
    padding-right: 5px;
  }
}

@keyframes upToDown {
  49% {
    transform: translateY(-100%);
  }
  50% {
    opacity: 0;
    transform: translateY(100%);
  }
  51% {
    opacity: 1;
  }
}
.divider {
  border-bottom: 1px solid;
}

#news {
  padding-top: 200px;
  padding-bottom: 60px;
}
@media (max-width: 767px) {
  #news {
    padding-top: 140px;
    padding-bottom: 40px;
  }
}
#news .news-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#news .news-header h2 {
  font-size: 140px;
  font-family: "Neue Haas Grotesk Display Pro Light";
  text-transform: lowercase;
  line-height: 100%;
  margin-bottom: 50px;
}
@media (max-width: 767px) {
  #news .news-header h2 {
    font-size: 60px;
    margin-bottom: 5px;
  }
}
#news .news-header .filter-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 9px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
@media (max-width: 767px) {
  #news .news-header .filter-wrapper {
    margin-bottom: 0px;
  }
}
#news .news-list {
  min-height: 340px;
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
  row-gap: 60px;
}
#news .news-list .news-item {
  display: flex;
  align-items: flex-start;
  gap: 35px;
  border-bottom: 1px solid black;
  padding-bottom: 60px;
}
@media (max-width: 767px) {
  #news .news-list .news-item {
    flex-direction: column !important;
    gap: 20px !important;
  }
}
#news .news-list .news-item:last-child {
  border-bottom: none;
}
#news .news-list .news-item .tumbnail-img {
  flex: 1 1;
}
@media (max-width: 767px) {
  #news .news-list .news-item .tumbnail-img {
    flex: unset;
  }
}
#news .news-list .news-item .copy-wrap {
  flex: 2.7 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  height: 100%;
}
#news .news-list .news-item .copy-wrap .rolling-copy-wrap {
  display: block !important;
}
@media (max-width: 767px) {
  #news .news-list .news-item .copy-wrap {
    gap: 5px;
  }
}
#news .news-list .news-item .top-wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 5px;
}
@media (max-width: 767px) {
  #news .news-list .news-item .top-wrap {
    gap: 5px;
  }
}
#news .news-list .news-item .arrow-wrapper-test {
  flex: 0.07 1;
  align-self: center;
  margin-left: 10px;
}
@media (max-width: 767px) {
  #news .news-list .news-item .arrow-wrapper-test {
    margin-left: 5px;
  }
}
#news .news-list .news-item .arrow-wrapper-test img {
  transform: translate(-20px, 20px); /* Move the arrow from bottom left */
  opacity: 0; /* Start with the arrow hidden */
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  display: inline-block;
  width: 18px;
}
@media (max-width: 767px) {
  #news .news-list .news-item .arrow-wrapper-test img {
    width: 12px;
  }
}
#news .news-list .news-item .hover-image-container {
  margin-bottom: 0;
}
#news .news-list .news-item .hover-image-container img {
  transition: transform 0.3s ease-in-out; /* Smooth scaling transition */
  transform: scale(1); /* Start at normal size */
  will-change: transform; /* Optimize for smooth animations */
  transform-origin: center;
}
#news .news-list .news-item .hover-image-container:hover img {
  transform: scale(1.03);
}
#news .news-list .news-item:has(.rolling-copy-wrap:hover) .hover-image-container img {
  transform: scale(1.03);
}
#news .news-list .news-item .rolling-copy-wrap:hover .arrow-wrapper-test > img {
  transform: translate(0, 0); /* Move to original position and reset rotation */
  opacity: 1;
}
#news .news-list .news-item:has(.hover-image-container:hover) .arrow-wrapper-test > img {
  transform: translate(0, 0);
  opacity: 1;
}
#news .news-list .news-item .news-title {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 28px;
  line-height: 1.4;
}
@media (max-width: 767px) {
  #news .news-list .news-item .news-title {
    font-size: 18px;
  }
}
#news .news-list .news-item .date {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 14px;
}
@media (max-width: 767px) {
  #news .news-list .news-item .date {
    font-size: 12px;
  }
}
#news .news-list .news-item .title {
  font-size: 16px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  border: 1px black solid;
  padding: 5px 18px;
  border-radius: 50px;
  width: max-content;
  color: black;
  margin-bottom: 10px;
}
@media (max-width: 767px) {
  #news .news-list .news-item .title {
    margin-bottom: 0px;
    font-size: 12px;
    padding: 3px 15px;
  }
}
@media (max-width: 767px) {
  #news .news-list .news-item {
    flex-direction: row;
    gap: 10px;
    padding-bottom: 30px;
    border-bottom: 0.7px solid;
  }
}
@media (max-width: 767px) {
  #news .news-list {
    margin-top: 15px;
    row-gap: 25px;
  }
}
/* LIGHTBOX  */
.yarl__button.yarl__navigation_next,
.yarl__button.yarl__navigation_prev {
  display: none;
}

.yarl__portal_open {
  z-index: 100000;
}

.show-more-button {
  border: 1px solid rgba(19, 19, 19, 0.737);
  border: none;
  padding: 4px 12px;
  font-size: 16px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  transition: all 0.3s ease;
  padding: 0;
  border-bottom: 1px solid;
  cursor: pointer;
}
.show-more-button:hover {
  color: white;
}

.show-more-wrap {
  position: relative;
  display: flex;
  margin-top: 60px;
  justify-content: center;
}
@media (max-width: 767px) {
  .show-more-wrap {
    margin-top: 25px;
  }
}

.react-player {
  width: 100% !important;
  height: 100% !important;
}
.react-player .Button_module_button__a2d215de {
  display: none;
}

.react-player iframe {
  width: 100%;
  height: 100%;
}

.back-link {
  transition: all 0.2s ease;
}
.back-link:hover {
  color: white;
}

/* SCATTER ANIMATION */
.scatter-section {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 770px;
  position: relative;
  overflow: unset;
}
@media (max-width: 767px) {
  .scatter-section {
    overflow: hidden;
    padding-top: 0px;
    padding-bottom: 0px;
    height: 650px;
  }
}
.scatter-section .image-container {
  position: absolute;
  border-radius: 10px;
  cursor: pointer;
  flex-direction: column;
}
.scatter-section .image-container .image {
  width: 100%;
}
.scatter-section .image-container .text-overlay {
  margin-top: 10px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 15px;
}
@media (max-width: 767px) {
  .scatter-section .image-container .text-overlay {
    bottom: 5px;
    left: 3px;
    font-size: 10px;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    margin-top: 7px;
  }
}
.scatter-section .center-text {
  font-size: 100px;
  font-family: "Neue Haas Grotesk Display Pro Light";
  line-height: 100%;
  color: white;
  text-align: center;
  z-index: 1;
}
@media (max-width: 767px) {
  .scatter-section .center-text {
    font-size: 34px;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    font-size: 40px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .scatter-section .center-text {
    font-size: 60px;
  }
}

.skeleton-wrap span {
  border-radius: 0;
}

.add-accounts-page-css .container-ad {
  max-width: 1200px;
  margin: 0 auto;
  width: 90%;
}
@media (max-width: 767px) {
  .add-accounts-page-css .container-ad {
    max-width: 320px;
  }
}
.add-accounts-page-css header {
  padding: 52px 0;
}
@media (max-width: 767px) {
  .add-accounts-page-css header {
    padding: 20px 0;
  }
}
@media (max-width: 767px) {
  .add-accounts-page-css header .logo {
    width: 120px;
  }
}
.add-accounts-page-css header nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.add-accounts-page-css header .nav-list {
  display: flex;
  align-items: center;
}
.add-accounts-page-css header .nav-list .nav-item {
  font-size: 14px;
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  margin-right: 31px;
  letter-spacing: 0%;
  color: #6e5e7e;
}
@media (max-width: 767px) {
  .add-accounts-page-css header .nav-list .nav-item {
    margin-right: 0;
  }
}
.add-accounts-page-css header a {
  display: block;
}
.add-accounts-page-css header .login-btn,
.add-accounts-page-css header .getin-btn {
  font-family: "Manrope Regular";
  font-size: 15px;
  line-height: 20px;
  padding: 12px 25px;
  border-radius: 40px;
  letter-spacing: -0.23px;
}
.add-accounts-page-css header .login-btn {
  border: 1px solid black;
  margin-right: 10px;
  margin-left: 97px;
}
@media (max-width: 767px) {
  .add-accounts-page-css header .login-btn {
    margin-left: 0;
    margin-right: 0;
  }
}
.add-accounts-page-css header .getin-btn {
  background: rgb(143, 55, 200);
  background: linear-gradient(0deg, rgb(143, 55, 200) 0%, rgb(159, 63, 181) 8%, rgb(210, 89, 125) 22%, rgb(242, 105, 91) 39%, rgb(255, 112, 78) 51%, rgb(255, 101, 104) 65%, rgb(255, 94, 125) 79%, rgb(255, 143, 107) 98%);
  color: white;
}
.add-accounts-page-css header .hamburger-1 {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 34px;
  height: 18px;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1000;
}
.add-accounts-page-css header .hamburger-1 .bar {
  width: 100%;
  height: 2px;
  background-color: #5c3688;
  transition: all 0.3s ease;
}
.add-accounts-page-css header .hamburger-1.active .bar:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}
.add-accounts-page-css header .hamburger-1.active .bar:nth-child(2) {
  opacity: 0;
}
.add-accounts-page-css header .hamburger-1.active .bar:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}
@media screen and (max-width: 768px) {
  .add-accounts-page-css header .nav-list {
    position: fixed;
    top: -100%;
    right: 0;
    width: 100%;
    background-color: white;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: top 0.4s ease;
  }
  .add-accounts-page-css header .nav-list.active {
    padding-top: 100px;
    top: 0;
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: white;
    gap: 20px;
    z-index: 5;
  }
  .add-accounts-page-css header .hamburger-1 {
    display: flex;
  }
}
.add-accounts-page-css .no-scroll {
  overflow: hidden;
  height: 100%;
  position: fixed;
  width: 100%;
}
.add-accounts-page-css .scroll-top-btn {
  background-color: red;
  background: linear-gradient(0deg, rgb(143, 55, 200) 0%, rgb(159, 63, 181) 8%, rgb(210, 89, 125) 22%, rgb(242, 105, 91) 39%, rgb(255, 112, 78) 51%, rgb(255, 101, 104) 65%, rgb(255, 94, 125) 79%, rgb(255, 143, 107) 98%);
  font-size: 25px;
  color: white;
  width: 50px;
  height: 50px;
  border-radius: 50px;
}
.add-accounts-page-css main #home .hero-copy {
  margin-top: 12px;
  font-family: "Manrope Semibold";
  font-size: 57px;
  line-height: 70px;
  color: #5c3688;
  margin-bottom: 40px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .hero-copy {
    text-align: center;
    font-size: 32px;
    line-height: 1.2;
    margin-top: 40px;
    margin-bottom: 50px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .add-accounts-page-css main #home .hero-copy {
    font-size: 50px;
    text-align: center;
    line-height: 70px;
  }
}
.add-accounts-page-css main #home .services {
  display: grid;
  grid-template-columns: repeat(2, 2fr);
  gap: 35px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .services {
    display: grid;
    grid-template-columns: repeat(2, 2fr);
    gap: 35px;
  }
}
.add-accounts-page-css main #home .wrapper {
  display: flex;
  gap: 20px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper {
    align-items: center;
    flex-direction: column;
  }
}
.add-accounts-page-css main #home .orange-ring {
  width: 60px;
  height: 60px;
  border: 2px solid #f17380;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-accounts-page-css main #home .orange-ring p {
  font-family: "Manrope Regular";
  color: #6e5e7e;
  font-size: 30px;
}
.add-accounts-page-css main #home .copy {
  color: #6e5e7e;
  font-family: "Manrope Regular";
  line-height: 28px;
  font-size: 28px;
  font-weight: 600;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .copy {
    line-height: 1.2;
    font-size: 20px;
    text-align: center;
  }
}
.add-accounts-page-css main #home .homepage-btn {
  margin-top: 52px;
  display: flex;
  justify-content: center;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .homepage-btn {
    margin-top: 40px;
  }
}
.add-accounts-page-css main #home .login-btn {
  font-family: "Manrope Regular";
  font-size: 15px;
  line-height: 20px;
  padding: 22px 44px;
  border: 1px solid black;
  border-radius: 40px;
  margin-right: 20px;
  letter-spacing: -0.23px;
}
.add-accounts-page-css main #home .getin-btn {
  font-family: "Manrope Regular";
  font-size: 15px;
  line-height: 20px;
  padding: 22px 83px;
  border-radius: 40px;
  background: rgb(143, 55, 200);
  background: linear-gradient(0deg, rgb(143, 55, 200) 0%, rgb(159, 63, 181) 8%, rgb(210, 89, 125) 22%, rgb(242, 105, 91) 39%, rgb(255, 112, 78) 51%, rgb(255, 101, 104) 65%, rgb(255, 94, 125) 79%, rgb(255, 143, 107) 98%);
  color: white;
  letter-spacing: -0.23px;
}
.add-accounts-page-css main #home .wrapper-form-banner {
  display: flex;
  gap: 0px;
  align-items: start;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner {
    flex-direction: column;
    align-items: stretch;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .wrapper-form-form {
  flex: 1 1;
  padding: 15px 40px;
  margin-top: 10px;
  background: linear-gradient(0deg, rgb(143, 55, 200) 0%, rgb(159, 63, 181) 8%, rgb(210, 89, 125) 22%, rgb(242, 105, 91) 39%, rgb(255, 112, 78) 51%, rgb(255, 101, 104) 65%, rgb(255, 94, 125) 79%, rgb(255, 143, 107) 98%);
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .wrapper-form-form {
    padding: 20px;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .wrapper-form-copy {
  flex: 1.6 1;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch {
  margin-bottom: 0;
  padding-bottom: 0px;
  display: flex;
  flex-direction: column;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch div {
  border-radius: 8px;
  width: 100%;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .input-wrapper {
  margin-top: 7px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .input-wrapper {
    gap: 5px;
  }
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .input-wrapper label {
    text-align: center;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .wrapper-radio-btn {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0;
  gap: 0px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .wrapper-radio-btn {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .error-form {
  font-family: "Manrope Semibold";
  font-size: 13px;
  padding-top: 5px;
  text-align: left;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .error-wrapper {
  padding: 0;
  margin-top: 10px;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .radio-btn-section {
  justify-content: center;
  padding: 0;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch h2 {
  text-align: center;
  font-family: "Manrope Semibold";
  color: white;
  font-size: 20px;
  padding-bottom: 20px;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch form {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .form-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .form-grid {
    display: flex;
    flex-direction: column;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch label {
  font-weight: bold;
  color: white;
  margin-bottom: 5px;
  font-family: "Manrope Semibold";
  font-size: 30px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch label {
    font-size: 22px;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch select {
  padding: 7px 20px;
  border: 1px solid white;
  border-radius: 50px;
  font-size: 18px;
  width: 100%;
  color: white !important;
  font-family: "DM Sans Regular";
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch input[type=text],
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch input[type=number] {
  padding: 7px 20px;
  border: 1px solid white;
  border-radius: 50px;
  font-size: 18px;
  width: 100%;
  color: white !important;
  font-family: "DM Sans Regular";
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch input::placeholder {
  color: white; /* Placeholder text color */
  font-size: 18px; /* Font size */
  opacity: 0.8; /* Thoda transparent effect */
  font-family: "DM Sans Regular";
  text-transform: capitalize;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .radio-label {
  display: inline-flex;
  align-items: center;
  margin-right: 15px;
  font-size: 22px;
  font-family: "Manrope Semibold";
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .radio-label {
    font-size: 15px;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .radio-input {
  width: 16px;
  height: 16px;
  margin-right: 15px;
  padding: 10px;
  border-radius: 50%;
  border: 2px solid #5c3688;
  transition: background-color 0.3s, border 0.3s;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .radio-input {
    padding: 7px;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .radio-input:checked {
  background-color: #4f1d89;
  border-color: #4f1d89;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .radio-input:checked + .radio-label {
  font-weight: bold;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch p {
  color: red;
  font-size: 14px;
  margin: 0;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch button {
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch button:hover {
  background-color: #45a049;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch div > div {
  text-align: center;
  border-radius: 8px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch div > div {
    text-align: center;
    padding-bottom: 0;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .back-plate {
  padding: 40px;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch h4 {
  color: #5c3688;
  font-family: "Manrope Semibold";
  font-size: 40px;
  margin-bottom: 10px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch h4 {
    font-size: 28px;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .success-p {
  color: #5c3688;
  font-family: "Manrope Regular";
  font-size: 30px;
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .success-p {
    font-size: 18px;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch button {
  background-color: white;
  padding: 15px 20px;
  font-size: "Manrope Regular";
  font-size: 22px;
  color: #5c3688;
  font-size: 20px;
  line-height: 20px;
  padding: 12px 25px;
  border-radius: 40px;
  letter-spacing: -0.23px;
  margin: auto;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch button:hover {
  background-color: #470e89;
}
.add-accounts-page-css main .msg-btn {
  position: fixed;
  bottom: 0;
  width: 90px;
  bottom: 20px;
  right: 20px;
  width: 90px;
  z-index: 10;
}
.add-accounts-page-css main .msg-btn img {
  border-radius: 50%;
  border: solid 1px white;
}
@media (max-width: 767px) {
  .add-accounts-page-css main .msg-btn {
    width: 40px;
  }
}
.add-accounts-page-css main #about {
  position: relative;
}
.add-accounts-page-css main #about .swiper-container {
  margin-top: 134px;
  width: 100%;
  overflow: hidden;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #about .swiper-container {
    margin-top: 60px;
  }
}
.add-accounts-page-css main #about .swiper-slide {
  width: auto;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-accounts-page-css main #about .hero-img {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
}
.add-accounts-page-css main #about .dot-img {
  flex-grow: 1;
}
.add-accounts-page-css main #partnership {
  padding-top: 167px;
}
.add-accounts-page-css main #partnership .partnership-wrapper {
  text-align: center;
}
.add-accounts-page-css main #partnership .head-copy {
  font-size: 80px;
  line-height: 90px;
  font-family: "Manrope Semibold";
}
@media (max-width: 767px) {
  .add-accounts-page-css main #partnership .head-copy {
    font-size: 40px;
    line-height: 50px;
  }
}
.add-accounts-page-css main #partnership .copy {
  margin-top: 33px;
  font-size: 30px;
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  line-height: 40px;
}
.add-accounts-page-css main #mediaSpend {
  margin-top: 120px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #mediaSpend {
    margin-top: 50px;
  }
}
.add-accounts-page-css main #mediaSpend .spand-wrapper {
  display: flex;
  justify-content: center;
}
.add-accounts-page-css main #mediaSpend .img-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.add-accounts-page-css main #mediaSpend .copy-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.add-accounts-page-css main #mediaSpend .copy-wrapper h4 {
  color: #5c3688;
  font-size: 100px;
  line-height: 100px;
  font-weight: 600;
  font-family: "Manrope Regular";
  text-align: center;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #mediaSpend .copy-wrapper h4 {
    font-size: 60px;
    line-height: 1.2;
  }
}
.add-accounts-page-css main #mediaSpend .copy-wrapper p {
  color: #5c3688;
  font-size: 60px;
  line-height: 70px;
  font-weight: 600;
  font-family: "Manrope Regular";
  text-align: center;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #mediaSpend .copy-wrapper p {
    font-size: 45px;
    line-height: 1.2;
  }
}
.add-accounts-page-css main #knowmore {
  padding-top: 157px;
}
.add-accounts-page-css main #knowmore .knowmore-wrapper {
  max-width: 1071px;
  margin: auto;
}
.add-accounts-page-css main #knowmore .card-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 137px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #knowmore .card-wrapper {
    flex-direction: column;
  }
}
.add-accounts-page-css main #knowmore .card-img {
  flex: 1 1;
}
.add-accounts-page-css main #knowmore .card-copy {
  flex: 1 1;
}
.add-accounts-page-css main #knowmore .card-title {
  font-size: 40px;
  line-height: 90px;
  font-family: "Manrope Semibold";
}
@media (max-width: 767px) {
  .add-accounts-page-css main #knowmore .card-title {
    line-height: 50px;
  }
}
.add-accounts-page-css main #knowmore .card-discription {
  font-size: 20px;
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  line-height: 30px;
  width: 338px;
}
.add-accounts-page-css main #knowmore .learnmore-btn {
  margin-top: 11px;
  font-size: 15px;
  font-family: "Manrope Regular";
  line-height: 30px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.add-accounts-page-css main #sliderContainer {
  padding-top: 0px;
  padding-bottom: 160px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px -4px 11px -4px inset;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer {
    padding-top: 0;
    padding-bottom: 120px;
    box-shadow: rgba(0, 0, 0, 0.19) 1px -10px 11px -4px inset;
  }
}
.add-accounts-page-css main #sliderContainer .wrapper {
  position: relative;
  display: flex;
  justify-content: center;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer .wrapper {
    display: block;
  }
}
.add-accounts-page-css main #sliderContainer .heading-slider-2 {
  font-family: "Manrope Semibold";
  font-size: 60px;
  line-height: 90px;
  text-align: center;
  color: #5c3688;
  margin-bottom: 60px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer .heading-slider-2 {
    font-size: 40px;
    line-height: 1.2;
    margin-bottom: 40px;
  }
}
.add-accounts-page-css main #sliderContainer .swiper-container {
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  top: 61px;
  bottom: 0;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer .swiper-container {
    position: static;
    display: block;
    width: 100%;
    position: absolute;
    display: block;
    left: 50%;
    left: 50%;
    top: 0;
    transform: translate(-50%, 0);
    bottom: unset;
  }
}
.add-accounts-page-css main #sliderContainer .swiper-wrapper {
  max-width: 1200px;
}
.add-accounts-page-css main #sliderContainer .swiper-slide {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: visible;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer .swiper-slide {
    padding: 0 40px;
    width: 100%;
  }
}
.add-accounts-page-css main #sliderContainer .swiper-button-next:after {
  content: unset;
}
.add-accounts-page-css main #sliderContainer .swiper-button-prev:after {
  content: unset;
}
.add-accounts-page-css main #sliderContainer .swiper-button-next2,
.add-accounts-page-css main #sliderContainer .swiper-button-prev2 {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 44px;
  height: 44px;
  position: absolute; /* Ensure absolute positioning */
  top: 50%;
  transform: translateY(-50%); /* Center vertically */
  z-index: 10; /* Ensure buttons are on top */
  cursor: pointer;
}
.add-accounts-page-css main #sliderContainer .swiper-button-next2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer .swiper-button-next2 {
    width: 30px;
    right: -5px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .add-accounts-page-css main #sliderContainer .swiper-button-next2 {
    right: 150px;
  }
}
.add-accounts-page-css main #sliderContainer .swiper-button-prev2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer .swiper-button-prev2 {
    width: 30px;
    left: -5px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .add-accounts-page-css main #sliderContainer .swiper-button-prev2 {
    left: 150px;
  }
}
.add-accounts-page-css main #sliderContainer .heading,
.add-accounts-page-css main #sliderContainer .city {
  font-size: 28px;
  line-height: 34px;
  font-family: "Manrope Regular";
  font-weight: 600;
  color: #5c3688;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer .heading,
  .add-accounts-page-css main #sliderContainer .city {
    text-align: center;
  }
}
.add-accounts-page-css main #sliderContainer .para {
  font-size: 18px;
  line-height: 24px;
  margin-top: 16px;
  font-family: "Manrope Regular";
  font-weight: 400;
  color: #5c3688;
  text-align: center;
  margin-bottom: 16px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer .para {
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
}
.add-accounts-page-css main #multichannel {
  padding-top: px;
}
.add-accounts-page-css main #multichannel .head-title {
  font-size: 80px;
  line-height: 90px;
  font-family: "Manrope Semibold";
  text-align: center;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #multichannel .head-title {
    font-size: 35px;
    line-height: 45px;
  }
}
.add-accounts-page-css main #multichannel .head-copy {
  font-size: 30px;
  line-height: 40px;
  font-family: "Manrope Semibold";
  text-align: center;
  margin-bottom: 93px;
}
.add-accounts-page-css main #multichannel .card-wrapper {
  margin-top: 93px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 339px;
  row-gap: 199px;
  position: relative;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #multichannel .card-wrapper {
    grid-template-columns: unset;
  }
}
.add-accounts-page-css main #multichannel .center-img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.add-accounts-page-css main #multichannel .card-title {
  font-size: 40px;
  font-family: "Manrope Semibold";
  line-height: 90px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #multichannel .card-title {
    line-height: 50px;
  }
}
.add-accounts-page-css main #multichannel .card-copy {
  font-size: 20px;
  font-family: "Manrope Semibold";
  line-height: 30px;
}
.add-accounts-page-css main #cardSection {
  padding-top: 80px;
}
.add-accounts-page-css main #cardSection .heading-cardSection {
  font-size: 60px;
  line-height: 90px;
  color: #5c3688;
  font-family: "Manrope Semibold";
  text-align: center;
  margin-bottom: 32px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #cardSection .heading-cardSection {
    font-size: 40px;
    line-height: 1.2;
  }
}
.add-accounts-page-css main #cardSection .card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.add-accounts-page-css main #cardSection .row {
  display: flex;
  width: 100%;
  position: relative;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #cardSection .row {
    flex-direction: column;
  }
}
.add-accounts-page-css main #cardSection .top-cards .card {
  width: 30%;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #cardSection .top-cards .card {
    width: 100%;
  }
}
.add-accounts-page-css main #cardSection .center-card {
  position: relative;
}
.add-accounts-page-css main #cardSection .center-card .card {
  width: 45%;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #cardSection .center-card .card {
    width: 100%;
  }
}
.add-accounts-page-css main #cardSection .card {
  padding: 16px;
  padding-top: 23px;
  padding-bottom: 76px;
  flex-grow: 1;
  position: relative;
}
.add-accounts-page-css main #cardSection .heading-card {
  font-size: 28px;
  font-family: "Manrope Semibold";
  line-height: 34px;
  color: #5c3688;
  margin-bottom: 15px;
}
.add-accounts-page-css main #cardSection .copy-card {
  font-size: 18px;
  font-family: "Manrope Regular";
  line-height: 24px;
  color: #5c3688;
  position: relative;
  z-index: 5;
}
.add-accounts-page-css main #cardSection .top-cards .card {
  border-bottom: 1px solid rgba(92, 54, 136, 0.2);
  z-index: 5; /* Add border-right to all cards except the last one */
}
.add-accounts-page-css main #cardSection .top-cards .card:not(:last-child) {
  border-right: 1px solid rgba(92, 54, 136, 0.2); /* Add border-right to all cards except the last one */
  z-index: 5; /* Add border-right to all cards except the last one */
}
.add-accounts-page-css main #cardSection .center-card .card:not(:last-child) {
  border-right: 1px solid rgba(92, 54, 136, 0.2); /* Add border-right to all cards except the last one */
  z-index: 5; /* Add border-right to all cards except the last one */
}
.add-accounts-page-css main #cardSection .card-container .row .card::after {
  content: "";
  position: absolute;
  width: 7px;
  height: 7px;
  background-color: rgba(92, 54, 136, 0.2);
  border-radius: 50%;
  z-index: 10;
}
.add-accounts-page-css main #cardSection .top-cards .card:not(:last-child)::after {
  top: 100%;
  right: -4px;
  transform: translateY(-50%);
  z-index: 10;
}
.add-accounts-page-css main #cardSection .center-card .card:not(:last-child)::after {
  top: 100%;
  right: -4px;
  transform: translateY(-50%);
  top: 0;
  z-index: 10;
}
.add-accounts-page-css main #cardSection .circle-pink {
  margin-bottom: 30px;
}
.add-accounts-page-css main #cardSection .card-4 {
  padding-left: 211px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #cardSection .card-4 {
    padding-left: 16px;
    border-bottom: 1px solid rgba(92, 54, 136, 0.2);
  }
}
.add-accounts-page-css main #cardSection .card-5 {
  padding-right: 211px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #cardSection .card-5 {
    padding: 16px;
  }
}
.add-accounts-page-css main #cardSection .card-5::after {
  content: unset !important;
  width: unset;
}
.add-accounts-page-css main #cardSection .card-3::after {
  content: unset !important;
  width: unset;
}
@media (max-width: 767px) {
  .add-accounts-page-css .scroll-container {
    padding-top: 60px;
  }
}
.add-accounts-page-css .section {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-accounts-page-css .pin-section {
  position: relative;
  height: 100vh;
  display: flex;
  overflow: hidden;
  justify-content: center;
  flex-direction: row-reverse;
  gap: 40px;
}
@media (max-width: 767px) {
  .add-accounts-page-css .pin-section {
    flex-direction: column-reverse;
    gap: 20px;
  }
}
.add-accounts-page-css .pin-section .card-copy {
  flex: 1 1;
}
.add-accounts-page-css .pin-section .learnmore-btn {
  margin-top: 11px;
  font-size: 15px;
  font-family: "Manrope Regular";
  line-height: 30px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.add-accounts-page-css .text-container,
.add-accounts-page-css .image-container {
  flex: 1 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 767px) {
  .add-accounts-page-css .text-container,
  .add-accounts-page-css .image-container {
    align-items: unset;
    top: 30px;
  }
}
.add-accounts-page-css .text-container {
  overflow: hidden;
}
.add-accounts-page-css .text-slide {
  position: absolute;
  width: 100%;
  opacity: 0;
  color: #5c3688;
}
.add-accounts-page-css .text-slide .card-title {
  font-size: 40px;
  line-height: 90px;
  font-family: "Manrope Semibold";
}
@media (max-width: 767px) {
  .add-accounts-page-css .text-slide .card-title {
    font-size: 24px;
    line-height: 50px;
  }
}
.add-accounts-page-css .text-slide .card-discription {
  font-size: 20px;
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  line-height: 30px;
  width: 338px;
}
@media (max-width: 767px) {
  .add-accounts-page-css .text-slide .card-discription {
    font-size: 15px;
    line-height: 1.4;
  }
}
.add-accounts-page-css .image-slide {
  position: absolute;
  width: 400px;
  height: 400px;
  background-size: cover;
  background-position: center;
  opacity: 0;
  padding: 100px 0;
}
@media (max-width: 767px) {
  .add-accounts-page-css .image-slide {
    width: 300px;
    height: 300px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .add-accounts-page-css .image-slide {
    width: 300px;
    height: 300px;
  }
}
.add-accounts-page-css .image-slide.backmeta {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_65___});
}
.add-accounts-page-css .image-slide.google-ads {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
}
.add-accounts-page-css .image-slide.tiktok {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
}
.add-accounts-page-css .image-slide.tabola {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
}
.add-accounts-page-css .image-slide.snap {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
}
.add-accounts-page-css .accordion-section {
  padding-top: 89px;
}
.add-accounts-page-css .accordion-section .heading-acc {
  font-size: 60px;
  line-height: 90px;
  color: #5c3688;
  text-align: center;
  margin-bottom: 50px;
  font-family: "Manrope Semibold";
}
@media (max-width: 767px) {
  .add-accounts-page-css .accordion-section .heading-acc {
    font-size: 40px;
    line-height: 1.2;
  }
}
.add-accounts-page-css .accordion-section .accordion {
  width: 80%;
  margin: 0 auto;
}
.add-accounts-page-css .accordion-section .accordion-item {
  border: 1px solid rgba(92, 54, 136, 0.2);
  margin-bottom: 20px;
  border-radius: 20px;
}
.add-accounts-page-css .accordion-section .accordion-button {
  border: none;
  padding: 30px;
  padding: 30px 100px;
  text-align: left;
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #5c3688;
  font-size: 28px;
  background: transparent;
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
}
.add-accounts-page-css .accordion-section .accordion-button span {
  font-size: 28px;
  width: 36px;
}
@media (max-width: 767px) {
  .add-accounts-page-css .accordion-section .accordion-button {
    padding: 30px;
    gap: 5px;
  }
  .add-accounts-page-css .accordion-section .accordion-button .btn-copy {
    font-size: 18px;
    line-height: 22px;
  }
}
.add-accounts-page-css .accordion-section .accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease;
  padding: 0 30px;
  font-size: 18px;
  color: #5c3688;
  padding: 0 100px;
  margin-left: 36px;
}
.add-accounts-page-css .accordion-section .accordion-content.show {
  max-height: 1000px;
}
.add-accounts-page-css .accordion-section .accordion-content p {
  font-family: "Manrope Regular";
}
@media (max-width: 767px) {
  .add-accounts-page-css .accordion-section .accordion-content {
    padding: 0 20px;
  }
}
.add-accounts-page-css .accordion-section .accordion-content p {
  font-family: "Manrope Regular";
  font-size: 18px;
  line-height: 24px;
  color: #5c3688;
  margin-bottom: 30px;
}
.add-accounts-page-css .accordion-section .accordion-content.show {
  max-height: 1000px; /* Arbitrarily large value to ensure content is visible */
}
.add-accounts-page-css #cardContact {
  padding-top: 116px;
}
@media (max-width: 767px) {
  .add-accounts-page-css #cardContact {
    padding-top: 60px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .add-accounts-page-css #cardContact {
    padding: 64px 50px;
  }
}
.add-accounts-page-css #cardContact .wrapper {
  display: flex;
  background-color: #f17380;
  justify-content: space-between;
  padding: 83px 121px;
  border-radius: 20px;
}
@media (max-width: 767px) {
  .add-accounts-page-css #cardContact .wrapper {
    flex-direction: column;
    padding: 30px;
  }
}
.add-accounts-page-css #cardContact .wrapper a {
  font-family: "Manrope Regular";
  font-size: 18px;
  line-height: 34px;
  font-weight: 600;
  color: white;
}
.add-accounts-page-css #cardContact .wrapper p {
  font-family: "Manrope Regular";
  font-size: 18px;
  line-height: 34px;
  font-weight: 600;
  color: white;
}
@media (max-width: 767px) {
  .add-accounts-page-css #cardContact .wrapper p {
    font-size: 14px;
  }
}
.add-accounts-page-css .footer-add {
  margin-top: 106px;
  padding-top: 56px;
  padding-bottom: 80px;
  background-color: #5c3688;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
@media (max-width: 767px) {
  .add-accounts-page-css .footer-add {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
    background-position: bottom;
    background-size: contain;
    background-repeat: no-repeat;
    padding-bottom: 80px;
    margin-top: 80px;
  }
}
.add-accounts-page-css .footer-add .footer-wrapper-ad {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .add-accounts-page-css .footer-add .footer-wrapper-ad {
    flex-direction: column;
    gap: 30px;
  }
}
.add-accounts-page-css .footer-add .footer-wrapper-ad .privacy-policy {
  font-family: "DM Sans Regular";
  font-size: 16px;
  color: white;
}
.add-accounts-page-css .footer-add .logo {
  width: 200px;
}
@media (max-width: 767px) {
  .add-accounts-page-css .footer-add .logo {
    width: 150px;
  }
}
.add-accounts-page-css .footer-add .nav-list {
  display: flex;
  align-items: center;
}
.add-accounts-page-css .footer-add .nav-list a {
  display: block;
}
@media (max-width: 767px) {
  .add-accounts-page-css .footer-add .nav-list {
    flex-direction: column;
    gap: 20px;
  }
}
.add-accounts-page-css .footer-add .nav-item {
  font-size: 14px;
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  margin-right: 31px;
  letter-spacing: 0%;
  color: white;
}
@media (max-width: 767px) {
  .add-accounts-page-css .footer-add .nav-item {
    margin-right: 0;
  }
}
.add-accounts-page-css .footer-add .footer-hero-img {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  width: 100%;
  bottom: 10px;
}
.add-accounts-page-css .footer-add .footer-hero-img img {
  flex-grow: 1;
}
@media (max-width: 767px) {
  .add-accounts-page-css .footer-add .footer-hero-img {
    bottom: 10px;
  }
}
.add-accounts-page-css .footer-add .copyright-copy {
  color: white;
  font-size: 14px;
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  line-height: 40px;
  text-align: center;
  bottom: 32px;
}
@media (max-width: 767px) {
  .add-accounts-page-css .footer-add .copyright-copy {
    font-size: 14px;
    width: 100%;
    left: unset;
    transform: unset;
    text-align: center;
    bottom: 10px;
  }
}

.privacy-policy-media-solution {
  padding: 40px 0;
}
.privacy-policy-media-solution .privacy-policy-wrapper h1 {
  font-family: "Neue Haas Grotesk Display Pro Bold";
  font-size: 30px;
  text-align: center;
  padding-bottom: 40px;
}
.privacy-policy-media-solution .privacy-policy-wrapper p {
  font-family: "Neue Haas Grotesk Display Pro Light";
  font-size: 20px;
}
.privacy-policy-media-solution .privacy-policy-wrapper h2 {
  font-family: "DM Sans Bold";
  font-size: 24px;
  margin: 20px 0;
}
.privacy-policy-media-solution .privacy-policy-wrapper h3 {
  font-family: "DM Sans Regular";
  font-size: 24px;
  margin: 20px 0;
}

.build-ecomm-page-css .container_ecom {
  max-width: 900px;
  margin: 0 auto;
  width: 90%;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .build-ecomm-page-css .container_ecom {
    width: 90%;
    max-width: 768px;
    margin: 0 auto;
  }
}
@media (max-width: 767px) {
  .build-ecomm-page-css .container_ecom {
    width: 320px;
    margin: 0 auto;
  }
}
.build-ecomm-page-css .container-1 {
  max-width: 1200px;
  margin: 0 auto;
  width: 90%;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .build-ecomm-page-css .container-1 {
    width: 90%;
    max-width: 768px;
    margin: 0 auto;
  }
}
@media (max-width: 767px) {
  .build-ecomm-page-css .container-1 {
    width: 320px;
    margin: 0 auto;
  }
}
.build-ecomm-page-css .banner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.build-ecomm-page-css .banner .wrapper {
  padding: 6rem 0;
  max-width: 1100px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .banner .wrapper {
    padding-bottom: 3rem;
    padding-top: 3rem;
  }
}
.build-ecomm-page-css .banner .wrapper .gredient_back {
  position: absolute;
  width: 400px;
  right: 0px;
  z-index: 5;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .banner .wrapper .gredient_back {
    width: 225px;
    bottom: 10px;
    position: absolute;
    right: 0;
  }
}
.build-ecomm-page-css .banner .wrapper .gredient_back .time {
  width: 100%;
  position: absolute;
  z-index: 7;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.build-ecomm-page-css .banner .wrapper .gredient_back .time i {
  font-size: 50px;
}
.build-ecomm-page-css .banner .wrapper .gredient_back .time h4 {
  text-align: center;
  font-family: "DM Sans Bold";
  font-size: 20px;
  line-height: 1.3;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .banner .wrapper .gredient_back .time h4 {
    font-size: 12px;
  }
}
.build-ecomm-page-css .banner .wrapper .logo-section {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: -moz-fit-content;
  width: fit-content;
}
.build-ecomm-page-css .banner .wrapper .logo-section p {
  text-align: end;
  margin-bottom: 5px;
  font-family: "DM Sans Regular";
  font-size: 12px;
  margin-right: -4px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .banner .wrapper .logo-section p {
    padding-right: unset;
  }
}
.build-ecomm-page-css .banner .wrapper .logo-section .flex-second {
  display: flex;
  align-items: stretch;
  gap: 20px;
}
.build-ecomm-page-css .banner .wrapper .logo-section .flex-second .logo {
  display: flex;
  border: 1px solid black;
  align-items: center;
  padding: 10px 20px;
  border-radius: 8px;
}
.build-ecomm-page-css .banner .wrapper .logo-section .flex-second .logo.logo-p {
  position: relative;
}
.build-ecomm-page-css .banner .wrapper .logo-section .flex-second .logo.logo-p p {
  position: absolute;
  top: -10px;
  right: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
}
.build-ecomm-page-css .banner .wrapper .logo-section .flex-second .logo .blink_logo {
  width: 250px;
}
.build-ecomm-page-css .banner .wrapper .logo-section .flex-second .logo .olm_logo {
  width: 65px;
}
.build-ecomm-page-css .banner .wrapper .hero-copy {
  margin-top: 20px;
  margin-bottom: 20px;
  position: relative;
  z-index: 10;
}
.build-ecomm-page-css .banner .wrapper .hero-copy a {
  display: block;
  margin: 0 auto;
}
.build-ecomm-page-css .banner .wrapper .hero-copy h2 {
  font-size: 4rem;
  font-family: "DM Sans Bold";
  line-height: 1;
  text-align: center;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .banner .wrapper .hero-copy h2 {
    font-size: 2rem;
  }
}
.build-ecomm-page-css .banner .wrapper .para {
  position: relative;
  z-index: 10;
  font-family: "DM Sans Regular";
  font-size: 20px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .banner .wrapper .para {
    font-size: 14px;
  }
}
.build-ecomm-page-css .banner .wrapper .btn {
  position: relative;
  z-index: 10;
  display: inline-block;
  font-size: 1.5rem;
  font-family: "DM Sans Regular";
  background-color: black;
  color: #e977c1;
  padding: 15px 30px;
  border: 1px solid black;
  border-radius: 50px;
  margin: 20px 0;
  margin: auto;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .banner .wrapper .btn {
    font-size: 16px;
    padding: 10px 30px;
  }
}
.build-ecomm-page-css .banner .wrapper .btn:hover {
  background-color: transparent;
  color: black;
  transition: 0.5s;
}
.build-ecomm-page-css .why_us .wrapper {
  padding: 4rem 0;
}
.build-ecomm-page-css .why_us .wrapper .flex-logo-wrapper {
  margin-top: 4rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 50px;
  column-gap: 50px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .why_us .wrapper .flex-logo-wrapper {
    grid-template-columns: repeat(2, 1fr);
    margin-top: 2rem;
    gap: 10px;
  }
}
.build-ecomm-page-css .why_us .wrapper .logo-copy-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f1f1f3;
  padding: 30px;
  text-align: center;
  border-radius: 10px;
  gap: 10px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .why_us .wrapper .logo-copy-item {
    padding: 15px;
    gap: 5px;
  }
}
.build-ecomm-page-css .why_us .wrapper .logo-copy-item img {
  width: 80px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .why_us .wrapper .logo-copy-item img {
    width: 40px;
  }
}
.build-ecomm-page-css .why_us .wrapper h2 {
  font-size: 3rem;
  font-family: "DM Sans Bold";
  margin-bottom: 10px;
  background: linear-gradient(345deg, #e5b400, #e05300, #e977c1, #516beb);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .why_us .wrapper h2 {
    font-size: 24px;
    text-align: center;
  }
}
.build-ecomm-page-css .why_us .wrapper p {
  font-size: 20px;
  font-family: "DM Sans Regular";
  padding-top: 20px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .why_us .wrapper p {
    font-size: 14px;
    padding-top: 5px;
  }
}
.build-ecomm-page-css .agenda {
  padding: 4rem 0;
  background-color: #f2f2f2;
}
.build-ecomm-page-css .agenda .wrapper .head {
  display: flex;
  align-items: baseline;
  font-size: 20px;
  font-family: "DM Sans Regular";
  margin-bottom: 30px;
  justify-content: space-between;
}
.build-ecomm-page-css .agenda .wrapper h2 {
  color: black;
  font-size: 3rem;
  font-family: "DM Sans Bold";
  text-transform: uppercase;
}
.build-ecomm-page-css .agenda .wrapper .lunch {
  background: linear-gradient(90deg, #e46f2f, #e05301, #e4ad00, #c58403, #ed86ae);
  display: flex;
  padding: 10px 20px;
  justify-content: space-between;
}
.build-ecomm-page-css .agenda .wrapper .lunch .copy {
  padding-left: 50px;
  font-size: 1.1rem;
  font-family: "DM Sans Bold";
  color: white;
  text-transform: uppercase;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .lunch .copy {
    padding-left: 0;
  }
}
.build-ecomm-page-css .agenda .wrapper .lunch .time {
  font-size: 1.1rem;
  font-family: "DM Sans Bold";
  color: white;
  text-transform: uppercase;
  padding-right: 50px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .lunch .time {
    padding-right: 0;
  }
}
.build-ecomm-page-css .agenda .wrapper .card-wrap {
  display: flex;
  flex-wrap: wrap;
  row-gap: 0px;
  column-gap: 2rem;
  padding-bottom: 30px;
  padding-top: 20px;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .card-wrap {
    flex-direction: column;
    padding-bottom: 20px;
  }
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card {
  width: 48%;
  display: flex;
  align-items: flex-start;
  padding: 20px 0;
  gap: 20px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .card-wrap .card {
    width: 100%;
    padding: 20px 0;
    gap: 10px;
  }
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card .img-wrap img {
  border-radius: 50%;
  width: 100px;
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card .info {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  justify-content: space-between;
  flex-direction: column;
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .name {
  font-size: 20px;
  font-family: "DM Sans Bold";
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .para {
  font-size: 20px;
  font-family: "DM Sans Regular";
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .position {
  display: flex;
  gap: 14px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .position {
    flex-direction: column;
    gap: 5px;
  }
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .position .copy {
  font-family: "DM Sans Regular";
  color: #6d6d6d;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .position .copy {
    font-size: 13px;
  }
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .position .time {
  font-family: "DM Sans Bold";
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .position .time {
    font-size: 14px;
  }
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .tag {
  font-size: 16px;
  font-family: "DM Sans Bold";
  background: linear-gradient(345deg, #facc35, #ee2a23, #f58121);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: "DM Sans Bold";
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .tag {
    font-size: 12px;
  }
}
.build-ecomm-page-css .agenda .wrapper .center-tag {
  padding-top: 20px;
  padding-bottom: 20px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .center-tag {
    padding-bottom: 0px;
  }
}
.build-ecomm-page-css .agenda .wrapper .center-tag .position {
  display: flex;
  gap: 3rem;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .center-tag .position {
    flex-direction: column;
    align-items: center;
    gap: 0;
  }
}
.build-ecomm-page-css .agenda .wrapper .center-tag .position .copy {
  font-family: "DM Sans Regular";
  color: #6d6d6d;
}
.build-ecomm-page-css .agenda .wrapper .center-tag .position .time {
  font-family: "DM Sans Bold";
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .center-tag .position .time {
    font-size: 14px;
  }
}
.build-ecomm-page-css .details {
  padding: 4rem 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.build-ecomm-page-css .details .wrapper h2 {
  color: white;
  font-size: 3rem;
  font-family: "DM Sans Bold";
  margin-bottom: 30px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .details .wrapper h2 {
    font-size: 24px;
    text-align: center;
  }
}
.build-ecomm-page-css .details .wrapper iframe {
  width: 100%;
}
.build-ecomm-page-css .details .wrapper iframe .HMRMj {
  display: none;
}
.build-ecomm-page-css .details .wrapper iframe .HB1eCd-UMrnmb {
  background-color: red;
}
.build-ecomm-page-css .details .wrapper iframe .HB1eCd-UMrnmb .teQAzf {
  width: 100% !important;
}
.build-ecomm-page-css .details .wrapper iframe .HB1eCd-UMrnmb body {
  background-color: transparent !important;
}
.build-ecomm-page-css .details .wrapper iframe .HB1eCd-UMrnmb .D8bnZd {
  background-color: rgba(62, 18, 107, 0) !important;
}
.build-ecomm-page-css .details .wrapper .form_container_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.build-ecomm-page-css .details .wrapper .form_container_1 .form_container {
  display: flex;
  gap: 1rem;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .details .wrapper .form_container_1 .form_container {
    flex-direction: column;
  }
}
.build-ecomm-page-css .details .wrapper .form_container_1 .form_container .form_1 {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  flex-grow: 1;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .details .wrapper .form_container_1 .form_container .form_1 {
    flex-direction: column;
  }
}
.build-ecomm-page-css .details .wrapper .form_container_1 .form_container .field-wrap {
  width: 48%;
  position: relative;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .details .wrapper .form_container_1 .form_container .field-wrap {
    width: 100%;
  }
}
.build-ecomm-page-css .details .wrapper .form_container_1 .form_container .field-wrap .error_form {
  font-size: 12px;
  color: red;
  position: absolute;
  bottom: -14px;
  margin: 0;
}
.build-ecomm-page-css .details .wrapper .form_container_1 .form_container .field-wrap.field-wrap-2 {
  width: 100%;
  position: relative;
}
.build-ecomm-page-css .details .wrapper .form_container_1 .form_container .field-wrap.field-wrap-2 .error_form {
  font-size: 12px;
  color: red;
  position: absolute;
  bottom: 5px;
  margin: 0;
}
.build-ecomm-page-css .details .wrapper .form_container_1 .form_container .input_css {
  max-width: 100%;
  width: 100%;
  background-color: #f2f2f2;
  font-size: 16px;
  padding: 18px 10px;
  border-radius: 5px;
  flex-grow: 1;
}
.build-ecomm-page-css .details .wrapper .form_container_1 .form_container .input_css::placeholder {
  color: #9d9d9d;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .details .wrapper .form_container_1 .form_container .input_css {
    width: 100%;
    padding: 14px 10px;
    font-size: 16px;
  }
}
.build-ecomm-page-css .details .wrapper .form_container_1 .input_css_2 {
  background-color: #f2f2f2;
  font-size: 24px;
  padding: 18px 10px;
  border-radius: 5px;
  font-family: "DM Sans Regular";
}
.build-ecomm-page-css .details .wrapper .form_container_1 .input_css_2::placeholder {
  color: #9d9d9d;
  font-size: 16px;
  vertical-align: middle;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .details .wrapper .form_container_1 .input_css_2 {
    padding: 14px 10px;
    font-size: 16px;
  }
}
.build-ecomm-page-css .details .wrapper .form_container_1 .input_css_1 {
  background-color: #f2f2f2;
  font-size: 16px;
  padding: 18px 10px;
  border-radius: 5px;
  font-family: "DM Sans Regular";
  width: 100%;
}
.build-ecomm-page-css .details .wrapper .form_container_1 .input_css_1::placeholder {
  color: #9d9d9d;
  font-size: 16px;
  vertical-align: middle;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .details .wrapper .form_container_1 .input_css_1 {
    padding: 14px 10px;
    font-size: 16px;
    height: 150px;
  }
}
.build-ecomm-page-css .details .wrapper a {
  display: inline-block;
  font-size: 1.5rem;
  font-family: "DM Sans Regular";
  color: #e977c1;
  padding: 15px 30px;
  border: none;
  border-radius: 50px;
  margin: 40px 0;
  color: white;
  background-color: transparent;
  border: 1px solid white;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .details .wrapper a {
    margin: 30px 0;
    padding: 10px 30px;
    font-size: 17px;
    display: block;
    text-align: center;
    /* margin: auto 0; */
    margin-left: auto;
    margin-right: auto;
    width: -moz-fit-content;
    width: fit-content;
  }
}
.build-ecomm-page-css .details .wrapper a:hover {
  background-color: black;
  color: #e977c1;
  border: 1px solid black;
  transition: 0.5s;
}
.build-ecomm-page-css .footer-ecom {
  padding: 2rem 0;
  position: absolute;
  width: 100%;
  background-color: #f2f2f2;
}
.build-ecomm-page-css .footer-ecom .wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .footer-ecom .wrapper {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
}
.build-ecomm-page-css .footer-ecom .wrapper .logo {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.build-ecomm-page-css .footer-ecom .wrapper .logo img {
  width: 130px;
}
.build-ecomm-page-css .footer-ecom .wrapper .logo p {
  font-family: "DM Sans Medium";
}
.build-ecomm-page-css .footer-ecom .wrapper .email_wrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-family: "DM Sans Regular";
}
.build-ecomm-page-css .footer-ecom .wrapper .email_wrap p {
  font-family: "DM Sans Medium";
}
.build-ecomm-page-css .footer-ecom .wrapper .email_wrap .flex-footer {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .footer-ecom .wrapper .email_wrap .flex-footer {
    flex-direction: column;
    align-items: center;
  }
}
@media (max-width: 767px) {
  .build-ecomm-page-css .footer-ecom .wrapper .email_wrap {
    flex-direction: column;
    gap: 10px;
    align-items: center;
  }
}

.logo-main-css .banner-relative {
  position: relative;
}
.logo-main-css .absolute-copy {
  position: absolute;
  top: 50%;
  color: white;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: "Manrope Bold";
  font-size: 60px;
}
@media (max-width: 767px) {
  .logo-main-css .absolute-copy {
    font-size: 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .logo-main-css .absolute-copy {
    font-size: 24px;
  }
}
.logo-main-css .wrapper-logo-row {
  padding: 80px 0;
  display: flex;
  flex-direction: column;
  gap: 100px;
}
.logo-main-css .wrapper-logo-row .grid-logo {
  display: grid;
  grid-template-columns: repeat(3, 3fr);
  gap: 50px;
}
@media (max-width: 767px) {
  .logo-main-css .wrapper-logo-row .grid-logo {
    grid-template-columns: repeat(1, 1fr);
    padding: 0 40px;
  }
}
.logo-main-css .wrapper-logo-row .card-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}
.logo-main-css .wrapper-logo-row .img-box {
  background-color: gray;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  padding: 50px;
  justify-content: center;
  background-color: rgb(248, 248, 248);
  border: 1px solid rgba(0, 0, 0, 0.176);
  border-radius: 6px;
}
.logo-main-css .wrapper-logo-row .btn-dow {
  background-color: rgba(0, 0, 0, 0);
  color: black;
  padding: 6px 12px;
  font-size: 16px;
  border: 1px solid black;
  border-radius: 6px;
}

.not-found-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  padding: 20px;
}

.not-found-container .container {
  padding: 40px;
  border-radius: 16px;
  max-width: 500px;
  width: 100%;
}

.not-found-container h1 {
  font-size: 3.2rem;
  margin-bottom: 10px;
  font-family: "DM Sans Bold";
  color: #000;
  text-transform: capitalize;
}
@media (max-width: 767px) {
  .not-found-container h1 {
    font-size: 1.5rem;
  }
}

.not-found-container p {
  font-size: 1.1rem;
  margin-bottom: 40px;
  font-family: "Manrope Light";
}

.cta-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-decoration: none;
  text-transform: capitalize;
  font-weight: bold;
  transition: background-color 0.3s ease;
  transition: border 0.3s ease;
  font-family: "Manrope Regular";
  font-size: 26px;
  padding-bottom: 2px;
  border-bottom: 2px solid transparent;
}
.cta-button img {
  width: 20px;
}
@media (max-width: 767px) {
  .cta-button {
    font-size: 1.2rem;
  }
  .cta-button img {
    width: 16px;
  }
}

.cta-button:hover img {
  transform: translate(15px, -15px); /* Move the arrow from bottom left */
  opacity: 0; /* Start with the arrow hidden */
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/main.scss"],"names":[],"mappings":"AACA;EACE,kDAAA;EACA,oHACE;EAEF,gBAAA;EACA,kBAAA;EACA,kBAAA;AAFF;AAKA;EACE,iDAAA;EACA,oHACE;EAEF,iBAAA;EACA,kBAAA;EACA,kBAAA;AALF;AAQA;EACE,kDAAA;EACA,oHACE;EAEF,gBAAA;EACA,kBAAA;EACA,kBAAA;AARF;AAWA;EACE,kDAAA;EACA,oHACE;EAEF,mBAAA;EACA,kBAAA;EACA,kBAAA;AAXF;AAcA;EACE,kDAAA;EACA,oHACE;EAEF,gBAAA;EACA,kBAAA;EACA,kBAAA;AAdF;AAiBA;EACE,mDAAA;EACA,sHACE;EAEF,gBAAA;EACA,kBAAA;EACA,kBAAA;AAjBF;AAoBA;EACE,kDAAA;EACA,sHACE;EAEF,gBAAA;EACA,kBAAA;EACA,kBAAA;AApBF;AAuBA;EACE,iDAAA;EACA,sHACE;EAEF,gBAAA;EACA,kBAAA;EACA,kBAAA;AAvBF;AAyBA;EACE,yDAAA;EACA,sHACE;EAEF,gBAAA;EACA,kBAAA;EACA,kBAAA;AAzBF;AA4BA;EACE,yDAAA;EACA,sHACE;EAEF,gBAAA;EACA,kBAAA;EACA,kBAAA;AA5BF;AAiCA,cAAA;AAaA,UAAA;AAQA;EACE,2BAAA;EACA,sHACE;EAEF,iBAAA;EACA,kBAAA;EACA,kBAAA;AApDF;AAuDA;EACE,iCAAA;EACA,sHACE;EAEF,gBAAA;EACA,kBAAA;EACA,kBAAA;AAvDF;AA0DA;EACE,6BAAA;EACA,sHACE;EAEF,gBAAA;EACA,kBAAA;EACA,kBAAA;AA1DF;AA6DA;EACE,gCAAA;EACA,sHACE;EAEF,iBAAA;EACA,kBAAA;EACA,kBAAA;AA7DF;AAgEA;EACE,4BAAA;EACA,sHACE;EAEF,gBAAA;EACA,kBAAA;EACA,kBAAA;AAhEF;AAmEA;EACE,+BAAA;EACA,sHACE;EAEF,gBAAA;EACA,kBAAA;EACA,kBAAA;AAnEF;AAsEA;EACE,8BAAA;EACA,sHACE;EAEF,mBAAA;EACA,kBAAA;EACA,kBAAA;AAtEF;AAyEA,cAAA;AAWA;EACE,8BAAA;EACA,sHACE;EAEF,mBAAA;EACA,kBAAA;EACA,kBAAA;AAnFF;AAsFA;EACE,gCAAA;EACA,sHACE;EAEF,gBAAA;EACA,kBAAA;EACA,kBAAA;AAtFF;AAyFA;EACE,2BAAA;EACA,sHACE;EAEF,iBAAA;EACA,kBAAA;EACA,kBAAA;AAzFF;AA4FA;EACE,6BAAA;EACA,sHACE;EAEF,mBAAA;EACA,kBAAA;EACA,kBAAA;AA5FF;AA+FA;EACE,6BAAA;EACA,sHACE;EAEF,gBAAA;EACA,kBAAA;EACA,kBAAA;AA/FF;AAkGA;EACE,iCAAA;EACA,sHACE;EAEF,iBAAA;EACA,kBAAA;EACA,kBAAA;AAlGF;AAqGA,cAAA;AAYA,WAAA;AA8BA,cAAA;AAEA;;;GAAA;AAKA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,cAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;AA7IF;;AAgJA,gDAAA;AACA;;;;;;;;;;;EAWE,cAAA;AA7IF;;AAgJA;EACE,cAAA;AA7IF;;AAgJA;;EAEE,gBAAA;AA7IF;;AAgJA;;EAEE,YAAA;AA7IF;;AAgJA;;;;EAIE,WAAA;EACA,aAAA;AA7IF;;AAgJA;EACE,yBAAA;EACA,iBAAA;AA7IF;;AAgJA;EACE,sBAAA;AA7IF;;AAgJA;EASE,qBAAA;AArJF;AA6IE;EAKE,cAAA;AA/IJ;;AAqJA;;;EAGE,kBAAA;AAlJF;;AA4JA;EACE,WAAA;AAzJF;;AA4JA;EACE,YAAA;AAzJF;;AA4JA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AAzJF;;AA4JA;EACE,OAAA;EACA,cAAA;EACA,WAAA;AAzJF;AA2JE;EAEE,WAAA;EACA,cAAA;AA1JJ;AA6JE;EACE,WAAA;AA3JJ;;AA+JA;EACE,aAAA;AA5JF;;AA+JA;;;EAGE,gBAAA;EACA,gBAAA;AA5JF;;AA+JA;EACE,gBAAA;AA5JF;;AA+JA;EACE,YAAA;AA5JF;;AA+JA,YAAA;AAEA;EACE,mCAAA;EACA,qBAAA;AA7JF;;AAgKA;;EAEE,WAAA;AA7JF;;AAgKA;;;;EAIE,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;AA7JF;;AAgKA;;EAEE,uBAAA;EACA,YAAA;AA7JF;;AAgKA;;;;;EAKE,aAAA;AA7JF;;AAgKA;EACE,cAAA;EACA,eAAA;AA7JF;;AAgKA;;;;;;;;EAQE,gBAAA;AA7JF;;AAgKA;EACE,gBAAA;AA7JF;;AAgKA;EACE,cAAA;EACA,eAAA;EACA,YAAA;AA7JF;;AAgKA,gCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AA7JF;;AAgKA,YAAA;AACA;EACE,0BAAA;AA7JF;;AAgKA;EACE,yBAAA;AA7JF;;AAgKA;EACE,yBAAA;AA7JF;;AAzJI;EAyTJ;IAEI,wBAAA;EA7JF;AACF;;AAvKI;EAuUJ;IAEI,wBAAA;EA7JF;AACF;;AAzKI;EAyUJ;IAEI,wBAAA;EA7JF;AACF;;AAgKA;EACE,WAAA;EACA,YAAA;AA7JF;;AAgKA;EACE,iBAAA;EACA,cAAA;EACA,UAAA;AA7JF;AA1LI;EAoVJ;IAOI,gBAAA;EA7JF;AACF;AAnMI;EAwVJ;IAWI,WAAA;IACA,eAAA;EA5JF;AACF;;AA+JA,aAAA;AAIA;EACE,kBAAA;AA/JF;;AAkKA;EACE,uBAAA;AA/JF;;AAkKA;EACE,uBAAA;EACA,YAAA;AA/JF;;AAiKA;EACE,uBAAA;EACA,YAAA;AA9JF;;AAmKA,kBAAA;AACA;EACE,iBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,sEAAA;EAEA,6BAAA;EACA,YAAA;EACA,WAAA;EAEA,6BAAA;EACA,yBAAA;AAlKF;AA1OI;EAgYJ;IAcI,eAAA;EAhKF;AACF;;AAmKA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAhKF;AAvPI;EAkZJ;IAOI,cAAA;IACA,iBAAA;EA9JF;AACF;;AAiKA;EACE,YAAA;AA9JF;AAjQI;EA8ZJ;IAGI,YAAA;IACA,uCAAA;EA5JF;AACF;;AA+JA,uBAAA;AAEA;EACE,aAAA;EACA,mBAAA;AA7JF;AA7QI;EAwaJ;IAII,WAAA;IACA,kBAAA;IACA,WAAA;IACA,OAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;EA3JF;AACF;AAxRI;EAobF;IAEI,iBAAA;IACA,oBAAA;IACA,WAAA;IACA,aAAA;IACA,uBAAA;EA1JJ;AACF;AA6JE;EACE,aAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;AA3JJ;AAxSI;EA8bF;IAOI,sBAAA;IACA,mBAAA;IACA,SAAA;EAzJJ;AACF;AA4JM;EACE,yBAAA;AA1JR;AAlTI;EA0cA;IAUI,SAAA;EA9JN;EAyJM;IACE,gBAAA;IACA,eAAA;IACA,kDAjoBF;EA0eN;AACF;;AA8JA,sBAAA;AAEA;EACE,aAAA;EACA,eAAA;AA5JF;AAlUI;EA4dJ;IAII,kBAAA;IACA,cAAA;EA1JF;AACF;;AA6JA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA1JF;;AA6JA;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCACE;AA3JJ;;AA+JA;EACE,wCAAA;AA5JF;;AA+JA;EACE,UAAA;AA5JF;;AA+JA;EACE,0CAAA;AA5JF;;AA+JA,wBAAA;AAOA;EACE;IACE,kCAAA;EAlKF;EAoKA;IACE,iCAAA;EAlKF;AACF;AAoKA;EAKE,iBAAA;AAtKF;AAhXI;EAihBJ;IAOI,gBAAA;EApKF;AACF;AAsKE;EAEE,qBAAA;EACA,kDA7sBI;EA8sBJ,YAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EAWA,+BAAA;AA/KJ;AAgLI;EASE,uBAAA;AAtLN;AAyLE;EACE,yCAAA;AAvLJ;;AA0LA;EACE,eAAA;AAvLF;;AA0LA,2BAAA;AACA;EACE;IAEE,kBAAA;EAxLF;EA2LA;IACE,cAAA;EAzLF;AACF;AA8LA;EACE,iBAAA;AA5LF;AAiMU;EACE,cA5vBL;AA6jBP;;AAuMA;EAEE,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAplBA,aAAA;EAulBA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAlMF;AA1aI;EA+lBJ;IAeI,kBAAA;IACA,qBAAA;IACA,YAAA;EAhMF;AACF;AAmMM;EACE,YAAA;AAjMR;AAsMM;EACE,YAAA;AApMR;AAyMI;EACE,kDAnzBE;EAozBF,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AAvMN;AA9bI;EAgoBA;IAQI,eAAA;IACA,gBAAA;EAtMN;AACF;AAhcI;EA4nBA;IAYI,eAAA;EApMN;AACF;AAuMI;EACE,kDAn0BE;EAo0BF,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AArMN;AAhdI;EAgpBA;IAQI,eAAA;EApMN;AACF;AAjdI;EA4oBA;IAWI,gBAAA;EAlMN;AACF;AAqMI;EACE,gBAAA;EACA,kDAh1BE;EAi1BF,eAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;AAnMN;AAleI;EA+pBA;IAQI,kBAAA;IAEA,gBAAA;IACA,eAAA;EAlMN;AACF;AAreI;EA2pBA;IAcI,eAAA;EAhMN;AACF;AAoME;;;EA/pBA,aAAA;EAoqBE,mBAAA;EACA,uBAAA;EACA,iBAAA;AA/LJ;;AAmMA;EACE,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,+BAAA;AAhMF;;AAmMA;EAGE,iBAAA;AAlMF;AArgBI;EAosBJ;IAMI,iBAAA;IACA,iBAAA;EAjMF;AACF;AAmME;EACE,aAAA;EACA,sBAAA;EAEA,kBAAA;AAlMJ;AAhhBI;EA8sBF;IAOI,UAAA;IACA,SAAA;EAjMJ;AACF;AAuMM;EACE,aAAA;AArMR;AAzhBI;EA6tBE;IAUI,UAAA;EA1MR;AACF;AA1hBI;EAytBE;IAiBI,YAAA;IACA,aAAA;EA5MR;AACF;AA8MQ;EACE,iBAAA;AA5MV;AA8MQ;EACE,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kDAx6BF;EAy6BE,eAAA;AA5MV;AA9iBI;EAqvBI;IAQI,eAAA;IACA,iBAAA;IACA,iBAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;EA3MV;AACF;AA+MM;EACE,gBAAA;EACA,kDAx7BA;EAy7BA,iBAAA;EACA,iBAAA;AA7MR;AA9jBI;EAuwBE;IAOI,eAAA;EA5MR;AACF;AAgNI;EAGE,mBAAA;AAhNN;AAqNM;EACE,kBAAA;AAnNR;AAqNQ;EACE,+EAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EAGA,aAAA;AArNV;AAllBI;EA8xBI;IAWI,+BAAA;IACA,gCAAA;EAnNV;AACF;AAqNQ;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAnNV;AA9lBI;EA6yBI;IAOI,WAAA;IACA,WAAA;EAlNV;AACF;AApmBI;EAmxBA;IAyCI,mBAAA;EApNN;AACF;AAsNM;EACE,iBAAA;AApNR;AA2NM;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,sBAAA;AAzNR;AAlnBI;EAu0BE;IASI,gBAAA;EA1NR;AACF;AA2NQ;EACE,kBAAA;AAzNV;AA1nBI;EAk1BI;IAGI,kBAAA;EAvNV;AACF;AAyNQ;EACE,uBAAA;AAvNV;AAyNQ;EACE,eAAA;EACA,kDA5gCF;EA6gCE,gBAAA;EACA,UAAA;AAvNV;AAxoBI;EA21BI;IAMI,eAAA;EArNV;AACF;AAyNM;EAQE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,yBAAA;EACA,qBAAA;AA9NR;AAtpBI;EAs2BE;IAgBI,sBAAA;EA5NR;AACF;AAkOQ;EAEE,mBAAA;EACA,iBAAA;EACA,kDAhjCF;EAijCE,eAAA;EACA,2BAAA;EAAA,sBAAA;AAjOV;AAlqBI;EA63BI;IASI,eAAA;IACA,eAAA;IACA,iBAAA;IACA,YAAA;EAhOV;AACF;AAmOQ;EACE,eAAA;EACA,kDA9jCF;EA+jCE,gBAAA;AAjOV;AA/qBI;EA64BI;IAKI,eAAA;EA/NV;AACF;AAprBI;EAs2BE;IAiDI,oBAAA;IACA,gBAAA;IACA,gBAAA;IAEA,YAAA;IAEA,sBAAA;IACA,iBAAA;IACA,aAAA;IACA,yBAAA;IACA,qBAAA;EAjOR;AACF;AA7rBI;EAk2BE;IA8DI,YAAA;IACA,aAAA;EA/NR;AACF;AAkOM;EACE,aAAA;EAKA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,sBAAA;AApOR;AA0OQ;EACE,iBAAA;AAxOV;AAjtBI;EAy6BE;IA0BI,YAAA;IACA,UAAA;IACA,iBAAA;EA9OR;AACF;AAptBI;EAq6BE;IA+BI,YAAA;IACA,aAAA;EA5OR;AACF;AA8OQ;EAEE,mBAAA;EACA,iBAAA;EACA,kDA/nCF;EAgoCE,eAAA;AA7OV;AApuBI;EA48BI;IAQI,eAAA;IACA,eAAA;IACA,iBAAA;IACA,YAAA;EA5OV;AACF;AA8OQ;EACE,eAAA;EACA,kDA3oCF;EA4oCE,gBAAA;EACA,UAAA;AA5OV;AAlvBI;EA09BI;IAOI,eAAA;EA3OV;AACF;AAsPI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,sEAAA;EACA,SAAA;EACA,sEAAA;EAEA,gCAAA;EACA,kDAxqCE;EAyqCF,gBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EAEA,sBAAA;EACA,mCAAA;EACA,kBAAA;AAtPN;AAxwBI;EA6+BA;IAoBI,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,kDAnrCA;IAorCA,kBAAA;IACA,eAAA;EArPN;AACF;AA9wBI;EAy+BA;IA4BI,eAAA;EAnPN;AACF;;AAwPA;EACE,wBAAA;EACA,sBAAA;EACA,4BAAA;AArPF;;AAuPA;EAEE,gBAAA;AArPF;AAjyBI;EAohCJ;IAQI,eAAA;IACA,iBAAA;EAvPF;AACF;AA0PE;EACE,eAAA;AAxPJ;AA1yBI;EAiiCF;IAOI,sBAAA;IACA,uBAAA;IACA,MAAA;EA1PJ;AACF;AA4PI;EACE,gBAAA;EACA,kDA9tCE;EA+tCF,iBAAA;EACA,YAAA;AA1PN;AAvzBI;EA6iCA;IAQI,eAAA;IACA,kDAruCA;EA2+BN;AACF;AAzzBI;EAyiCA;IAYI,eAAA;EAxPN;AACF;AA2PI;EACE,eAAA;EACA,kDA9uCE;EA+uCF,gBAAA;EACA,eAAA;AAzPN;AAx0BI;EA6jCA;IAOI,eAAA;EAxPN;AACF;AA4PE;EACE,UAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;AA1PJ;AAp1BI;EAykCF;IAQI,SAAA;EAzPJ;AACF;AAr1BI;EAqkCF;IAWI,SAAA;EAvPJ;AACF;AAyPI;EACE,eAAA;AAvPN;AA0PQ;EACE,aAAA;AAxPV;AA2PQ;EACE,aAAA;AAzPV;AAgQM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EAEA,2BAAA;EACA,qBAAA;AA/PR;AAx3BI;EAumCE;IAoBI,cAAA;IACA,aAAA;IACA,UAAA;IACA,aAAA;IACA,sBAAA;EA/PR;AACF;AA73BI;EAmmCE;IA2BI,YAAA;IACA,aAAA;EA7PR;AACF;AA+PQ;EACE,iBAAA;EACA,cAAA;AA7PV;AAgQQ;EAEE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kDA/zCF;EAg0CE,YAAA;EACA,eAAA;AA/PV;AAn5BI;EA2oCI;IASI,eAAA;EA7PV;AACF;AAgQQ;EACE,0DAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;AA9PV;AAiQQ;EACE,0DAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;AA/PV;AAkQQ;EACE,0DAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;AAhQV;AAmQQ;EACE,0DAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;AAjQV;AAsQI;EACE,eAAA;AApQN;AAuQQ;EACE,aAAA;AArQV;AAwQQ;EACE,aAAA;AAtQV;AAgRM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,aAAA;EAEA,2BAAA;EACA,qBAAA;AA/QR;AAv8BI;EAysCE;IAgBI,cAAA;IACA,UAAA;IACA,aAAA;IACA,sBAAA;IACA,aAAA;EA9QR;AACF;AA58BI;EAqsCE;IAuBI,YAAA;IACA,aAAA;EA5QR;AACF;AA8QQ;EACE,iBAAA;EACA,cAAA;AA5QV;AA+QQ;EAEE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kDA75CF;EA+5CE,YAAA;EACA,eAAA;AA/QV;AAl+BI;EAyuCI;IAUI,eAAA;EA7QV;AACF;AAgRQ;EACE,0DAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;AA9QV;AAgRU;EACE,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AA9QZ;AAkRQ;EACE,0DAAA;EACA,mCAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;AAhRV;AAmRQ;EACE,0DAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;AAjRV;AAoRQ;EACE,0DAAA;EACA,mCAAA;EAEA,wBAAA;EACA,sBAAA;EACA,4BAAA;AAnRV;AAwRI;EACE,kBAAA;EACA,gBAAA;EACA,kDAj9CE;EAk9CF,QAAA;EACA,sEAAA;EACA,SAAA;EACA,sEAAA;EAEA,gCAAA;EAIA,YAAA;EACA,UAAA;AA1RN;AAnhCI;EA+xCA;IAiBI,eAAA;EAzRN;AACF;;AA8RA;EAEE,oBAAA;EAEA,kBAAA;AA7RF;AA7hCI;EAszCJ;IASI,cAAA;EA9RF;AACF;AAkSE;EAGE,WAAA;AAlSJ;AAriCI;EAo0CF;IAOI,UAAA;EAlSJ;AACF;AAsSM;EACE,aAAA;AApSR;AAuSM;EACE,aAAA;AArSR;AAySI;EACE,eAAA;AAvSN;AAnjCI;EAy1CA;IAOI,eAAA;EAzSN;AACF;AA4SI;EACE,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,aAAA;EAEA,2BAAA;EACA,qBAAA;EAEA,mBAAA;EAEA,kBAAA;AA7SN;AAkTM;EACE,+EAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EAGA,aAAA;AAlTR;AAqTM;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;AAnTR;AAsTM;EACE,YAAA;EACA,eAAA;EACA,kDAxjDA;EAyjDA,cAAA;AApTR;AAtlCI;EAs4CE;IAMI,eAAA;EAlTR;AACF;AAqTM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AAnTR;AAsTM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AApTR;AAuTM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AArTR;AAwTM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AAtTR;AAyTM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AAvTR;AA0TM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AAxTR;AA2TM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AAzTR;AA4TM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AA1TR;AA6TM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AA3TR;AA8TM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AA5TR;AA+TM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AA7TR;AAgUM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AA9TR;AAkUI;EACE,gBAAA;AAhUN;AA1pCI;EAy9CA;IAGI,eAAA;EA9TN;AACF;AAiUI;EACE,iBAAA;AA/TN;AAlqCI;EAg+CA;IAGI,gBAAA;EA7TN;AACF;AAgUI;EACE,iBAAA;AA9TN;AA1qCI;EAu+CA;IAGI,iBAAA;EA5TN;AACF;AA+TI;EACE,iBAAA;AA7TN;AAlrCI;EA8+CA;IAGI,iBAAA;EA3TN;AACF;AA+TE;EACE,eAAA;EACA,0BAAA;AA7TJ;AA3rCI;EAs/CF;IAII,0BAAA;EA3TJ;AACF;AA8TE;EACE,gBAAA;EACA,kDAlrDI;EAorDJ,SAAA;EACA,WAAA;EACA,iBAAA;EAEA,YAAA;EACA,WAAA;AA9TJ;AAzsCI;EA8/CF;IAYI,UAAA;IACA,SAAA;IAEA,eAAA;IAEA,kDA9rDE;IA+rDF,eAAA;EA/TJ;AACF;AA9sCI;EA0/CF;IAqBI,eAAA;EA7TJ;AACF;AAgUE;EACE,gBAAA;EACA,kDA3sDI;EA6sDJ,aAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EAEA,YAAA;AAhUJ;AAhuCI;EAuhDF;IAYI,WAAA;IACA,eAAA;IACA,YAAA;IACA,kDArtDE;IAstDF,eAAA;EA/TJ;AACF;AAruCI;EAmhDF;IAmBI,eAAA;EA7TJ;AACF;;AAiUA;EACE,aAAA;AA9TF;AAlvCI;EA+iDJ;IAII,cAAA;IACA,WAAA;IACA,eAAA;IAEA,MAAA;IACA,OAAA;IACA,YAAA;IACA,QAAA;IACA,WAAA;IACA,0DAAA;IACA,2BAAA;IACA,2BAAA;IACA,sBAAA;IACA,4BAAA;EA9TF;AACF;;AAiUA;EACE,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;AA9TF;AA3wCI;EAokDJ;IAQI,uBAAA;EA7TF;AACF;AAhxCI;EA8kDA;IAEI,WAAA;IACA,cAAA;IACA,eAAA;IACA,OAAA;IACA,MAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;IAKA,sBAAA;EA7TN;AACF;;AAiUA;EACE,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AA9TF;AAoUA;EACE,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;AAlUF;AAnzCI;EAgnDJ;IAOI,0DAAA;IACA,yBAAA;EAhUF;AACF;;AAmUA;EAEE,gBAAA;AAjUF;AA7zCI;EA4nDJ;IAOI,UAAA;IACA,eAAA;EAlUF;AACF;AAoUE;EACE,kDA1zDI;EA2zDJ,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EAEA,cAAA;AAnUJ;AA30CI;EAuoDF;IAUI,eAAA;IACA,mBAAA;IACA,kDAl0DE;IAo0DF,eAAA;IACA,mBAAA;IACA,kDAAA;IACA,cAAA;EAnUJ;AACF;AAl1CI;EAmoDF;IAoBI,eAAA;EAjUJ;AACF;AAoUE;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAlUJ;AAoUI;EACE,qBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAlUN;AAsUI;EACE,WAAA,EAAA,gDAAA;AApUN;AAuUI;EACE,eAAA;AArUN;AAh3CI;EAorDA;IAGI,eAAA;EAnUN;AACF;AAr3CI;EA+pDF;IA6BI,gBAAA;IACA,SAAA;EAnUJ;AACF;AAoUI;EACE,kDAh3DG;AA8iDT;AAqUI;EAOE,eAAA;AAzUN;AA2UM;EACE,kDA73DC;EA83DD,gBAAA;EACA,kBAAA;AAzUR;AAt4CI;EA4sDE;IAKI,gBAAA;IAEA,eAAA;EAxUR;AACF;AA4UI;EACE,kBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,wBAAA;EACA,kDAn5DE;EAo5DF,eAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AA1UN;AA6UI;EACE,mBAAA;AA3UN;AAgVI;EACE,aAAA;EACA,eAAA;AA9UN;;AAmVA;EAGE,qBAAA;AAlVF;AA16CI;EAyvDJ;IAcI,cAAA;IACA,oBAAA;EAzVF;AACF;AA2VE;EACE,gBAAA;EACA,kDA/7DI;EAg8DJ,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AAzVJ;AAx7CI;EA2wDF;IAWI,mBAAA;IACA,eAAA;IACA,kDAv8DE;IAw8DF,cAAA;IACA,eAAA;IACA,iBAAA;EA1VJ;AACF;AA97CI;EAuwDF;IAoBI,eAAA;EAzVJ;AACF;AA4VE;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AA1VJ;AA78CI;EAmyDF;IAOI,sBAAA;IACA,SAAA;IACA,eAAA;EAzVJ;AACF;AA2VI;EACE,kDAAA;EACA,aAAA;EAEA,SAAA;AA1VN;AA4VM;EACE,iBAAA;EACA,qBAAA;EACA,kDAv+DA;AA6oDR;AA99CI;EAqzDE;IAKI,eAAA;IACA,mBAAA;EAxVR;AACF;AA2VM;EACE,kDA/+DA;EAg/DA,8BAAA;EACA,cAAA;EACA,2BAAA;EAAA,sBAAA;EACA,mBAAA;AAzVR;AA2VQ;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;AAzVV;AAh/CI;EA+zDE;IAcI,eAAA;EAzVR;EA0VQ;IACE,eAAA;EAxVV;AACF;AA4VM;EACE,kDApgEA;EAqgEA,eAAA;EACA,cAAA;EACA,mBAAA;AA1VR;AA9/CI;EAo1DE;IAMI,eAAA;EAxVR;AACF;AA2VM;EAEE,kDA/gEA;EAghEA,8BAAA;EACA,cAAA;EACA,2BAAA;EAAA,sBAAA;EACA,qBAAA;AA1VR;AA4VQ;EACE,mBAAA;AA1VV;AAsWM;EACE,kDAniEA;EAoiEA,8BAAA;EACA,cAAA;EACA,2BAAA;EAAA,sBAAA;EACA,qBAAA;AApWR;AAuWM;EACE,kDA3iEA;EA4iEA,eAAA;EACA,cAAA;EACA,qBAAA;AArWR;AAwWM;EACE,cAAA;EACA,iBAAA;EACA,kDApjEA;EAqjEA,kBAAA;AAtWR;AAyWM;EACE,kDAzjEA;EA0jEA,gBAAA;AAvWR;AA4WE;EACE,aAAA;AA1WJ;AAviDI;EAg5DF;IAGI,cAAA;EAxWJ;EA0WI;IACE,eAAA,EAAA,kEAAA;EAxWN;EA0WI;IACE,aAAA;EAxWN;EA2WI;IACE,cAAA;IACA,gBAAA;IACA,wBAAA;EAzWN;EA2WI;IACE,aAAA;EAzWN;EA4WI;IACE,kDAAA;IACA,aAAA;IAEA,SAAA;IACA,aAAA;IACA,cAAA;EA3WN;EA4WM;IACE,iBAAA;IACA,qBAAA;IACA,kDA9lEF;EAovDN;AACF;AAtkDI;EA46DI;IAKI,eAAA;IACA,mBAAA;EAvWV;AACF;AA5kDI;EAs7DI;IACE,kDAtmEF;IAumEE,8BAAA;IACA,cAAA;IACA,2BAAA;IAAA,sBAAA;IACA,mBAAA;EAvWR;EAyWQ;IACE,mBAAA;IACA,gBAAA;IACA,kBAAA;EAvWV;AACF;AA1lDI;EAs7DI;IAcI,eAAA;EAtWV;EAuWU;IACE,eAAA;EArWZ;AACF;AAlmDI;EA28DI;IACE,kDA3nEF;IA4nEE,eAAA;IACA,cAAA;IACA,mBAAA;EAtWR;AACF;AA1mDI;EA28DI;IAMI,eAAA;EAnWV;AACF;AA/mDI;EAq9DI;IAEE,kDAtoEF;IAuoEE,8BAAA;IACA,cAAA;IACA,2BAAA;IAAA,sBAAA;IACA,qBAAA;EApWR;EAsWQ;IACE,mBAAA;EApWV;EAgXM;IACE,kDA1pEF;IA2pEE,8BAAA;IACA,cAAA;IACA,2BAAA;IAAA,sBAAA;IACA,qBAAA;EA9WR;EAiXM;IACE,kDAlqEF;IAmqEE,eAAA;IACA,cAAA;IACA,qBAAA;EA/WR;EAkXM;IACE,cAAA;IACA,iBAAA;IACA,kDA3qEF;IA4qEE,kBAAA;EAhXR;EAmXM;IACE,kDAhrEF;IAirEE,gBAAA;EAjXR;AACF;;AAuXA;EAEE,kBAAA;EACA,oBAAA;AArXF;AAuXE;EACE,gBAAA;EACA,kDA/rEI;EAgsEJ,iBAAA;EAEA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;AAtXJ;AAhqDI;EA8gEF;IAUI,gBAAA;EApXJ;AACF;AAjqDI;EA0gEF;IAaI,gBAAA;EAlXJ;AACF;AAlqDI;EAsgEF;IAgBI,gBAAA;EAhXJ;AACF;AAmXE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AAjXJ;AAprDI;EAkiEF;IAMI,sBAAA;IACA,SAAA;EAhXJ;AACF;AAiXI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;AA/WN;AAgXM;EACE,kDAhuEA;AAk3DR;AAnsDI;EA2iEA;IASI,SAAA;EA7WN;EA8WM;IACE,eAAA;EA5WR;AACF;AA8WM;EACE,uBAAA;EACA,mBAAA;EACA,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,SAAA;AA7WR;AAntDI;EAyjEE;IASI,iBAAA;IACA,aAAA;IACA,mBAAA;IACA,SAAA;EA3WR;AACF;AA4WQ;EACE,0BAAA;EACA,YAAA;EACA,eAAA;EACA,kDA1vEF;AAg5DR;AAjuDI;EAukEI;IAMI,eAAA;EAxWV;AACF;AA6WI;EACE,aAAA;EACA,sBAAA;EAEA,eAAA;EACA,iBAAA;AA5WN;AA5uDI;EAmlEA;IAOI,iBAAA;IACA,oBAAA;EA1WN;AACF;AA2WM;EACE,iBAAA;EACA,oBAAA;EACA,2BAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;AAzWR;AA2WU;EACE,0BAAA;AAzWZ;AA6WQ;EACE,SAAA;EACA,gBAAA;AA3WV;AA4WU;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;AA1WZ;AA4WU;EACE,SAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,8BAAA;AA1WZ;AA7wDI;EAknEM;IAQI,SAAA;EAzWZ;AACF;AA0WY;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAxWd;AAyWc;EACE,uBAAA;EACA,mBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,kDAtzER;EAuzEQ,0BAAA;AAxWhB;AA0Wc;EACE,kDA1zER;EA2zEQ,eAAA;EACA,gBAAA;AAxWhB;AAryDI;EA4nEQ;IAqBI,SAAA;EAxWd;EA0Wc;IACE,eAAA;IACA,gBAAA;EAxWhB;AACF;AA2WY;EACE,kDAz0EN;EA00EM,eAAA;EACA,gBAAA;AAzWd;AAnzDI;EA+pEU;IACE,eAAA;EAzWd;AACF;AAxzDI;EA6lEE;IAyEI,sBAAA;IACA,SAAA;IACA,iBAAA;IACA,oBAAA;EA1WR;AACF;AA8WE;EACE,kBAAA;EACA,cAAA;EACA,0BAAA;EACA,kDAj2EI;AAq/DR;AAt0DI;EAygEJ;IA6KI,kBAAA;IACA,iBAAA;EA5WF;EA6WE;IACE,eAAA;IACA,SAAA;IACA,UAAA;EA3WJ;AACF;;AA+WA;EACE,kBAAA;EACA,oBAAA;AA5WF;AAt1DI;EAgsEJ;IAII,kBAAA;EA1WF;AACF;AA4WI;EACE,aAAA;EACA,sBAAA;AA1WN;AA4WM;EACE,aAAA;EACA,8BAAA;AA1WR;AA4WQ;EACE,mBAAA;AA1WV;AAt2DI;EA2sEE;IAQI,sBAAA;IACA,uBAAA;EAzWR;EA0WQ;IACE,uBAAA;EAxWV;AACF;AA0WQ;EACE,eAAA;EACA,gBAAA;EACA,kDA34EF;AAmiER;AAp3DI;EAytEI;IAKI,eAAA;IACA,gBAAA;EAtWV;AACF;AAwWQ;EACE,gBAAA;EACA,kDAt5EF;EAu5EE,iBAAA;EACA,yBAAA;AAtWV;AAh4DI;EAkuEI;IAOI,eAAA;IAEA,gBAAA;EAtWV;AACF;AAl4DI;EA8tEI;IAYI,gBAAA;EApWV;AACF;AAn4DI;EA0tEI;IAgBI,gBAAA;EAnWV;AACF;AAqWQ;EAEE,iBAAA;EAIA,SAAA;EACA,aAAA;EACA,iBAAA;EAEA,aAAA;EACA,sBAAA;EA6NA,gEAAA;AApkBV;AAz5DI;EAqvEI;IAcI,iBAAA;IACA,SAAA;EAtWV;AACF;AAuWU;EAEE,aAAA;EAGA,4CAAA;EAIA,aAAA;EACA,gBAAA;AA3WZ;AAr6DI;EAswEM;IAYI,UAAA;IACA,sBAAA;IACA,aAAA;EAzWZ;AACF;AA4WY;EACE,iDA58EP;EA68EO,eAAA;EACA,kBAAA;AA1Wd;AAj7DI;EAwxEQ;IAKI,eAAA;EAxWd;AACF;AA0WY;EACE,kDAh9EN;EAi9EM,eAAA;AAxWd;AA17DI;EAgyEQ;IAII,eAAA;EAtWd;AACF;AAwWY;EACE,aAAA;EAEA,gBAAA;AAvWd;AAwWc;EACE,SAAA;AAtWhB;AAt8DI;EAuyEQ;IAQI,mBAAA;EArWd;AACF;AAuWY;EACE,6DAAA;EACA,gBAAA;EAEA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAtWd;AAn9DI;EAkzEQ;IAUI,6BAAA;EArWd;AACF;AAp9DI;EA8yEQ;IAcI,kBAAA;EApWd;AACF;AAr9DI;EA0zEU;IAEI,gCAAA;EAnWhB;AACF;AA99DI;EA8zEU;IAKI,iBAAA;EAjWhB;AACF;AAyWY;EACE,sBAAA;AAvWd;AA0WY;EACE,gBAAA;EAGA,gBAAA;AA1Wd;AA4WY;EAOE,gBAAA;AAhXd;AAj/DI;EA01EQ;IASI,4BAAA;EA9Wd;AACF;AAiXY;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;AA/Wd;AA9/DI;EAu2EQ;IAQI,kBAAA;IACA,SAAA;IACA,sBAAA;IACA,uBAAA;EA7Wd;AACF;AAgXc;EACE,eAAA;EACA,kDAviFR;EAyiFQ,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AA/WhB;AAhhEI;EAs3EU;IAWI,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,kBAAA;EA7WhB;AACF;AA+Wc;EACE,uBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AA7WhB;AA+Wc;EACE,iBAAA;EACA,eAAA;AA7WhB;AApiEI;EA+4EU;IAII,uBAAA;IAIA,eAAA;EA9WhB;AACF;AA1iEI;EAq3EQ;IAuCI,SAAA;EA9Wd;AACF;AAgXY;EACE,aAAA;EACA,qBAAA;EACA,SAAA;AA9Wd;AA+Wc;EACE,iCAAA,EAAA,oCAAA;EACA,UAAA,EAAA,gCAAA;EACA,gEACE;AA9WlB;AAzjEI;EA+5EQ;IAaI,QAAA;EA/Wd;AACF;AAiXc;EACE,eAAA;EAEA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAhXhB;AArkEI;EA+6EU;IAQI,eAAA;IACA,SAAA;IACA,kBAAA;EA9WhB;AACF;AAgXc;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,OAAA;EACA,YAAA,EAAA,gDAAA;EACA,2BAAA;AA9WhB;AAiXc;EACE,WAAA;EACA,mBAAA;AA/WhB;AA1lEI;EAu8EU;IAKI,UAAA;EA9WhB;AACF;AAoXgB;EACE,0BAAA,EAAA,iDAAA;EACA,UAAA;AAlXlB;AA2XU;EACE,2BAAA;EAKA,gBAAA;AA7XZ;AAvmEI;EA89EM;IAQI,sBAAA;EA3XZ;AACF;;AAuYA;EACE,kBAAA;EACA,oBAAA;AApYF;AAjnEI;EAm/EJ;IAII,kBAAA;EAlYF;AACF;AAqYI;EACE,aAAA;EACA,sBAAA;AAnYN;AAoYM;EACE,gBAAA;EACA,kDAlrFA;EAmrFA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAlYR;AAloEI;EA8/EE;IAQI,eAAA;EAhYR;AACF;AAnoEI;EA0/EE;IAWI,eAAA;EA9XR;AACF;AAgYM;EACE,aAAA;EACA,YAAA;AA9XR;AAgYM;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kDAAA;EACA,kBAAA;AA9XR;AAxpEI;EAghFE;IASI,sBAAA;IACA,SAAA;IACA,oBAAA;EA7XR;AACF;AA8XQ;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,6BAAA;AA5XV;AAvqEI;EA6hFI;IAQI,8BAAA;IACA,kBAAA;IACA,oBAAA;EA1XV;EA2XU;IACE,mBAAA;EAzXZ;AACF;AA2XU;EACE,kBAAA;AAzXZ;AA2XU;EACE,kDAhuFH;EAiuFG,eAAA;EACA,kBAAA;AAzXZ;AAzrEI;EA+iFM;IAKI,eAAA;EAvXZ;AACF;AAyXU;EACE,kDAvuFJ;EAwuFI,eAAA;EACA,yBAAA;AAvXZ;AAnsEI;EAujFM;IAKI,eAAA;EArXZ;AACF;AAsXY;EACE,cApuFP;AAg3EP;AA3sEI;EAokFQ;IACE,iBAAA;EAtXZ;AACF;AA2XI;EACE,gBAAA;AAzXN;AA0XM;EACE,eAAA;EACA,kDAjwFA;EAkwFA,yBAAA;AAxXR;AAxtEI;EA6kFE;IAKI,eAAA;EAtXR;AACF;AAwXM;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AAtXR;AAnuEI;EAqlFE;IAOI,eAAA;IACA,SAAA;IACA,2BAAA;IACA,gBAAA;IACA,kBAAA;EArXR;AACF;AAsXQ;EACE,yCAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kDAtxFF;EAuxFE,yBAAA;AApXV;AAqXU;EACE,iBAAA;EACA,YAAA;EACA,uBAAA;AAnXZ;AAzvEI;EAkmFI;IAaI,eAAA;IACA,iBAAA;EAlXV;AACF;AAoXQ;EACE,yCAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kDAvyFF;EAwyFE,yBAAA;AAlXV;AAmXU;EACE,iBAAA;EACA,YAAA;EACA,uBAAA;AAjXZ;AA5wEI;EAmnFI;IAaI,eAAA;IACA,iBAAA;EAhXV;AACF;AAmXQ;EACE,iBAAA;EACA,YAAA;EACA,uBAAA;AAjXV;AAmXQ;EACE,eAAA;EACA,kDA3zFF;EA6zFE,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;AAlXV;AAmXU;EACE,WAAA;AAjXZ;AAnyEI;EA0oFI;IAvnFN,aAAA;IAqoFU,SAAA;IACA,oBAAA;EA5WV;AACF;AAiXQ;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AA/WV;AAvzEI;EA+pFI;IASI,sBAAA;IACA,uBAAA;IAEA,eAAA;IACA,SAAA;EA9WV;EA+WU;IACE,iBAAA;EA7WZ;AACF;AAgXU;EACE,6DAAA;EACA,mBAAA;AA9WZ;AAgXU;EACE,gBAAA;AA9WZ;AAgXU;EACE,yBAAA;EACA,0DAAA;AA9WZ;AAgXU;EACE,qBAAA;AA9WZ;AAgXU;EACE,WAAA;EACA,kDAp3FJ;EAq3FI,eAAA;EACA,gBAAA;AA9WZ;AAt1EI;EAgsFM;IAMI,eAAA;EA5WZ;AACF;AA8WU;EACE,SAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;AA5WZ;AAl2EI;EAysFM;IAQI,WAAA;EA3WZ;AACF;AA6WY;EACE,aAAA;EACA,kDAr4FN;EAs4FM,eAAA;EACA,gBAAA;EACA,mBAAA;AA3Wd;AA92EI;EAotFQ;IAOI,eAAA;EAzWd;AACF;AA2WY;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AAzWd;AA4WgB;EACE,iCAAA,EAAA,oCAAA;EACA,UAAA,EAAA,gCAAA;EACA,gEACE;AA3WpB;AAgXc;EACE,6DAAA;EACA,mBAAA;AA9WhB;AAgXc;EACE,gBAAA;AA9WhB;AAgXc;EACE,WAAA;EACA,aAAA;EACA,qBAAA;AA9WhB;AAiXc;EAEE,0DAAA;AAhXhB;AAsXc;EAEE,0BAAA,EAAA,iDAAA;EACA,UAAA;AArXhB;AAuXc;EACE,WAAA;EACA,cAAA;EAEA,gBAAA;EACA,aAAA;EACA,qBAAA;EAEA,mBAAA;AAvXhB;AAyXgB;EACE,WAAA;AAvXlB;AA35EI;EAixFY;IAGI,mBAAA;IACA,WAAA;EArXlB;AACF;AAwXc;EACE,WAAA;EACA,eAAA;EACA,kDA38FR;EA48FQ,gBAAA;AAtXhB;AAv6EI;EAyxFU;IAQI,eAAA;EAtXhB;AACF;AA56EI;EA8tFQ;IAuEI,eAAA;EArXd;AACF;AAyXU;EACE,mBAAA;AAvXZ;AA4XQ;EACE,gBAAA;AA1XV;;AAiYA;EACE,kBAAA;EACA,qBAAA;AA9XF;AA57EI;EAwzFJ;IAII,kBAAA;EA5XF;AACF;AA8XI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AA5XN;AAt8EI;EA+zFA;IAKI,sBAAA;IACA,uBAAA;EA1XN;AACF;AA2XM;EACE,kDAv/FA;EAw/FA,eAAA;EACA,gBAAA;AAzXR;AAj9EI;EAu0FE;IAKI,eAAA;IACA,gBAAA;EAvXR;AACF;AA0XI;EACE,gBAAA;EACA,kDArgGE;EAsgGF,iBAAA;EACA,yBAAA;AAxXN;AA79EI;EAi1FA;IAMI,eAAA;IACA,gBAAA;EAtXN;AACF;AA/9EI;EA60FA;IAUI,gBAAA;EApXN;AACF;AAh+EI;EAy0FA;IAaI,gBAAA;EAlXN;AACF;AAqXI;EACE,iBAAA;EACA,aAAA;EACA,qCAAA;EACA,iBAAA;EACA,aAAA;AAnXN;AAp/EI;EAk2FA;IAQI,qCAAA;EAlXN;AACF;AAr/EI;EA81FA;IAaI,qCAAA;IACA,gBAAA;IACA,aAAA;EAlXN;AACF;AAoXI;EACE,SAAA;EACA,gBAAA;AAlXN;AAmXM;EACE,sCAAA,EAAA,8BAAA;EACA,mBAAA,EAAA,yBAAA;EACA,sBAAA,EAAA,mCAAA;EACA,wBAAA;AAjXR;AAoXI;EACE,aAAA;EAEA,kDAhjGE;EAijGF,eAAA;EAEA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,gBAAA;EACA,SAAA;AApXN;AAsXM;EAEE,oBAAA;EAEA,iCAAA,EAAA,oCAAA;EACA,UAAA,EAAA,gCAAA;EACA,gEACE;AAvXV;AA1hFI;EA04FE;IAWI,WAAA;IAEA,wBAAA,EAAA,8BAAA;IACA,UAAA;IACA,mBAAA;EAxXR;AACF;AAyXQ;EACE,WAAA;AAvXV;AAriFI;EA83FA;IAmCI,eAAA;IACA,aAAA;EAxXN;AACF;AA0XI;EACE,2BAAA,EAAA,wBAAA;AAxXN;AA9iFI;EAq6FA;IAGI,mBAAA;EAtXN;AACF;AAnjFI;EA26FA;IAEI,sCAAA;EAtXN;AACF;AAxjFI;EAg7FA;IAEI,8BAAA;EAtXN;AACF;AAwXI;EACE,aAAA;EACA,kDAAA;AAtXN;AAwXM;EACE,eAAA;AAtXR;AAuXQ;EACE,wBAAA,EAAA,8BAAA;EACA,UAAA,EAAA,kBAAA;AArXV;AAuXQ;EACE,gBAAA;AArXV;AAsXU;EACE,sBAAA;AApXZ;AAyXI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAvXN;AA2XI;EACE,aAAA;EAEA,kDAjoGE;EAkoGF,eAAA;EACA,gBAAA;AA1XN;AA1lFI;EA+8FA;IAQI,eAAA;IACA,aAAA;EAzXN;AACF;;AA8XA;EACE,gBAAA;AA3XF;AApmFI;EA89FJ;IAGI,eAAA;EAzXF;AACF;AA2XE;EACE,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AAzXJ;AA/mFI;EAo+FF;IAQI,aAAA;IACA,qCAAA;IACA,gBAAA;EAzXJ;AACF;AA2XM;EACE,YAAA;AAzXR;AAgYM;EACE,YAAA;AA9XR;AAiYM;EACE,gBAAA;AA/XR;AAgYQ;EACE,cArqGH;AAuyFP;AAkYM;EACE,gBAAA;AAhYR;AAmYM;EACE,kDAzrGC;EA0rGD,eAAA;EAEA,2BAAA;EAAA,sBAAA;EACA,0BAAA;EACA,qBAAA;AAlYR;AA5oFI;EAwgGE;IAQI,eAAA;IACA,qBAAA;EAhYR;AACF;AAmYM;EACE,kDAtsGC;EAusGD,eAAA;EAEA,2BAAA;EAAA,sBAAA;EACA,0BAAA;EACA,qBAAA;AAlYR;AAzpFI;EAqhGE;IAQI,eAAA;IACA,qBAAA;EAhYR;AACF;AAmYM;EACE,kDAltGA;EAmtGA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;AAjYR;AAkYQ;EACE,cA/sGH;AA+0FP;AA1qFI;EAkiGE;IAWI,eAAA;EA/XR;AACF;AAkYM;EACE,kDAjuGA;EAmuGA,eAAA;EACA,cAAA;EACA,gBAAA;AAjYR;AArrFI;EAijGE;IAOI,eAAA;EA/XR;AACF;AAkYM;EACE,eAAA;EACA,kDA7uGA;EA8uGA,qBAAA;EACA,yBAAA;EACA,eAAA;AAhYR;AAjsFI;EA4jGE;IAOI,eAAA;EA9XR;AACF;AA+XQ;EACE,cA3uGH;AA82FP;AAzsFI;EAqkGI;IAGI,YAAA;EA3XV;AACF;AA9sFI;EA6kGE;IAEI,QAAA;EA7XR;AACF;AAntFI;EAklGE;IAEI,QAAA;EA7XR;AACF;AAxtFI;EAulGE;IAEI,QAAA;EA7XR;AACF;AA7tFI;EA4lGE;IAEI,QAAA;EA7XR;AACF;AA0YA;EACE,eAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,oCAAA;EACA,aAAA;EACA,YAAA;EAEA,sBAAA;AAzYF;AA0YE;EACE,eAAA;EACA,kDA1yGI;EA2yGJ,eAAA;EACA,0BAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,gCAAA;AAxYJ;;AA4YA;EACE,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AAzYF;AAjwFI;EAqoGJ;IAOI,kBAAA;EAvYF;AACF;AAyYI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,8BAAA;AAvYN;AA7wFI;EA+oGA;IAOI,sBAAA;IACA,uBAAA;IACA,cAAA;IACA,SAAA;EArYN;AACF;AAjxFI;EA2oGA;IAaI,uBAAA;IACA,sBAAA;EAnYN;AACF;AAoYM;EAEE,kDAn1GA;EAo1GA,yBAAA;EACA,gBAAA;EACA,iBAAA;AAnYR;AAjyFI;EA+pGE;IAOI,eAAA;EAjYR;AACF;AAlyFI;EA2pGE;IAUI,gBAAA;EA/XR;AACF;AAnyFI;EAupGE;IAaI,gBAAA;EA7XR;AACF;AA+XM;EAEE,kDAh2GA;EAi2GA,eAAA;EACA,gBAAA;AA9XR;AArzFI;EA+qGE;IAMI,eAAA;EA5XR;AACF;AAkYI;EACE,YAAA;EACA,kDA72GE;EA82GF,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AAhYN;AAl0FI;EA4rGA;IAQI,eAAA;IACA,UAAA;EA9XN;AACF;AAkYE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAhYJ;AAmYI;EACE,mBAAA;EACA,uBAAA;EACA,kDAl4GE;EAm4GF,iBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AAjYN;AAkYM;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;AAhYR;AAmYI;EACE,uBAAA;EACA,YAAA;EACA,uBAAA;AAjYN;AAj2FI;EA0sGF;IA6BI,SAAA;IACA,mBAAA;EAlYJ;AACF;AAqYI;EACE,kDA55GE;AAyhGR;AA12FI;EA4uGA;IAII,eAAA;EAlYN;AACF;AAqYI;EACE,aAAA;EACA,SAAA;AAnYN;AAn3FI;EAovGA;IAKI,QAAA;EAlYN;AACF;AAmYM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAjYR;AA93FI;EA2vGE;IAOI,gBAAA;EAhYR;AACF;AAqYQ;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,kDA57GF;EA67GE,eAAA;AAnYV;AAsYU;EACE,6BAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AApYZ;AAsYU;EACE,wCAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AApYZ;AAsYU;EACE,6BAAA;AApYZ;AAsYU;EACE,6BAAA;AApYZ;AAsYU;EACE,YAAA;EACA,6BAAA;AApYZ;AAsYU;EACE,iBAAA;AApYZ;AAp6FI;EAwwGI;IAqCI,eAAA;IAEA,eAAA;IACA,gBAAA;EAtYV;AACF;AAwYQ;EACE,kBAAA;EACA,WAAA;AAtYV;AA/6FI;EAmzGI;IAII,eAAA;EApYV;AACF;AAyYE;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAvYJ;AA17FI;EA6zGF;IAMI,gBAAA;IACA,mBAAA;EArYJ;AACF;AAsYI;EACE,aAAA;EACA,qCAAA;EACA,UAAA;EACA,aAAA;AApYN;AAsYM;EACE;IACE,qCAAA;EApYR;AACF;AAuYM;EACE;IACE,qCAAA;EArYR;AACF;AAwYM;EACE;IACE,0BAAA;EAtYR;AACF;AAr9FI;EAs0GA;IAyBI,SAAA;EAtYN;AACF;AAt9FI;EAk0GA;IA4BI,8BAAA;EApYN;AACF;AAgeE;EACE,kDA/mHI;EAgnHJ,eAAA;EACA,iBAAA;EACA,mBAAA;AA9dJ;AAr+FI;EA+7GF;IAOI,gBAAA;IACA,eAAA;EA7dJ;AACF;AAieI;EACE,aAAA;AA/dN;AA9+FI;EA48GA;IAGI,SAAA;EA7dN;AACF;AA+dM;EACE,kBAAA;EACA,kDAnoHA;EAooHA,eAAA;AA7dR;AAx/FI;EAk9GE;IAKI,eAAA;IACA,kBAAA;EA3dR;AACF;AA+dM;EACE,eAAA;EACA,oBAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;AA7dR;AA8dQ;EAEE,iCAAA,EAAA,oCAAA;EACA,UAAA,EAAA,gCAAA;EACA,gEACE;AA9dZ;AA5gGI;EAq+GI;IAQI,cAAA;EA7dV;AACF;AA8dU;EACE,WAAA;AA5dZ;AAphGI;EA++GM;IAGI,WAAA;EA1dZ;AACF;AA6dQ;EACE,mBAAA;AA3dV;AA4dU;EACE,WAAA;AA1dZ;AA6dQ;EACE,cAAA;EAEA,YAAA;EACA,aAAA;AA5dV;AApiGI;EA69GE;IAsCI,YAAA;IACA,eAAA;IACA,oBAAA;EA3dR;AACF;AA8dM;EACE,WAAA;EACA,6DAAA;EAEA,aAAA;EACA,yBAAA;EACA,mBAAA;AA7dR;AA+dQ;EACE,gCAAA;AA7dV;AAieM;EACE,gBAAA;AA/dR;AAqeM;EACE,sBAAA;AAneR;AAueM;EACE,yBAAA;AAreR;AAseQ;EAEE,0BAAA,EAAA,iDAAA;EACA,UAAA;AAreV;AAlkGI;EA28GF;IAkGI,UAAA;EAveJ;AACF;AAnkGI;EAu8GF;IAqGI,eAAA;EAreJ;AACF;AAseI;EACE,gBAAA;AApeN;AAueI;EACE,gBAAA;AAreN;AAweI;EACE,SAAA;EACA,kDA3uHE;EA4uHF,eAAA;EACA,gBAAA;AAteN;AAxlGI;EA0jHA;IASI,eAAA;IACA,gBAAA;EAveN;AACF;AAyeI;EACE,kDAvvHE;EAwvHF,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AAveN;AA4eI;EAGE,YAAA,EAAA,mBAAA;EAEA,kBAAA,EAAA,oBAAA;EACA,eAAA,EAAA,6BAAA;AA7eN;AA8eM;EACE,WAAA;EACA,yBAAA;EAEA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AA7eR;AAtnGI;EAwlHE;IAaI,WAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;EA3eR;AACF;AA6eM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AA3eR;AA1oGI;EA2mHE;IAYI,WAAA;IACA,UAAA;IACA,YAAA;EAzeR;AACF;AAifE;EACE,8BAAA;AA/eJ;AAkfE;EACE,kDAtzHI;EAuzHJ,eAAA;AAhfJ;;AAqfE;EACE,aAAA;AAlfJ;;AAsfE;EACE,eAAA;EACA,kBAAA;EACA,UAAA;AAnfJ;AA1pGI;EA0oHF;IAKI,iBAAA;EAjfJ;AACF;AAvqGI;EAkpHF;IASI,mBAAA;IACA,kBAAA;IACA,oBAAA;IACA,WAAA;EAhfJ;AACF;AAifI;EAEE,SAAA;AAhfN;AAkfM;EACE,sDAAA;EACA,WAAA;EACA,YAAA;AAhfR;AAvrGI;EAgqHA;IAUI,sBAAA;IACA,SAAA;EA/eN;AACF;AAgfM;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AA9eR;AAtsGI;EA6qHE;IASI,SAAA;EA5eR;AACF;AA8eQ;EACE,eAAA;EACA,kDA12HF;EA22HE,gBAAA;AA5eV;AAhtGI;EAyrHI;IAKI,eAAA;EA1eV;AACF;AA4eQ;EACE,eAAA;EACA,kDAl3HF;EAm3HE,cAAA;AA1eV;AA1tGI;EAisHI;IAKI,eAAA;EAxeV;AACF;AA4eI;EACE,SAAA;EAEA,cAAA;AA3eN;AAnuGI;EA2sHA;IAMI,aAAA;EA1eN;AACF;AA4eI;EACE,eAAA;EACA,kDAr4HE;AA25GR;AA5uGI;EAotHA;IAII,eAAA;EAxeN;AACF;AA0eI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAxeN;AAyeM;EACE,kDA/4HA;EAg5HA,0BAAA;AAveR;AA0eI;EACE,eAAA;EACA,kDAr5HE;AA66GR;AA0eI;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,gBAAA;AAzeN;AA2eM;EACE,uBAAA;EACA,8CAAA;AAzeR;AA2eM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AAzeR;AA6eI;EACE,kDA16HE;EA26HF,eAAA;EACA,gBAAA;AA3eN;AAlxGI;EA0vHA;IAMI,eAAA;EA1eN;AACF;AA4eI;EACE,gBAAA;EACA,SAAA;EACA,aAAA;EACA,2BAAA;EACA,eAAA;AA1eN;AA9xGI;EAmwHA;IAOI,eAAA;IACA,SAAA;IACA,gBAAA;EAxeN;AACF;AAyeM;EAEE,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;AAxeR;AAyeQ;EACE,uBAAA;AAveV;AAyeQ;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,wBAAA;EACA,wCAAA;EACA,eAAA;AAveV;AAyeQ;EACE,YAAA;AAveV;AA3zGI;EA8wHE;IAuBI,aAAA;EAteR;AACF;AA8eE;EACE,uBAAA;EACA,eAAA;AA5eJ;AAp0GI;EA8yHF;IAII,iBAAA;IACA,oBAAA;EA1eJ;AACF;AA2eI;EACE,iBAAA;EACA,aAAA;EAEA,UAAA;EACA,2BAAA;AA1eN;AAh1GI;EAqzHA;IAOI,SAAA;IACA,8BAAA;EAxeN;AACF;AAyeM;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;AAveR;AAyeQ;EACE,kDAr/HF;EAu/HE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAxeV;AAn2GI;EAq0HI;IAQI,eAAA;EAteV;AACF;AAweQ;EACE,kDAhgIF;EAigIE,YAAA;EACA,eAAA;EACA,gBAAA;AAteV;AA92GI;EAg1HI;IAMI,eAAA;IACA,eAAA;EApeV;AACF;AAueM;EACE,SAAA;AAreR;AA0eE;EACE,0DAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,eAAA;EACA,oBAAA;AAxeJ;AA/3GI;EAi2HF;IAQI,iBAAA;IACA,oBAAA;EAteJ;AACF;AAweI;EACE,kDA7hIE;EA8hIF,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAteN;AA54GI;EA62HA;IAOI,eAAA;IACA,mBAAA;EApeN;AACF;AAseI;EAIE,kBAAA;AAveN;AAweM;EAEE,eAAA;AAveR;AAyeM;EACE,aAAA;EAEA,gBAAA;AAxeR;AA0eQ;EACE,WAAA;AAxeV;AAifE;EACE,uBAAA;EACA,eAAA;EACA,iBAAA;AA/eJ;AAp6GI;EAg5HF;IAKI,iBAAA;IACA,oBAAA;EA7eJ;AACF;AA8eI;EACE,iBAAA;AA5eN;AA8eQ;EACE,eAAA;EACA,aAAA;EAEA,uBAAA;AA7eV;AAl7GI;EA25HI;IAMI,sBAAA;IACA,eAAA;IACA,aAAA;IACA,uBAAA;EA3eV;AACF;AA4eU;EACE,mBAAA;AA1eZ;AA4eU;EACE,WAAA;AA1eZ;AA2eY;EACE,kDA3lIN;EA4lIM,eAAA;EAEA,uBAAA;EAAA,kBAAA;AA1ed;AAr8GI;EA26HQ;IAMI,eAAA;EAxed;AACF;AA4eU;EACE,SAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;AA1eZ;AA4eY;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AA1ed;AAt9GI;EA47HQ;IASI,QAAA;IACA,WAAA;EA3ed;AACF;AA6ec;EACE,eAAA;EACA,kDA1nIR;EA8nIQ,kBAAA;EACA,gBAAA;AA9ehB;AA0egB;EACE,YAAA;AAxelB;AAr+GI;EAy8HU;IASI,eAAA;IACA,gBAAA;IACA,gBAAA;EAzehB;EA0egB;IACE,WAAA;EAxelB;AACF;AA2ec;EACE,eAAA;EACA,kDA3oIR;EA6oIQ,YAAA;AA1ehB;AAp/GI;EA09HU;IAOI,iBAAA;EAzehB;AACF;AA2ec;EAj9HZ,aAAA;EAm9Hc,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,cA9oIR;AAyqHR;AAuegB;EACE,eAAA;AArelB;AAxgHI;EAo+HU;IAYI,uBAAA;EApehB;AACF;AAueY;EACE,kDApqIN;EAqqIM,gBAAA;EACA,eAAA;EACA,YAAA;AAred;AAnhHI;EAo/HQ;IAMI,eAAA;IACA,eAAA;EAned;AACF;AAseY;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,yBAAA;AAped;AA/hHI;EA+/HQ;IAOI,WAAA;IACA,gBAAA;IAEA,mBAAA;IACA,SAAA;EAped;AACF;AAviHI;EA6gIU;IAGI,SAAA;EArehB;AACF;AAyeY;EACE;IACE,qCAAA;IACA,SAAA;EAved;AACF;AA0eY;EACE;IACE,qCAAA;EAxed;AACF;AA2eY;EACE;IACE,qCAAA;IACA,SAAA;IACA,aAAA;IACA,WAAA;IACA,uBAAA;EAzed;AACF;AA2eY;EACE,aAAA;EACA,qCAAA;EACA,oBAAA;EACA,SAAA;AAzed;AAtkHI;EA2iIQ;IAOI,aAAA;IACA,qCAAA;IACA,SAAA;IACA,gBAAA;IACA,kBAAA;IAEA,SAAA;EAzed;AACF;AA0ec;EACE;IACE,qCAAA;IACA,SAAA;EAxehB;AACF;AA2ec;EACE;IACE,qCAAA;EAzehB;AACF;AA4ec;EACE;IACE,qCAAA;IACA,SAAA;IACA,aAAA;IACA,WAAA;EA1ehB;AACF;AAmfE;EACE,eAAA;AAjfJ;AAtmHI;EAslIF;IAGI,eAAA;EA/eJ;AACF;AAkfM;EACE,kDA7wIA;EA8wIA,eAAA;EACA,mBAAA;EACA,kBAAA;AAhfR;AAjnHI;EA6lIE;IAMI,eAAA;EA9eR;AACF;AAgfM;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AA9eR;AA3nHI;EAsmIE;IAKI,qCAAA;IAEA,SAAA;EA7eR;AACF;AA+eQ;EACE,aAAA;EACA,aAAA;EACA,sBAAA;AA7eV;AA+eU;EACE,6DAAA;AA7eZ;AAmfU;EACE,gBAAA;AAjfZ;AAmfU;EAGE,0DAAA;AAnfZ;AAqfU;EACE,qBAAA;AAnfZ;AAsfU;EAEE,mBAAA;AArfZ;AAwfY;EACE,eAAA;EACA,kDA9zIN;EA+zIM,eAAA;AAtfd;AA1pHI;EA6oIQ;IAKI,eAAA;EApfd;AACF;AAsfY;EACE,kDAr0IN;EAs0IM,eAAA;EACA,gBAAA;EACA,kBAAA;AApfd;AArqHI;EAqpIQ;IAMI,eAAA;IACA,kBAAA;EAlfd;AACF;AAofY;EACE,kDA/0IN;EAg1IM,eAAA;EACA,8BAAA;EACA,2BAAA;EAAA,sBAAA;AAlfd;AAsfY;EACE,WAAA;EACA,iCAAA,EAAA,oCAAA;EACA,UAAA,EAAA,gCAAA;EACA,gEACE;AArfhB;AAvrHI;EA+qIQ;IAEI,WAAA;IACA,mBAAA;EAtfd;AACF;AA2fY;EACE,0BAAA,EAAA,iDAAA;EACA,UAAA;AAzfd;;AAkgBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AA/fF;AAkgBE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,+CAAA;EACA,4CAAA;AAhgBJ;AAmgBE;EACE,QAAA;AAjgBJ;AAmgBE;EACE,QAAA;AAjgBJ;;AAqgBA;EACE;IACE,oBAAA;EAlgBF;EAogBA;IACE,yBAAA;EAlgBF;AACF;AAqgBA;EACE,iDA35IK;EA45IL,0BAAA;AAngBF;;AAsgBA;EACE,SAAA;EACA,uCAAA;EACA,UAAA;AAngBF;;AAsgBA;EACE,UAAA;EACA,WAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,mBAAA;EACA,0BAAA;EACA,+CAAA;AAngBF;;AAsgBA;EACE,UAAA;EACA,WAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,mBAAA;EACA,mBAAA;AAngBF;AArwHI;EA+vIJ;IAYI,YAAA;IACA,UAAA;IACA,WAAA;IACA,+BAAA;EAlgBF;AACF;;AAqgBA;EACE;IACE,wCAAA;IACA,YAAA;EAlgBF;EAogBA;IACE,uCAAA;IACA,YAAA;EAlgBF;EAogBA;IACE,wCAAA;IACA,YAAA;EAlgBF;AACF;AAqgBA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAngBF;AAsgBE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,yBAAA;AApgBJ;AAsgBE;EACE,yBAAA;EACA,WAAA;EACA,iBAAA;AApgBJ;;AAwgBA;EAEE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;AAtgBF;AAzzHI;EA0zIJ;IASI,gBAAA;IACA,gBAAA;IACA,qBAAA;IACA,kBAAA;EAtgBF;AACF;;AAygBA;EACE;IACE,4BAAA;EAtgBF;EAwgBA;IACE,UAAA;IACA,2BAAA;EAtgBF;EAwgBA;IACE,UAAA;EAtgBF;AACF;AAygBA;EACE,wBAAA;AAvgBF;;AA0gBA;EACE,kBAAA;EACA,oBAAA;AAvgBF;AAt1HI;EA21IJ;IAII,kBAAA;IACA,oBAAA;EArgBF;AACF;AAsgBE;EAcE,aAAA;EACA,mBAAA;EACA,8BAAA;AAjhBJ;AAkgBI;EACE,gBAAA;EACA,kDAvhJE;EAwhJF,yBAAA;EACA,iBAAA;EACA,mBAAA;AAhgBN;AAx2HI;EA22IE;IACE,eAAA;IACA,kBAAA;EAhgBN;AACF;AAqgBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,kDAviJE;AAoiIR;AAr3HI;EAm3IA;IAQI,kBAAA;EAlgBN;AACF;AAqgBE;EACE,iBAAA;EA72IF,aAAA;EA+2IE,SAAA;EACA,eAAA;EAEA,aAAA;AAhgBJ;AAogBI;EAt3IF,aAAA;EA23II,uBAAA;EACA,SAAA;EACA,8BAAA;EACA,oBAAA;AAjgBN;AAh5HI;EAy4IA;IAWI,iCAAA;IACA,oBAAA;EAhgBN;AACF;AAkgBM;EACE,mBAAA;AAhgBR;AAmgBM;EACE,SAAA;AAjgBR;AA55HI;EA45IE;IAGI,WAAA;EA/fR;AACF;AAkgBM;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;EAEA,YAAA;AAjgBR;AAkgBQ;EACE,yBAAA;AAhgBV;AA56HI;EAm6IE;IAYI,QAAA;EA/fR;AACF;AAigBM;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;EACA,QAAA;AA/fR;AAx7HI;EAk7IE;IAOI,QAAA;EA7fR;AACF;AA+fM;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;AA7fR;AAl8HI;EA47IE;IAKI,gBAAA;EA3fR;AACF;AA4fQ;EACE,iCAAA,EAAA,oCAAA;EACA,UAAA,EAAA,gCAAA;EACA,gEACE;EAEF,qBAAA;EACA,WAAA;AA5fV;AA98HI;EAm8II;IASI,WAAA;EA1fV;AACF;AA8fM;EAGE,gBAAA;AA9fR;AAggBQ;EACE,sCAAA,EAAA,8BAAA;EACA,mBAAA,EAAA,yBAAA;EACA,sBAAA,EAAA,mCAAA;EACA,wBAAA;AA9fV;AAqgBM;EACE,sBAAA;AAngBR;AAqgBM;EACE,sBAAA;AAngBR;AAqgBM;EAEE,0BAAA,EAAA,iDAAA;EACA,UAAA;AApgBR;AAsgBM;EACE,0BAAA;EACA,UAAA;AApgBR;AAwgBM;EACE,kDAlqJA;EAmqJA,eAAA;EACA,gBAAA;AAtgBR;AA/+HI;EAk/IE;IAKI,eAAA;EApgBR;AACF;AAsgBM;EACE,kDA1qJA;EA2qJA,eAAA;AApgBR;AAx/HI;EA0/IE;IAKI,eAAA;EAngBR;AACF;AAqgBM;EACE,eAAA;EACA,kDAnrJA;EAorJA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAngBR;AAvgII;EAkgJE;IAUI,kBAAA;IACA,eAAA;IACA,iBAAA;EAjgBR;AACF;AA9gII;EAy4IA;IA0II,mBAAA;IACA,SAAA;IACA,oBAAA;IACA,0BAAA;EAjgBN;AACF;AAthII;EA+3IF;IA2JI,gBAAA;IACA,aAAA;EAhgBJ;AACF;AAshBA,cAAA;AACA;;EAEE,aAAA;AAphBF;;AAuhBA;EACE,eAAA;AAphBF;;AAuhBA;EACE,yCAAA;EACA,YAAA;EACA,iBAAA;EAEA,eAAA;EACA,kDAjvJM;EAkvJN,yBAAA;EACA,UAAA;EAEA,wBAAA;EACA,eAAA;AAthBF;AAuhBE;EAEE,YAAA;AAthBJ;;AA0hBA;EACE,kBAAA;EA5jJA,aAAA;EA8jJA,gBAAA;EACA,uBAAA;AAnhBF;AA/jII;EA8kJJ;IAMI,gBAAA;EAjhBF;AACF;;AAohBA;EACE,sBAAA;EACA,uBAAA;AAjhBF;AAkhBE;EACE,aAAA;AAhhBJ;;AAohBA;EACE,WAAA;EACA,YAAA;AAjhBF;;AAohBA;EACE,yBAAA;AAjhBF;AAkhBE;EACE,YAAA;AAhhBJ;;AAohBA,sBAAA;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAlhBF;AAlmII;EA8mJJ;IAWI,gBAAA;IACA,gBAAA;IACA,mBAAA;IACA,aAAA;EAnhBF;AACF;AAqhBE;EACE,kBAAA;EAMA,mBAAA;EACA,eAAA;EACA,sBAAA;AAxhBJ;AA0hBI;EACE,WAAA;AAxhBN;AA+hBI;EAQE,gBAAA;EACA,kDA10JE;EA20JF,eAAA;AApiBN;AAxnII;EAkpJA;IAaI,WAAA;IACA,SAAA;IACA,eAAA;IACA,kDAj1JA;IAk1JA,eAAA;EAniBN;AACF;AAuiBE;EACE,gBAAA;EACA,kDA51JI;EA61JJ,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AAriBJ;AAzoII;EAwqJF;IASI,eAAA;IACA,kDAj2JE;IAk2JF,eAAA;EApiBJ;AACF;AA5oII;EAoqJF;IAeI,eAAA;EAniBJ;AACF;;AAuiBA;EACE,gBAAA;AApiBF;;AAwiBE;EACE,iBAAA;EACA,cAAA;EACA,UAAA;AAriBJ;AA/pII;EAisJF;IAWI,gBAAA;EAziBJ;AACF;AA2iBE;EACE,eAAA;AAziBJ;AAvqII;EA+sJF;IAGI,eAAA;EAviBJ;AACF;AA5qII;EAotJA;IAEI,YAAA;EAtiBN;AACF;AAwiBI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAtiBN;AAyiBI;EACE,aAAA;EACA,mBAAA;AAviBN;AAyiBM;EACE,eAAA;EACA,kDAr5JC;EAs5JD,kBAAA;EACA,kBAAA;EACA,cAAA;AAviBR;AAjsII;EAmuJE;IAOI,eAAA;EAriBR;AACF;AAyiBI;EACE,cAAA;AAviBN;AA0iBI;;EAEE,8BA90JK;EA+0JL,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AAxiBN;AA2iBI;EACE,uBAAA;EACA,kBAAA;EACA,iBAAA;AAziBN;AAvtII;EA6vJA;IAKI,cAAA;IACA,eAAA;EAviBN;AACF;AA0iBI;EAGE,6BAAA;EACA,yNAAA;EAWA,YAAA;AApjBN;AAujBI;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AArjBN;AAujBM;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;AArjBR;AAwjBM;EACE,4CAAA;AAtjBR;AAyjBM;EACE,UAAA;AAvjBR;AA0jBM;EACE,8CAAA;AAxjBR;AA4jBI;EACE;IACE,eAAA;IACA,UAAA;IACA,QAAA;IACA,WAAA;IACA,uBAAA;IACA,sBAAA;IACA,mBAAA;IACA,aAAA;IACA,wCAAA;IACA,yBAAA;EA1jBN;EA4jBM;IAEE,kBAAA;IACA,MAAA;IACA,aAAA;IACA,sBAAA;IACA,aAAA;IACA,uBAAA;IACA,SAAA;IACA,UAAA;EA3jBR;EA+jBI;IACE,aAAA;EA7jBN;AACF;AAgkBE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AA9jBJ;AAikBE;EACE,qBAAA;EACA,yNAAA;EAYA,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AA1kBJ;AAglBM;EACE,gBAAA;EACA,+BAh9JI;EAi9JJ,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AA9kBR;AA9yII;EAs3JE;IAQI,kBAAA;IAEA,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,mBAAA;EA7kBR;AACF;AAnzII;EAk3JE;IAgBI,eAAA;IACA,kBAAA;IACA,iBAAA;EA3kBR;AACF;AA6kBM;EAEE,aAAA;EACA,qCAAA;EACA,SAAA;AA5kBR;AAn0II;EA24JE;IAQI,aAAA;IACA,qCAAA;IACA,SAAA;EA5kBR;AACF;AA8kBM;EACE,aAAA;EACA,SAAA;AA5kBR;AA90II;EAw5JE;IAII,mBAAA;IACA,sBAAA;EA1kBR;AACF;AA4kBM;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA1kBR;AA2kBQ;EAEE,8BAngKC;EAogKD,cAAA;EACA,eAAA;AA1kBV;AA6kBM;EACE,cAAA;EACA,8BA1gKG;EA2gKH,iBAAA;EACA,eAAA;EACA,gBAAA;AA3kBR;AAz2II;EA+6JE;IAOI,gBAAA;IACA,eAAA;IACA,kBAAA;EAzkBR;AACF;AA2kBM;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;AAzkBR;AAr3II;EA27JE;IAKI,gBAAA;EAvkBR;AACF;AAykBM;EACE,8BA7hKG;EA8hKH,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;AAvkBR;AAykBM;EACE,8BAviKG;EAwiKH,eAAA;EACA,iBAAA;EACA,kBAAA;EAEA,mBAAA;EAEA,6BAAA;EACA,yNAAA;EAWA,YAAA;EACA,uBAAA;AAnlBR;AAslBM;EACE,aAAA;EACA,QAAA;EACA,kBAAA;AAplBR;AAp5II;EAq+JE;IAKI,sBAAA;IACA,oBAAA;EAllBR;AACF;AAolBQ;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,yNAAA;AAllBV;AAh6II;EA8+JI;IAiBI,aAAA;EA3lBV;AACF;AA6lBQ;EACE,WAAA;AA3lBV;AA8lBQ;EAGE,gBAAA;EAEA,mBAAA;EACA,aAAA;EACA,sBAAA;AA/lBV;AAmmBU;EAKE,kBAAA;EAEA,WAAA;AAtmBZ;AA4mBU;EAEE,eAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AA3mBZ;AAx7II;EA8hKM;IASI,QAAA;EA3mBZ;EA6mBY;IACE,kBAAA;EA3mBd;AACF;AA+mBU;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,UAAA;EACA,QAAA;AA7mBZ;AAv8II;EA+iKM;IAOI,aAAA;IACA,qCAAA;EA3mBZ;AACF;AA8mBU;EACE,+BAppKA;EAqpKA,eAAA;EACA,gBAAA;EACA,gBAAA;AA5mBZ;AA8mBU;EACE,UAAA;EACA,gBAAA;AA5mBZ;AA+mBU;EAEE,uBAAA;EAEA,UAAA;AA/mBZ;AAknBU;EACE,kBAAA;EACA,+BAvqKA;EAwqKA,YAAA;EACA,eAAA;EACA,oBAAA;AAhnBZ;AAunBU;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AArnBZ;AAunBU;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AArnBZ;AA5+II;EA8lKM;IAMI,aAAA;IACA,sBAAA;EApnBZ;AACF;AAunBU;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,+BArsKA;EAssKA,eAAA;AArnBZ;AAz/II;EAymKM;IAOI,eAAA;EAnnBZ;AACF;AAqnBU;EAEE,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;EACA,8BA7oKA;AAyhJZ;AAunBU;;EAEE,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;EACA,8BAxpKA;AAmiJZ;AAwnBU;EACE,YAAA,EAAA,2BAAA;EAEA,eAAA,EAAA,cAAA;EACA,YAAA,EAAA,6BAAA;EACA,8BAhqKA;EAiqKA,0BAAA;AAvnBZ;AA2nBU;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAhvKA;AAunJZ;AA/hJI;EAmpKM;IAOI,eAAA;EAvnBZ;AACF;AA0nBU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,8CACE;AAznBd;AA7iJI;EA8pKM;IAWI,YAAA;EAxnBZ;AACF;AA2nBU;EACE,yBAAA;EACA,qBAAA;AAznBZ;AA4nBU;EACE,iBAAA;AA1nBZ;AA6nBU;EACE,UAAA;EACA,eAAA;EACA,SAAA;AA3nBZ;AA8nBU;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AA5nBZ;AA+nBU;EACE,yBAAA;AA7nBZ;AAgoBU;EACE,kBAAA;EAGA,kBAAA;AAhoBZ;AA/kJI;EA2sKM;IAOI,kBAAA;IACA,iBAAA;EA/nBZ;AACF;AAkoBU;EACE,aAAA;AAhoBZ;AAsoBU;EACE,cAAA;EACA,+BAxzKA;EAyzKA,eAAA;EACA,mBAAA;AApoBZ;AA9lJI;EA8tKM;IAMI,eAAA;EAloBZ;AACF;AAooBU;EACE,cAAA;EACA,8BAl0KD;EAm0KC,eAAA;EACA,mBAAA;AAloBZ;AAzmJI;EAuuKM;IAMI,eAAA;EAhoBZ;AACF;AAmoBU;EACE,uBAAA;EACA,kBAAA;EACA,4BA70KD;EA80KC,eAAA;EAEA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAloBZ;AAqoBU;EACE,yBAAA;AAnoBZ;AAyoBI;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;AAvoBN;AA0oBM;EACE,kBAAA;EACA,uBAAA;AAxoBR;AA3oJI;EAuwKA;IAeI,WAAA;EAvoBN;AACF;AA0oBI;EACE,kBAAA;AAxoBN;AA0oBM;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;AAxoBR;AAxpJI;EA6xKE;IAKI,gBAAA;EAtoBR;AACF;AAyoBM;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvoBR;AA0oBM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;AAxoBR;AA0oBM;EACE,YAAA;AAxoBR;AA4oBI;EACE,kBAAA;AA1oBN;AA2oBM;EACE,kBAAA;AAzoBR;AA2oBM;EACE,eAAA;EACA,iBAAA;EACA,+BA35KI;AAkxJZ;AA1rJI;EAg0KE;IAKI,eAAA;IACA,iBAAA;EAvoBR;AACF;AAyoBM;EACE,gBAAA;EACA,eAAA;EACA,kDA5/KC;EA6/KD,iBAAA;AAvoBR;AA2oBI;EACE,iBAAA;AAzoBN;AAzsJI;EAi1KA;IAGI,gBAAA;EAvoBN;AACF;AAwoBM;EAEE,aAAA;EACA,uBAAA;AAvoBR;AAyoBM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAvoBR;AAyoBM;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAvoBR;AAyoBQ;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAx8KC;EAy8KD,kBAAA;AAvoBV;AAzuJI;EA02KI;IAQI,eAAA;IACA,gBAAA;EAroBV;AACF;AAuoBQ;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAp9KC;EAq9KD,kBAAA;AAroBV;AAvvJI;EAs3KI;IAQI,eAAA;IACA,gBAAA;EAnoBV;AACF;AAwoBI;EACE,kBAAA;AAtoBN;AAuoBM;EACE,iBAAA;EACA,YAAA;AAroBR;AAuoBM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAroBR;AA1wJI;EA24KE;IAMI,sBAAA;EAnoBR;AACF;AAqoBM;EACE,SAAA;AAnoBR;AAqoBM;EACE,SAAA;AAnoBR;AAqoBM;EACE,eAAA;EACA,iBAAA;EACA,+BAr/KI;AAk3JZ;AA1xJI;EA05KE;IAKI,iBAAA;EAjoBR;AACF;AAmoBM;EACE,eAAA;EACA,kDAplLC;EAqlLD,iBAAA;EAEA,YAAA;AAloBR;AAooBM;EACE,gBAAA;EACA,eAAA;EACA,8BArgLG;EAsgLH,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,SAAA;AAnoBR;AAuoBI;EACE,gBAAA;EACA,qBAAA;EACA,wDAAA;AAroBN;AAnzJI;EAq7KA;IAKI,cAAA;IACA,qBAAA;IACA,yDAAA;EAnoBN;AACF;AAooBM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAloBR;AA/zJI;EA87KE;IAKI,cAAA;EAhoBR;AACF;AAkoBM;EACE,+BA/hLI;EAgiLJ,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAhoBR;AA50JI;EAs8KE;IAQI,eAAA;IACA,gBAAA;IACA,mBAAA;EA9nBR;AACF;AAgoBM;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;AA9nBR;AA31JI;EAm9KE;IAQI,gBAAA;IACA,cAAA;IACA,WAAA;IACA,kBAAA;IACA,cAAA;IACA,SAAA;IAEA,SAAA;IACA,MAAA;IACA,6BAAA;IACA,aAAA;EA7nBR;AACF;AA+nBM;EACE,iBAAA;AA7nBR;AA+nBM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AA7nBR;AAn3JI;EA2+KE;IAOI,eAAA;IACA,WAAA;EA3nBR;AACF;AA6nBM;EACE,cAAA;AA3nBR;AA6nBM;EACE,cAAA;AA3nBR;AA6nBM;;EAEE,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA,EAAA,gCAAA;EACA,QAAA;EACA,2BAAA,EAAA,sBAAA;EACA,WAAA,EAAA,8BAAA;EACA,eAAA;AA3nBR;AAioBM;EACE,0DAAA;AA/nBR;AA/4JI;EA6gLE;IAGI,WAAA;IACA,WAAA;EA7nBR;AACF;AAj5JI;EAygLE;IAOI,YAAA;EA3nBR;AACF;AA8nBM;EACE,0DAAA;AA5nBR;AA75JI;EAwhLE;IAGI,WAAA;IACA,UAAA;EA1nBR;AACF;AA/5JI;EAohLE;IAOI,WAAA;EAxnBR;AACF;AA0nBM;;EAEE,eAAA;EACA,iBAAA;EACA,8BA/nLG;EAgoLH,gBAAA;EACA,cAAA;AAxnBR;AAh7JI;EAkiLE;;IAQI,kBAAA;EArnBR;AACF;AAunBM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BA1oLG;EA2oLH,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AArnBR;AAh8JI;EA6iLE;IAUI,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,gBAAA;EAnnBR;AACF;AAunBI;EACE,eAAA;AArnBN;AAwnBM;EACE,eAAA;EACA,iBAAA;EACA,+BA9pLI;EA+pLJ,kBAAA;AAtnBR;AAj9JI;EAmkLE;IAMI,eAAA;IACA,iBAAA;EApnBR;AACF;AAunBM;EACE,eAAA;EACA,iBAAA;EACA,+BAzqLI;EA0qLJ,kBAAA;EACA,mBAAA;AArnBR;AAwnBM;EACE,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAtnBR;AAt+JI;EAslLE;IASI,4BAAA;EArnBR;AACF;AAunBM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,gCAAA;AAtnBR;AAwnBM;EACE,eAAA;EACA,+BAnsLI;EAosLJ,iBAAA;AAtnBR;AAt/JI;EAymLE;IAKI,iBAAA;EApnBR;AACF;AAsnBM;EACE,eAAA;EACA,+BA3sLI;EA4sLJ,iBAAA;AApnBR;AAwnBI;EACE,iBAAA;AAtnBN;AAunBM;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,+BAttLI;EAutLJ,kBAAA;EACA,mBAAA;AArnBR;AA3gKI;EA0nLE;IAQI,eAAA;IACA,gBAAA;EAnnBR;AACF;AAqnBM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AAnnBR;AAsnBM;EACE,aAAA;EACA,WAAA;EAGA,kBAAA;AAtnBR;AA9hKI;EA+oLE;IAQI,sBAAA;EArnBR;AACF;AAwnBM;EACE,UAAA;AAtnBR;AAtiKI;EA2pLE;IAGI,WAAA;EApnBR;AACF;AAunBM;EACE,kBAAA;AArnBR;AAwnBM;EACE,UAAA;AAtnBR;AAjjKI;EAsqLE;IAGI,WAAA;EApnBR;AACF;AAunBM;EAEE,aAAA;EACA,iBAAA;EACA,oBAAA;EAKA,YAAA;EACA,kBAAA;AA1nBR;AA4nBM;EACE,eAAA;EACA,+BAnxLI;EAoxLJ,iBAAA;EACA,cAAA;EACA,mBAAA;AA1nBR;AA4nBM;EACE,eAAA;EACA,8BA3xLG;EA4xLH,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AA1nBR;AA6nBM;EACE,+CAAA;EACA,UAAA,EAAA,sDAAA;AA3nBR;AA6nBM;EACE,8CAAA,EAAA,sDAAA;EACA,UAAA,EAAA,sDAAA;AA3nBR;AA6nBM;EACE,8CAAA,EAAA,sDAAA;EACA,UAAA,EAAA,sDAAA;AA3nBR;AA8nBM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,wCAAA;EACA,kBAAA;EACA,WAAA;AA5nBR;AA8nBM;EACE,SAAA;EACA,WAAA;EACA,2BAAA;EACA,WAAA;AA5nBR;AA+nBM;EACE,SAAA;EACA,WAAA;EACA,2BAAA;EACA,MAAA;EACA,WAAA;AA7nBR;AA+nBM;EACE,mBAAA;AA7nBR;AAgoBM;EACE,mBAAA;AA9nBR;AApnKI;EAivLE;IAGI,kBAAA;IACA,+CAAA;EA5nBR;AACF;AA8nBM;EACE,oBAAA;AA5nBR;AA7nKI;EAwvLE;IAGI,aAAA;EA1nBR;AACF;AA6nBM;EACE,yBAAA;EACA,YAAA;AA3nBR;AA6nBM;EACE,yBAAA;EACA,YAAA;AA3nBR;AA1oKI;EA2wLF;IAEI,iBAAA;EA/nBJ;AACF;AAkoBE;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhoBJ;AAkoBE;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;EACA,SAAA;AAhoBJ;AA9pKI;EAuxLF;IAUI,8BAAA;IACA,SAAA;EA/nBJ;AACF;AAgoBI;EACE,SAAA;AA9nBN;AAioBI;EACE,gBAAA;EACA,eAAA;EACA,8BAp4LK;EAq4LL,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,SAAA;AAhoBN;AAmoBE;;EAEE,SAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjoBJ;AAxrKI;EAmzLF;;IAQI,kBAAA;IACA,SAAA;EA9nBJ;AACF;AAgoBE;EACE,gBAAA;AA9nBJ;AAgoBE;EAEE,kBAAA;EACA,WAAA;EAEA,UAAA;EACA,cAAA;AAhoBJ;AAkoBI;EACE,eAAA;EACA,iBAAA;EACA,+BAr6LM;AAqyKZ;AA7sKI;EA00LA;IAKI,eAAA;IACA,iBAAA;EA9nBN;AACF;AAgoBI;EACE,eAAA;EACA,kDArgMG;EAsgMH,iBAAA;EAEA,YAAA;AA/nBN;AAztKI;EAm1LA;IAOI,eAAA;IACA,gBAAA;EA7nBN;AACF;AAgoBE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,UAAA;EACA,gBAAA;AA9nBJ;AAxuKI;EA+1LF;IASI,YAAA;IACA,aAAA;EA5nBJ;AACF;AA1uKI;EA21LF;IAaI,YAAA;IACA,aAAA;EA1nBJ;AACF;AA4nBI;EACE,0DAAA;AA1nBN;AA4nBI;EACE,0DAAA;AA1nBN;AA4nBI;EACE,0DAAA;AA1nBN;AA4nBI;EACE,0DAAA;AA1nBN;AA4nBI;EACE,0DAAA;AA1nBN;AA+tBE;EACE,iBAAA;AA7tBJ;AA+tBI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,+BAnkMM;AAs2KZ;AA9wKI;EAq+LA;IASI,eAAA;IACA,gBAAA;EA5tBN;AACF;AA+tBI;EACE,UAAA;EACA,cAAA;AA7tBN;AAguBI;EACE,wCAAA;EACA,mBAAA;EACA,mBAAA;AA9tBN;AAiuBI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,2BAAA;EACA,yBAAA;AA/tBN;AAiuBM;EACE,eAAA;EACA,WAAA;AA/tBR;AAlzKI;EA8/LA;IAuBI,aAAA;IACA,QAAA;EA/tBN;EAguBM;IACE,eAAA;IACA,iBAAA;EA9tBR;AACF;AAkuBI;EACE,aAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAhuBN;AAkuBM;EACE,kBAAA;AAhuBR;AAmuBM;EACE,8BAtoMG;AAq6KX;AA50KI;EA8hMA;IAmBI,eAAA;EAjuBN;AACF;AAouBI;EAEE,8BAhpMK;EAipML,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAnuBN;AAsuBI;EACE,kBAAA,EAAA,yDAAA;AApuBN;AAwuBE;EACE,kBAAA;AAtuBJ;AA91KI;EAmkMF;IAGI,iBAAA;EApuBJ;AACF;AA/1KI;EA+jMF;IAMI,kBAAA;EAluBJ;AACF;AAmuBI;EACE,aAAA;EACA,yBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAjuBN;AA/2KI;EA2kMA;IAOI,sBAAA;IACA,aAAA;EA/tBN;AACF;AAiuBM;EACE,8BAhrMG;EAirMH,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AA/tBR;AAiuBM;EACE,8BAvrMG;EAwrMH,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AA/tBR;AAn4KI;EA6lME;IAOI,eAAA;EA7tBR;AACF;AAkuBE;EACE,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0DAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;AAhuBJ;AAn5KI;EA0mMF;IAWI,0DAAA;IACA,2BAAA;IACA,wBAAA;IACA,4BAAA;IACA,oBAAA;IACA,gBAAA;EA9tBJ;AACF;AA+tBI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AA7tBN;AAl6KI;EA4nMA;IAOI,sBAAA;IACA,SAAA;EA7tBN;AACF;AA+tBM;EACE,8BA1pMI;EA2pMJ,eAAA;EACA,YAAA;AA7tBR;AAguBI;EACE,YAAA;AA9tBN;AAh7KI;EA6oMA;IAGI,YAAA;EA5tBN;AACF;AA8tBI;EACE,aAAA;EACA,mBAAA;AA5tBN;AA6tBM;EACE,cAAA;AA3tBR;AA57KI;EAmpMA;IAQI,sBAAA;IACA,SAAA;EA3tBN;AACF;AA6tBI;EACE,eAAA;EACA,kDAj1MG;EAk1MH,kBAAA;EACA,kBAAA;EACA,YAAA;AA3tBN;AAz8KI;EA+pMA;IAOI,eAAA;EAztBN;AACF;AA4tBI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;AA1tBN;AA2tBM;EACE,YAAA;AAztBR;AA39KI;EA0qMA;IAaI,YAAA;EAxtBN;AACF;AA2tBI;EACE,YAAA;EACA,eAAA;EACA,kDA92MG;EA+2MH,iBAAA;EACA,kBAAA;EAEA,YAAA;AA1tBN;AAx+KI;EA2rMA;IAWI,eAAA;IACA,WAAA;IACA,WAAA;IACA,gBAAA;IACA,kBAAA;IACA,YAAA;EA1tBN;AACF;;AA8tBA;EACE,eAAA;AA3tBF;AA6tBI;EACE,iDAv4MC;EAw4MD,eAAA;EACA,kBAAA;EACA,oBAAA;AA3tBN;AA6tBI;EACE,kDA54ME;EA64MF,eAAA;AA3tBN;AA6tBI;EACE,2BA9uMG;EA+uMH,eAAA;EACA,cAAA;AA3tBN;AA6tBI;EACE,8BArvMM;EAsvMN,eAAA;EACA,cAAA;AA3tBN;;AAwuBE;EACE,gBAAA;EACA,cAAA;EACA,UAAA;AAruBJ;AA5gLI;EA8uMF;IAMI,UAAA;IACA,gBAAA;IACA,cAAA;EApuBJ;AACF;AAvhLI;EAkvMF;IAYI,YAAA;IAEA,cAAA;EApuBJ;AACF;AAuuBE;EACE,iBAAA;EACA,cAAA;EACA,UAAA;AAruBJ;AA9hLI;EAgwMF;IAMI,UAAA;IACA,gBAAA;IACA,cAAA;EApuBJ;AACF;AAziLI;EAowMF;IAYI,YAAA;IAEA,cAAA;EApuBJ;AACF;AAuuBE;EACE,0DAAA;EACA,sBAAA;EA3CA,4BAAA;EACA,2BAAA;AAzrBJ;AAsuBI;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AApuBN;AA7jLI;EA2xMA;IASI,oBAAA;IACA,iBAAA;EAnuBN;AACF;AAquBM;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AAnuBR;AAzkLI;EAwyME;IAOI,YAAA;IACA,YAAA;IACA,kBAAA;IACA,QAAA;EAluBR;AACF;AAouBQ;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAluBV;AAouBU;EACE,eAAA;AAluBZ;AAquBU;EACE,kBAAA;EACA,2BAv1MH;EAw1MG,eAAA;EACA,gBAAA;AAnuBZ;AAtmLI;EAq0MM;IAOI,eAAA;EAluBZ;AACF;AAuuBM;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EAAA,kBAAA;AAruBR;AAuuBQ;EACE,eAAA;EACA,kBAAA;EACA,8BA/2ME;EAg3MF,eAAA;EACA,kBAAA;AAruBV;AA1nLI;EA01MI;IAQI,oBAAA;EApuBV;AACF;AAuuBQ;EAn1MN,aAAA;EAq1MQ,oBAAA;EACA,SAAA;AAjuBV;AAmuBU;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAluBZ;AAouBY;EACE,kBAAA;AAluBd;AAouBc;EACE,kBAAA;EACA,UAAA;EAEA,UAAA;EACA,gCAAA;EACA,eAAA;AAnuBhB;AAuuBY;EACE,YAAA;AAruBd;AAwuBY;EACE,WAAA;AAtuBd;AA4uBM;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AA1uBR;AA4uBQ;EACE,cAAA;EACA,cAAA;AA1uBV;AA6uBQ;EACE,eAAA;EACA,2BAx6MD;EA06MC,cAAA;EACA,kBAAA;AA5uBV;AA/qLI;EAs5MI;IAQI,eAAA;EA3uBV;AACF;AA+uBM;EACE,kBAAA;EACA,WAAA;EACA,8BAx7MI;EAy7MJ,eAAA;AA7uBR;AA1rLI;EAm6ME;IAOI,eAAA;EA5uBR;AACF;AA+uBM;EACE,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,8BAr8MI;EAs8MJ,uBAAA;EACA,cAh8MC;EAi8MD,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AA7uBR;AA7sLI;EA86ME;IAeI,eAAA;IACA,kBAAA;EA5uBR;AACF;AA8uBQ;EACE,6BAAA;EACA,YAAA;EACA,gBAAA;AA5uBV;AAmvBI;EACE,eAAA;AAjvBN;AAmvBM;EACE,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,aAAA;EACA,gBAAA;AAjvBR;AAluLI;EA88ME;IAOI,qCAAA;IACA,gBAAA;IAEA,SAAA;EAhvBR;AACF;AAkvBM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;AAhvBR;AAnvLI;EA29ME;IAUI,aAAA;IACA,QAAA;EA9uBR;AACF;AA+uBQ;EACE,WAAA;AA7uBV;AA5vLI;EAw+MI;IAGI,WAAA;EA3uBV;AACF;AA8uBM;EACE,eAAA;EACA,2BAjgNC;EAkgND,mBAAA;EACA,uEAAA;EACA,6BAAA;EACA,oCAAA;AA5uBR;AAzwLI;EA++ME;IASI,eAAA;IACA,kBAAA;EA3uBR;AACF;AA8uBM;EACE,eAAA;EACA,8BAjhNI;EAkhNJ,iBAAA;AA5uBR;AApxLI;EA6/ME;IAMI,eAAA;IACA,gBAAA;EA3uBR;AACF;AAgvBE;EAEE,eAAA;EACA,yBAAA;AA/uBJ;AAkvBM;EACE,aAAA;EACA,qBAAA;EACA,eAAA;EACA,8BAtiNI;EAuiNJ,mBAAA;EACA,8BAAA;AAhvBR;AAmvBM;EACE,YAAA;EACA,eAAA;EACA,2BA5iNC;EA6iND,yBAAA;AAjvBR;AAwvBM;EAEE,+EAAA;EAnhNN,aAAA;EAqhNM,kBAAA;EACA,8BAAA;AAnvBR;AAqvBQ;EACE,kBAAA;EACA,iBAAA;EACA,2BA9jND;EA+jNC,YAAA;EACA,yBAAA;AAnvBV;AA7zLI;EA2iNI;IAQI,eAAA;EAlvBV;AACF;AAqvBQ;EACE,iBAAA;EACA,2BAzkND;EA0kNC,YAAA;EACA,yBAAA;EACA,mBAAA;AAnvBV;AAz0LI;EAujNI;IAQI,gBAAA;EAlvBV;AACF;AAsvBM;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,8BAAA;AApvBR;AAv1LI;EAokNE;IAUI,sBAAA;IACA,oBAAA;EAnvBR;AACF;AAqvBQ;EAGE,UAAA;EAlkNR,aAAA;EAokNQ,uBAAA;EACA,eAAA;EACA,SAAA;AAjvBV;AAx2LI;EAklNI;IAUI,WAAA;IACA,eAAA;IACA,SAAA;EAhvBV;AACF;AAyvBY;EACE,kBAAA;EACA,YAAA;AAvvBd;AA2vBU;EA3lNR,aAAA;EA8lNU,6BAAA;EACA,WAAA;EACA,8BAAA;EACA,sBAAA;AAtvBZ;AAwvBY;EACE,eAAA;EACA,2BAxoNL;AAk5LT;AAyvBY;EACE,eAAA;EACA,8BA/oNF;AAw5LZ;AA0vBY;EA7mNV,aAAA;EA+mNY,SAAA;AApvBd;AA94LI;EAgoNQ;IAKI,sBAAA;IACA,QAAA;EAnvBd;AACF;AAqvBc;EACE,8BA5pNJ;EA6pNI,cAAA;AAnvBhB;AAx5LI;EAyoNU;IAKI,eAAA;EAlvBhB;AACF;AAqvBc;EACE,2BAnqNP;AAg7LT;AAh6LI;EAkpNU;IAII,eAAA;EAlvBhB;AACF;AAsvBY;EACE,eAAA;EACA,2BA7qNL;EA8qNK,8DAAA;EACA,6BAAA;EACA,oCAAA;EAEA,2BAlrNL;AA67LT;AA76LI;EA2pNQ;IAUI,eAAA;EApvBd;AACF;AA0vBM;EACE,iBAAA;EACA,oBAAA;AAxvBR;AAt7LI;EA4qNE;IAKI,mBAAA;EAvvBR;AACF;AAyvBQ;EAjqNN,aAAA;EAmqNQ,SAAA;AAnvBV;AAn8LI;EAorNI;IAKI,sBAAA;IACA,mBAAA;IACA,MAAA;EAlvBV;AACF;AAovBU;EACE,8BAjtNA;EAktNA,cAAA;AAlvBZ;AAqvBU;EACE,2BAptNH;AAi+LT;AAj9LI;EAmsNM;IAII,eAAA;EAlvBZ;AACF;AAyvBE;EACE,eAAA;EACA,0DAAA;EACA,sBAAA;EAreA,4BAAA;EACA,2BAAA;AAjRJ;AAyvBM;EACE,YAAA;EACA,eAAA;EACA,2BAzuNC;EA0uND,mBAAA;AAvvBR;AAn+LI;EAstNE;IAOI,eAAA;IACA,kBAAA;EAtvBR;AACF;AAyvBM;EACE,WAAA;AAvvBR;AAwvBQ;EACE,aAAA;AAtvBV;AAwvBQ;EACE,qBAAA;AAtvBV;AAuvBU;EACE,sBAAA;AArvBZ;AAuvBU;EACE,wCAAA;AArvBZ;AAuvBU;EACE,iDAAA;AArvBZ;AA0vBM;EAluNJ,aAAA;EAouNM,sBAAA;EACA,SAAA;AApvBR;AAsvBQ;EAvuNN,aAAA;EAyuNQ,SAAA;AAhvBV;AA5gMI;EA0vNI;IAKI,sBAAA;EA/uBV;AACF;AAivBU;EA/uNR,aAAA;EAivNU,eAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;AA3uBZ;AA5hMI;EAkwNM;IAQI,sBAAA;EA1uBZ;AACF;AA6uBU;EACE,UAAA;EACA,kBAAA;AA3uBZ;AAriMI;EA8wNM;IAKI,WAAA;EA1uBZ;AACF;AA4uBY;EACE,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AA1uBd;AA6uBY;EACE,WAAA;EACA,kBAAA;AA3uBd;AA6uBc;EACE,eAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AA3uBhB;AAgvBU;EACE,eAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EAEA,YAAA;AA/uBZ;AAivBY;EACE,cAAA;AA/uBd;AAxkMI;EA4yNM;IAeI,WAAA;IACA,kBAAA;IACA,eAAA;EA/uBZ;AACF;AAmvBQ;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAz1NE;AAwmMZ;AAmvBU;EACE,cAAA;EACA,eAAA;EACA,sBAAA;AAjvBZ;AA3lMI;EAk0NI;IAcI,kBAAA;IACA,eAAA;EAjvBV;AACF;AAovBQ;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BA52NE;EA62NF,WAAA;AAlvBV;AAovBU;EACE,cAAA;EACA,eAAA;EACA,sBAAA;AAlvBZ;AA9mMI;EAq1NI;IAeI,kBAAA;IACA,eAAA;IACA,aAAA;EAlvBV;AACF;AAsvBM;EACE,qBAAA;EACA,iBAAA;EACA,8BAh4NI;EAi4NJ,cA13NC;EA23ND,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EAEA,YAAA;EACA,6BAAA;EACA,uBAAA;AArvBR;AAloMI;EA22NE;IAeI,cAAA;IACA,kBAAA;IACA,eAAA;IACA,cAAA;IACA,kBAAA;IACA,oBAAA;IACA,iBAAA;IACA,kBAAA;IACA,uBAAA;IAAA,kBAAA;EApvBR;AACF;AAsvBQ;EACE,uBAAA;EACA,cAl5ND;EAm5NC,uBAAA;EACA,gBAAA;AApvBV;AA0vBE;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EAEA,yBAAA;AAzvBJ;AA2vBI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;AAzvBN;AAnqMI;EAs5NA;IASI,sBAAA;IACA,SAAA;IACA,mBAAA;EAxvBN;AACF;AA0vBM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAxvBR;AAyvBQ;EACE,YAAA;AAvvBV;AAyvBQ;EACE,6BA77NC;AAssMX;AA2vBM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,8BAt8NI;AA6sMZ;AA0vBQ;EACE,6BAv8NC;AA+sMX;AA0vBQ;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAxvBV;AAnsMI;EAw7NI;IAKI,sBAAA;IACA,mBAAA;EAtvBV;AACF;AAzsMI;EAg7NE;IAmBI,sBAAA;IACA,SAAA;IACA,mBAAA;EAtvBR;AACF;;AA6vBE;EACE,kBAAA;AA1vBJ;AA4vBE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,SAAA;EACA,gCAAA;EACA,2BAziOI;EA0iOJ,eAAA;AA1vBJ;AA7tMI;EAg9NF;IASI,eAAA;EAxvBJ;AACF;AA9tMI;EA48NF;IAYI,eAAA;EAtvBJ;AACF;AAwvBE;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;AAtvBJ;AAuvBI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AArvBN;AAlvMI;EAo+NA;IAMI,qCAAA;IACA,eAAA;EApvBN;AACF;AAsvBI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AApvBN;AAsvBI;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,oCAAA;EACA,sCAAA;EACA,kBAAA;AApvBN;AAsvBI;EACE,kCAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;AApvBN;;AAyvBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EAEA,kBAAA;EACA,aAAA;AAvvBF;;AA0vBA;EAEE,aAAA;EACA,mBAAA;EAEA,gBAAA;EACA,WAAA;AAzvBF;;AA4vBA;EACE,iBAAA;EACA,mBAAA;EACA,2BAjjOO;EAkjOP,WAAA;EACA,0BAAA;AAzvBF;AA1yMI;EA8hOJ;IAOI,iBAAA;EAvvBF;AACF;;AA0vBA;EACE,iBAAA;EAEA,mBAAA;EACA,4BApoOO;AA44MT;;AA2vBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EAIA,qBAAA;EACA,0BAAA;EAEA,iBAAA;EACA,sCAAA;EACA,4BAAA;EACA,8BAvpOS;EAwpOT,eAAA;EACA,mBAAA;EACA,oCAAA;AA5vBF;AA6vBE;EACE,WAAA;AA3vBJ;AAx0MI;EAgjOJ;IAsBI,iBAAA;EA1vBF;EA2vBE;IACE,WAAA;EAzvBJ;AACF;;AAiwBE;EACE,iCAAA,EAAA,oCAAA;EACA,UAAA,EAAA,gCAAA;EACA,gEACE;AA/vBN","sourcesContent":["// //\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro Black\";\n  src:\n    url(\"../fonts/NeueHaasDisplay-Black.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-Black.woff\") format(\"woff\");\n  font-weight: 900;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro Bold\";\n  src:\n    url(\"../fonts/NeueHaasDisplay-Bold.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-Bold.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro Light\";\n  src:\n    url(\"../fonts/NeueHaasDisplay-Light.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-Light.woff\") format(\"woff\");\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro Mediu\";\n  src:\n    url(\"../fonts/NeueHaasDisplay-Mediu.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-Mediu.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro Roman\";\n  src:\n    url(\"../fonts/NeueHaasDisplay-Roman.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-Roman.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro XXThin\";\n  src:\n    url(\"../fonts/NeueHaasDisplay-XXThin.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-XXThin.woff\") format(\"woff\");\n  font-weight: 100;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro XThin\";\n  src:\n    url(\"../fonts/NeueHaasDisplay-XThin.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-XThin.woff\") format(\"woff\");\n  font-weight: 100;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro Thin\";\n  src:\n    url(\"../fonts/NeueHaasDisplay-Thin.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-Thin.woff\") format(\"woff\");\n  font-weight: 100;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro light italic\";\n  src:\n    url(\"../fonts/NeueHaasDisplay-LightItalic.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-LightItalic.woff\") format(\"woff\");\n  font-weight: 300;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro roman italic\";\n  src:\n    url(\"../fonts/NeueHaasDisplay-RomanItalic.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-RomanItalic.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: italic;\n  font-display: swap;\n}\n\n// ad-accounts\n\n/* VARIABLES */\n\n$black: \"Neue Haas Grotesk Display Pro Black\";\n$bold: \"Neue Haas Grotesk Display Pro Bold\";\n$light: \"Neue Haas Grotesk Display Pro Light\";\n$lightItalic: \"Neue Haas Grotesk Display Pro light italic\";\n$medium: \"Neue Haas Grotesk Display Pro Mediu\";\n$roman: \"Neue Haas Grotesk Display Pro Roman\";\n$romanItalic: \"Neue Haas Grotesk Display Pro roman italic\";\n$xxthin: \"Neue Haas Grotesk Display Pro XXThin\";\n$xthin: \"Neue Haas Grotesk Display Pro XThin\";\n$thin: \"Neue Haas Grotesk Display Pro Thin\";\n\n/* Color */\n$Yellow: #e5b400;\n$Orange: #e05300;\n$Pink: #e977c1;\n$Blue: #516beb;\n$grayC: #808080;\n\n// ad-accounts\n@font-face {\n  font-family: \"Manrope Bold\";\n  src:\n    url(\"../fonts/Manrope-Bold.woff2\") format(\"woff2\"),\n    url(\"../fonts/Manrope-Bold.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Manrope Extralight\";\n  src:\n    url(\"../fonts/Manrope-ExtraLight.woff2\") format(\"woff2\"),\n    url(\"../fonts/Manrope-ExtraLight.woff\") format(\"woff\");\n  font-weight: 200;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Manrope Medium\";\n  src:\n    url(\"../fonts/Manrope-Medium.woff2\") format(\"woff2\"),\n    url(\"../fonts/Manrope-Medium.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Manrope Extrabold\";\n  src:\n    url(\"../fonts/Manrope-ExtraBold.woff2\") format(\"woff2\"),\n    url(\"../fonts/Manrope-ExtraBold.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Manrope Light\";\n  src:\n    url(\"../fonts/Manrope-Light.woff2\") format(\"woff2\"),\n    url(\"../fonts/Manrope-Light.woff\") format(\"woff\");\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Manrope Semibold\";\n  src:\n    url(\"../fonts/Manrope-SemiBold.woff2\") format(\"woff2\"),\n    url(\"../fonts/Manrope-SemiBold.woff\") format(\"woff\");\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Manrope Regular\";\n  src:\n    url(\"../fonts/Manrope-Regular.woff2\") format(\"woff2\"),\n    url(\"../fonts/Manrope-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n/* VARIABLES */\n\n$Mregular: \"Manrope Regular\";\n$Msemibold: \"Manrope Semibold\";\n$Mlight: \"Manrope Light\";\n$Mextrabold: \"Manrope Extrabold\";\n$Mmedium: \"Manrope Medium\";\n$Mextralight: \"Manrope Extralight\";\n$Mbold: \"Manrope Bold\";\n\n// ecom\n@font-face {\n  font-family: \"DM Sans Regular\";\n  src:\n    url(\"../fonts/DMSans-Regular.woff2\") format(\"woff2\"),\n    url(\"../fonts/DMSans-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"DM Sans MedItalic\";\n  src:\n    url(\"../fonts/DMSans-MediumItalic.woff2\") format(\"woff2\"),\n    url(\"../fonts/DMSans-MediumItalic.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"DM Sans Bold\";\n  src:\n    url(\"../fonts/DMSans-Bold.woff2\") format(\"woff2\"),\n    url(\"../fonts/DMSans-Bold.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"DM Sans Italic\";\n  src:\n    url(\"../fonts/DMSans-Italic.woff2\") format(\"woff2\"),\n    url(\"../fonts/DMSans-Italic.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"DM Sans Medium\";\n  src:\n    url(\"../fonts/DMSans-Medium.woff2\") format(\"woff2\"),\n    url(\"../fonts/DMSans-Medium.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"DM Sans BoldItalic\";\n  src:\n    url(\"../fonts/DMSans-BoldItalic.woff2\") format(\"woff2\"),\n    url(\"../fonts/DMSans-BoldItalic.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: italic;\n  font-display: swap;\n}\n\n/* VARIABLES */\n\n$DMregular: \"DM Sans Regular\";\n$DMmedium: \"DM Sans Medium\";\n$DMbold: \"DM Sans Bold\";\n$DMitalic: \"DM Sans Italic\";\n$DMiditalic: \"DM Sans MedItalic\";\n$DMbolditalic: \"DM Sans BoldItalic\";\n\n$DmPink: #e977c1;\n//\n\n/* MIXINS */\n\n@mixin mq($size) {\n  @if $size==xs {\n    @media (max-width: 320px) {\n      @content;\n    }\n  } @else if $size==mobile {\n    @media (max-width: 767px) {\n      @content;\n    }\n  } @else if $size==tab {\n    @media only screen and (min-width: 768px) and (max-width: 1024px) {\n      @content;\n    }\n  } @else if $size==desktop {\n    @media only screen and (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin flexbox {\n  display: -webkit-box; // old\n  display: -moz-box; // old\n  display: -ms-flexbox; // ie\n  display: -webkit-flex; // new\n  display: flex; // new\n}\n\n/* RESET CSS */\n\n/* http://meyerweb.com/eric/tools/css/reset/\n     v2.0 | 20110126\n     License: none (public domain)\n  */\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  color: inherit;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\n\nbody {\n  line-height: 1;\n}\n\nol,\nul {\n  list-style: none;\n}\n\nblockquote,\nq {\n  quotes: none;\n}\n\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: \"\";\n  content: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n* {\n  box-sizing: border-box;\n}\n\na {\n  &,\n  &:hover,\n  &:active,\n  &:visited,\n  &:focus {\n    color: inherit;\n  }\n\n  text-decoration: none;\n}\n\ni,\nem,\n.italic-text {\n  font-style: italic;\n}\n\nb,\nstrong,\nth,\n.bold-text {\n  //font-weight: bold;\n}\n\n.left {\n  float: left;\n}\n\n.right {\n  float: right;\n}\n\n.wrap-clear::after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n\n.clearfix {\n  zoom: 1;\n  display: table;\n  clear: both;\n\n  &:before,\n  &:after {\n    content: \"\";\n    display: table;\n  }\n\n  &:after {\n    clear: both;\n  }\n}\n\n:focus {\n  outline: none;\n}\n\ninput,\nbutton,\ntextarea {\n  border-radius: 0;\n  appearance: none;\n}\n\nselect {\n  border-radius: 0;\n}\n\ntextarea {\n  resize: none;\n}\n\n/* COMMONS */\n\nbody {\n  -webkit-font-smoothing: antialiased;\n  letter-spacing: 0.6px;\n}\n\nol,\nul {\n  margin: 0px;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  -webkit-appearance: none;\n  outline: none;\n  border-radius: 0;\n  background-color: transparent;\n}\n\ninput,\ntextarea {\n  background: transparent;\n  border: none;\n}\n\ninput:focus,\nselect:focus,\ntextarea:focus,\nbutton:focus,\na:focus {\n  outline: none;\n}\n\na {\n  color: inherit;\n  cursor: pointer;\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\nh1,\nh2,\nh3,\nh4 {\n  line-height: 1.4;\n}\n\np {\n  line-height: 1.6;\n}\n\nimg {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.slick-slider.reverse {\n  transform: rotate(180deg);\n}\n\n.slick-slider.reverse .slick-slide {\n  transform: rotate(180deg);\n}\n\n.hidden-lg {\n  @include mq(desktop) {\n    display: none !important;\n  }\n}\n\n.hidden-xs {\n  @include mq(mobile) {\n    display: none !important;\n  }\n}\n\n.hidden-md {\n  @include mq(tab) {\n    display: none !important;\n  }\n}\n\n.img-responsive {\n  width: 100%;\n  height: auto;\n}\n\n.container {\n  max-width: 1280px;\n  margin: 0 auto;\n  width: 90%;\n  // padding: 0 15px;\n\n  @include mq(tab) {\n    max-width: 768px;\n  }\n\n  @include mq(mobile) {\n    width: 100%;\n    padding: 0 20px;\n  }\n}\n\n/* MAIN CSS */\n$hero_color: #6a69f1;\n$header-text-color: transparent;\n\nmain {\n  position: relative;\n}\n\nbody {\n  scroll-behavior: smooth;\n}\n\n.dark-footer {\n  background-color: black;\n  color: white;\n}\n.white-footer {\n  background-color: white;\n  color: black;\n}\n\n//\n\n/* Header styles */\n.header {\n  padding: 16px 0px;\n  position: fixed;\n  top: 0px;\n  left: 50%;\n  /* position the left edge of the element at the middle of the parent */\n\n  transform: translate(-50%, 0);\n  z-index: 100;\n  width: 100%;\n\n  background-color: transparent;\n  transition: all 0.3s ease;\n  @include mq(mobile) {\n    padding: 10px 0;\n  }\n}\n\n.header-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  @include mq(mobile) {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n}\n\n.logo img {\n  width: 140px;\n  @include mq(mobile) {\n    width: 130px;\n    /* Adjust according to your logo size */\n  }\n}\n\n/* Desktop nav styles */\n\n.nav-links {\n  display: flex;\n  align-items: center;\n  @include mq(mobile) {\n    width: 100%;\n    position: absolute;\n    top: -100vh;\n    left: 0;\n    background-color: rgb(233, 228, 228);\n    display: flex;\n    flex-direction: column;\n  }\n  .wrap-links {\n    @include mq(mobile) {\n      padding-top: 80px;\n      padding-bottom: 80px;\n      width: 100%;\n      height: 100vh;\n      background-color: white;\n    }\n  }\n\n  ul {\n    display: flex;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    gap: 52px;\n    @include mq(mobile) {\n      flex-direction: column;\n      align-items: center;\n      gap: 20px;\n    }\n\n    li {\n      a {\n        transition: all 0.3s ease;\n      }\n      @include mq(mobile) {\n        a {\n          line-height: 1.4;\n          font-size: 26px;\n          font-family: $roman;\n        }\n        margin: 0;\n      }\n    }\n  }\n}\n\n/* Mobile nav styles */\n\n.menu-icon {\n  display: none;\n  cursor: pointer;\n  @include mq(mobile) {\n    position: relative;\n    z-index: 20000;\n  }\n}\n\n.hamburger {\n  width: 30px;\n  height: 21px;\n  position: relative;\n}\n\n.hamburger span {\n  display: block;\n  width: 100%;\n  height: 2px;\n  background: #000;\n  margin-bottom: 6px;\n  transition:\n    transform 0.3s,\n    opacity 0.3s;\n}\n\n.hamburger.open span:nth-child(1) {\n  transform: translateY(8px) rotate(45deg);\n}\n\n.hamburger.open span:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger.open span:nth-child(3) {\n  transform: translateY(-8px) rotate(-45deg);\n}\n\n/* Sliding menu styles */\n\n// .nav-links ul li a {\n//   color: #000;\n//   font-size: 18px;\n// }\n\n@keyframes italicAnimation {\n  0% {\n    font-variation-settings: \"ital\" 12;\n  }\n  100% {\n    font-variation-settings: \"ital\" 0;\n  }\n}\nli {\n  // margin-right: 32px;\n\n  // display: flex;\n  // min-width: 85px;\n  text-align: right;\n  @include mq(mobile) {\n    min-width: unset;\n  }\n\n  a {\n    // color: $header-text-color;\n    text-decoration: none;\n    font-family: $roman;\n    color: black;\n    font-size: 18px;\n    transition: all 0.3s ease;\n    display: block;\n    // transform: none;\n    // // min-width: 75px;\n    // // width: clamp(fit-content, fit-content + 10px);\n    // transition: 0.2s;\n    // transition: transform 0.3s, font-style 0.3s;\n    // letter-spacing: 0.3px;\n    // // margin-right: 33px;\n    // animation-duration: 0.5s;\n    // animation-iteration-count: 1;\n    // animation-fill-mode: forwards;\n    transition: transform 0.2s ease;\n    &:hover {\n      //text-decoration: underline;\n      // color: white;\n      // font-family: $romanItalic;\n      // transform: none;\n      // letter-spacing: 0.3px;\n      // transform: skewX(-10deg);\n      // font-variation-settings: \"slnt\" -10;\n      // margin-left: -2px;\n      transform: skew(-15deg);\n    }\n  }\n  a:not(:hover) {\n    animation-name: italics-animation-reverse;\n  }\n}\nli:last-child {\n  margin-right: 0;\n}\n\n/* Media query for mobile */\n@media (max-width: 768px) {\n  .nav-links {\n    // display: none;\n    text-align: center;\n  }\n\n  .menu-icon {\n    display: block;\n  }\n}\n//\n//\n\n.header.scroll-top {\n  background: white;\n  .header-wrapper {\n    .nav-links {\n      ul li {\n        a {\n          &:hover {\n            color: $Blue;\n          }\n        }\n      }\n    }\n  }\n}\n\n#hero {\n  // background-image: url('../images/hero_bg.png');\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  height: 100vh;\n  width: 100vw;\n  position: relative;\n  overflow: hidden;\n\n  @include flexbox();\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  @include mq(mobile) {\n    padding-top: 160px;\n    padding-bottom: 100px;\n    height: auto;\n  }\n  .headings {\n    .top-copy-container {\n      p {\n        color: white;\n        // mix-blend-mode: exclusion;\n      }\n    }\n    .head-copy-container {\n      h1 {\n        color: white;\n        // mix-blend-mode: exclusion;\n      }\n    }\n\n    p {\n      font-family: $light;\n      text-align: center;\n      font-size: 100px;\n      line-height: 1;\n      text-transform: lowercase;\n\n      @include mq(mobile) {\n        font-size: 40px;\n        line-height: 1.1;\n      }\n      @include mq(tab) {\n        font-size: 70px;\n      }\n    }\n\n    h1 {\n      font-family: $light;\n      text-align: center;\n      font-size: 200px;\n      line-height: 1;\n      text-transform: lowercase;\n\n      @include mq(mobile) {\n        font-size: 60px;\n      }\n      @include mq(tab) {\n        font-size: 140px;\n      }\n    }\n\n    .bottom-copy {\n      margin-top: 2rem;\n      font-family: $roman;\n      font-size: 20px;\n      z-index: 10;\n      text-align: center;\n      color: black;\n      @include mq(mobile) {\n        text-align: center;\n\n        margin-top: 20px;\n        font-size: 13px;\n      }\n      @include mq(tab) {\n        font-size: 26px;\n      }\n    }\n  }\n\n  .top-copy-container,\n  .bottom-copy-container,\n  .head-copy-container {\n    // overflow: hidden;\n    @include flexbox();\n    align-items: center;\n    justify-content: center;\n    line-height: 100%;\n  }\n}\n\n.image-at-cursor {\n  position: absolute;\n  pointer-events: none;\n  z-index: 1000;\n  transition: transform 0.3s ease;\n}\n\n#about {\n  // padding: 6rem 0;\n\n  padding-top: 20px;\n\n  @include mq(mobile) {\n    padding-bottom: 0;\n    padding-top: 70px;\n  }\n\n  .about-wrapper {\n    display: flex;\n    flex-direction: column;\n    // gap: 14rem;\n    position: relative;\n\n    @include mq(mobile) {\n      gap: 180px;\n      gap: 2rem;\n    }\n    .top-img-wrap {\n      // display: flex;\n      // justify-content: space-between;\n      // align-items: center;\n\n      .about-image {\n        padding: 15px;\n        // width: 430px;\n        // height: 298px;\n        // overflow: hidden;\n        // display: flex;\n        // justify-content: space-between;\n        // align-items: flex-start;\n\n        @include mq(mobile) {\n          padding: 0;\n          // max-width: 200px;\n          // height: 130px;\n          // border-radius: 10px;\n          // padding: 10px;\n        }\n        @include mq(tab) {\n          width: 350px;\n          height: 240px;\n        }\n\n        img {\n          object-fit: cover;\n        }\n        p {\n          background-color: white;\n          border-radius: 20px;\n          padding: 0px 10px;\n          font-family: $roman;\n          font-size: 14px;\n\n          @include mq(mobile) {\n            font-size: 10px;\n            line-height: 100%;\n            padding: 3px 10px;\n            font-size: 10px;\n            line-height: 100%;\n            padding: 3px 0px;\n          }\n        }\n      }\n\n      .intro {\n        max-width: 500px;\n        font-family: $roman;\n        font-size: 1.5rem;\n        line-height: 1.25;\n\n        @include mq(mobile) {\n          font-size: 1rem;\n        }\n      }\n    }\n\n    .about-image {\n      // max-width: 430px;\n      // height: 298px;\n      border-radius: 30px;\n      // display: flex;\n      // justify-content: flex-start;\n      // align-items: flex-start;\n\n      .img-wrap {\n        position: relative;\n\n        .black-overlay {\n          background: linear-gradient(0deg, rgb(0 0 0 / 80%) 0%, rgba(0, 0, 0, 0) 100%);\n          position: absolute;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          height: 40%;\n          // border-bottom-left-radius: 15px;\n          // border-bottom-right-radius: 15px;\n          padding: 10px;\n          @include mq(mobile) {\n            border-bottom-left-radius: 10px;\n            border-bottom-right-radius: 10px;\n          }\n        }\n        .copy-below {\n          position: absolute;\n          bottom: 15px;\n          right: 10px;\n          color: white;\n\n          @include mq(mobile) {\n            bottom: 5px;\n            right: 10px;\n          }\n        }\n      }\n\n      @include mq(mobile) {\n        // flex-direction: column;\n        border-radius: 10px;\n      }\n\n      img {\n        object-fit: cover;\n        // border-radius: 15px;\n        @include mq(mobile) {\n          // border-radius: 10px;\n        }\n      }\n\n      &.about-image-top {\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-start;\n        flex-direction: column;\n\n        @include mq(mobile) {\n          // background-size: cover;\n          // position: static;\n          max-width: 200px;\n        }\n        img {\n          margin-bottom: 0px;\n          @include mq(mobile) {\n            margin-bottom: 0px;\n          }\n        }\n        p {\n          background-color: unset;\n        }\n        .copy-below {\n          font-size: 20px;\n          font-family: $roman;\n          line-height: 1.2;\n          left: 10px;\n          @include mq(mobile) {\n            font-size: 14px;\n          }\n        }\n      }\n\n      &.about-image-center {\n        // max-width: 400px;\n        // padding: 15px;\n        // width: 430px;\n        // height: 298px;\n        // position: absolute;\n        // right: 0px;\n        // top: 230px;\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-start;\n        flex-direction: column;\n        align-self: flex-end;\n        justify-content: flex-end;\n        align-items: flex-end;\n        @include mq(mobile) {\n          flex-direction: column;\n        }\n\n        img {\n          // width: 100%;\n        }\n\n        p {\n          // background-color: white;\n          border-radius: 20px;\n          padding: 0px 10px;\n          font-family: $roman;\n          font-size: 14px;\n          max-width: fit-content;\n\n          @include mq(mobile) {\n            font-size: 10px;\n            font-size: 10px;\n            line-height: 100%;\n            padding: 0px;\n          }\n        }\n\n        .copy-below {\n          font-size: 20px;\n          font-family: $roman;\n          line-height: 1.2;\n          @include mq(mobile) {\n            font-size: 14px;\n          }\n        }\n\n        @include mq(mobile) {\n          align-self: flex-end;\n          position: static;\n          max-width: 200px;\n          // height: 130px;\n          padding: 0px;\n          // border-radius: 10px;\n          background-size: cover;\n          margin-top: -10px;\n          display: flex;\n          justify-content: flex-end;\n          align-items: flex-end;\n        }\n        @include mq(tab) {\n          width: 350px;\n          height: 240px;\n        }\n      }\n\n      &.about-image-bottom {\n        padding: 15px;\n        // width: 430px;\n        // height: 298px;\n        // border-radius: 30px;\n        // display: flex;\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-start;\n        flex-direction: column;\n\n        @include mq(mobile) {\n          // flex-direction: column;\n        }\n\n        img {\n          object-fit: cover;\n        }\n\n        @include mq(mobile) {\n          // max-width: 200px;\n          // height: 130px;\n          // border-radius: 10px;\n          // padding: 10px;\n          // background-size: cover;\n          // position: static;\n          width: 200px;\n          padding: 0;\n          margin-top: -10px;\n        }\n        @include mq(tab) {\n          width: 350px;\n          height: 240px;\n        }\n\n        p {\n          // background-color: white;\n          border-radius: 20px;\n          padding: 0px 10px;\n          font-family: $roman;\n          font-size: 14px;\n\n          @include mq(mobile) {\n            font-size: 10px;\n            font-size: 10px;\n            line-height: 100%;\n            padding: 0px;\n          }\n        }\n        .copy-below {\n          font-size: 20px;\n          font-family: $roman;\n          line-height: 1.2;\n          left: 10px;\n\n          @include mq(mobile) {\n            font-size: 14px;\n          }\n        }\n      }\n\n      p {\n        @include mq(desktop) {\n          // display: none;\n        }\n      }\n    }\n\n    .center-copy {\n      width: 100%;\n      position: absolute;\n      top: 50%;\n      /* position the top  edge of the element at the middle of the parent */\n      left: 50%;\n      /* position the left edge of the element at the middle of the parent */\n\n      transform: translate(-50%, -50%);\n      font-family: $light;\n      font-size: 100px;\n      z-index: 50;\n      line-height: 1;\n      color: white;\n      // mix-blend-mode: exclusion;\n      will-change: transform;\n      -webkit-font-smoothing: antialiased;\n      text-align: center;\n\n      @include mq(mobile) {\n        font-size: 34px;\n        position: static;\n        transform: unset;\n        font-family: $roman;\n        margin-bottom: 0px;\n        font-size: 40px;\n      }\n      @include mq(tab) {\n        font-size: 60px;\n      }\n    }\n  }\n}\n\n.back-constant {\n  background-position: top;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n#work {\n  // padding: 6rem 0;\n  padding: 120px 0;\n\n  // padding-top: 40px;\n  // padding-bottom: 40px;\n\n  @include mq(mobile) {\n    padding: 40px 0;\n    padding-top: 80px;\n    // padding-bottom: 40px;\n  }\n\n  .work-copy {\n    max-width: 100%;\n    // display: flex;\n\n    // margin-bottom: 40px;\n\n    @include mq(mobile) {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0;\n    }\n\n    h3 {\n      font-size: 100px;\n      font-family: $roman;\n      line-height: 100%;\n      color: white;\n      // mix-blend-mode: exclusion;\n\n      @include mq(mobile) {\n        font-size: 34px;\n        font-family: $roman;\n      }\n      @include mq(tab) {\n        font-size: 60px;\n      }\n    }\n\n    p {\n      font-size: 1rem;\n      font-family: $roman;\n      line-height: 1.4;\n      font-size: 18px;\n\n      @include mq(mobile) {\n        font-size: 15px;\n      }\n    }\n  }\n\n  .sliders-wrap {\n    z-index: 7;\n    position: relative;\n    display: flex;\n    gap: 90px;\n    flex-direction: column;\n\n    @include mq(mobile) {\n      gap: 3rem;\n    }\n    @include mq(tab) {\n      gap: 80px;\n    }\n\n    .work-slider-top {\n      max-width: 100%;\n\n      .slick-slider {\n        .slick-prev {\n          display: none;\n        }\n\n        .slick-next {\n          display: none;\n        }\n\n        .slick-list {\n        }\n      }\n\n      .card-item {\n        width: 360px;\n        height: 250px;\n        margin: 0 80px;\n        overflow: hidden;\n        border-radius: 10px;\n        position: relative;\n        display: flex;\n        justify-content: end;\n        align-items: flex-start;\n        padding: 10px;\n        background-size: cover;\n        background-position: center;\n        background-repeat: no-repeat;\n        //\n        justify-content: flex-start;\n        align-items: flex-end;\n        // 29july\n\n        @include mq(mobile) {\n          margin: 0 30px;\n          padding: 10px;\n          width: 90%;\n          height: 150px;\n          background-size: cover;\n        }\n        @include mq(tab) {\n          width: 320px;\n          height: 220px;\n        }\n\n        img {\n          object-fit: cover;\n          display: block;\n        }\n\n        p {\n          // background-color: rgb(0, 0, 0);\n          line-height: 1.2;\n          padding: 1px 10px;\n          border-radius: 20px;\n          font-family: $roman;\n          color: white;\n          font-size: 22px;\n          @include mq(mobile) {\n            font-size: 16px;\n          }\n        }\n\n        &.card-1 {\n          background-image: url(\"../images/social.png\");\n          background-position: top;\n          background-size: cover;\n          background-repeat: no-repeat;\n        }\n\n        &.card-2 {\n          background-image: url(\"../images/video.png\");\n          background-position: top;\n          background-size: cover;\n          background-repeat: no-repeat;\n        }\n\n        &.card-3 {\n          background-image: url(\"../images/games2.png\");\n          background-position: top;\n          background-size: cover;\n          background-repeat: no-repeat;\n        }\n\n        &.card-4 {\n          background-image: url(\"../images/ads2.png\");\n          background-position: top;\n          background-size: cover;\n          background-repeat: no-repeat;\n        }\n      }\n    }\n\n    .work-slider-bottom {\n      max-width: 100%;\n\n      .slick-slider {\n        .slick-prev {\n          display: none;\n        }\n\n        .slick-next {\n          display: none;\n        }\n        .slick-slide {\n          @include mq(mobile) {\n            // margin-right: 15px;\n            // margin-left: 15px;\n          }\n        }\n      }\n\n      .card-item {\n        width: 360px;\n        height: 250px;\n        margin: 0 80px;\n        overflow: hidden;\n        border-radius: 10px;\n        position: relative;\n        display: flex;\n        justify-content: end;\n        align-items: flex-start;\n        padding: 10px;\n\n        justify-content: flex-start;\n        align-items: flex-end;\n\n        @include mq(mobile) {\n          margin: 0 10px;\n          width: 90%;\n          height: 150px;\n          background-size: cover;\n          padding: 10px;\n        }\n        @include mq(tab) {\n          width: 320px;\n          height: 220px;\n        }\n\n        img {\n          object-fit: cover;\n          display: block;\n        }\n\n        p {\n          // background-color: white;\n          line-height: 1.2;\n          padding: 1px 10px;\n          border-radius: 20px;\n          font-family: $roman;\n          // 29july\n          color: white;\n          font-size: 22px;\n          @include mq(mobile) {\n            font-size: 16px;\n          }\n        }\n\n        &.card-1 {\n          background-image: url(\"../images/web.png\");\n          background-position: top;\n          background-size: cover;\n          background-repeat: no-repeat;\n\n          p {\n            background-color: white;\n            line-height: 1.2;\n            padding: 0px 10px;\n            border-radius: 8px;\n          }\n        }\n\n        &.card-2 {\n          background-image: url(\"../images/metaverse.png\");\n          background-color: rgb(100, 98, 124);\n          background-position: top;\n          background-size: cover;\n          background-repeat: no-repeat;\n        }\n\n        &.card-3 {\n          background-image: url(\"../images/ads.png\");\n          background-position: top;\n          background-size: cover;\n          background-repeat: no-repeat;\n        }\n\n        &.card-4 {\n          background-image: url(\"../images/animation-&-motion-graphics.png\");\n          background-color: rgb(100, 98, 124);\n\n          background-position: top;\n          background-size: cover;\n          background-repeat: no-repeat;\n        }\n      }\n    }\n\n    .work_heading {\n      position: absolute;\n      font-size: 11rem;\n      font-family: $roman;\n      top: 50%;\n      /* position the top  edge of the element at the middle of the parent */\n      left: 50%;\n      /* position the left edge of the element at the middle of the parent */\n\n      transform: translate(-50%, -50%);\n      //z-index: -1;\n\n      // mix-blend-mode: exclusion;\n      color: white;\n      z-index: 1;\n\n      @include mq(mobile) {\n        font-size: 3rem;\n      }\n    }\n  }\n}\n\n#team {\n  // padding: 100px 0;\n  pointer-events: none;\n\n  position: relative;\n  // padding-top: 40px;\n  @include mq(mobile) {\n    // padding-top: 0;\n    // padding: 40px;\n    padding: 0px 0;\n    // padding-bottom: 50px;\n    // margin-bottom: 50px;\n  }\n\n  .team-slider {\n    // padding-top: 40px;\n    // padding-bottom: 40px;\n    z-index: 10;\n\n    @include mq(mobile) {\n      // padding-top: 20px;\n      padding: 0;\n      // padding-bottom: 20px;\n    }\n\n    .slick-slider {\n      .slick-prev {\n        display: none;\n      }\n\n      .slick-next {\n        display: none;\n      }\n    }\n\n    .slick-slide {\n      padding: 0 20px;\n\n      img {\n        // border-radius: 15px;\n      }\n      @include mq(mobile) {\n        padding: 0 15px;\n      }\n    }\n\n    .team-card {\n      background-position: center;\n      background-size: cover;\n      background-repeat: no-repeat;\n      display: flex;\n\n      justify-content: flex-start;\n      align-items: flex-end;\n      // padding: 10px;\n      border-radius: 15px;\n      // height: 350px;\n      position: relative;\n      @include mq(mobile) {\n        // height: 210px;\n      }\n\n      .black-overlay {\n        background: linear-gradient(0deg, rgb(0 0 0 / 80%) 0%, rgba(0, 0, 0, 0) 100%);\n        position: absolute;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        height: 40%;\n        // border-bottom-left-radius: 15px;\n        // border-bottom-right-radius: 15px;\n        padding: 10px;\n      }\n\n      .team-name {\n        position: absolute;\n        margin-bottom: 15px;\n        margin-left: 15px;\n      }\n\n      p {\n        color: white;\n        font-size: 19px;\n        font-family: $roman;\n        line-height: 1;\n        @include mq(mobile) {\n          font-size: 16px;\n        }\n      }\n\n      &.team-card-0 {\n        width: 130px;\n        height: 350px;\n        background-image: url(\"../images/Rikki.jpg\");\n      }\n\n      &.team-card-1 {\n        width: 130px;\n        height: 350px;\n        background-image: url(\"../images/Dia.jpg\");\n      }\n\n      &.team-card-2 {\n        width: 150px;\n        height: 400px;\n        background-image: url(\"../images/Dooj.jpg\");\n      }\n\n      &.team-card-3 {\n        width: 130px;\n        height: 350px;\n        background-image: url(\"../images/Khushboo.jpg\");\n      }\n\n      &.team-card-4 {\n        width: 110px;\n        height: 400px;\n        background-image: url(\"../images/Michell.jpg\");\n      }\n\n      &.team-card-5 {\n        width: 140px;\n        height: 350px;\n        background-image: url(\"../images/Prerna.jpg\");\n      }\n\n      &.team-card-6 {\n        width: 140px;\n        height: 400px;\n        background-image: url(\"../images/Dia.jpg\");\n      }\n\n      &.team-card-7 {\n        width: 200px;\n        height: 500px;\n        background-image: url(\"../images/Dooj.jpg\");\n      }\n\n      &.team-card-8 {\n        width: 120px;\n        height: 400px;\n        background-image: url(\"../images/Khushboo.jpg\");\n      }\n\n      &.team-card-9 {\n        width: 140px;\n        height: 400px;\n        background-image: url(\"../images/Michell.jpg\");\n      }\n\n      &.team-card-10 {\n        width: 130px;\n        height: 400px;\n        background-image: url(\"../images/Prerna.jpg\");\n      }\n\n      &.team-card-11 {\n        width: 120px;\n        height: 400px;\n        background-image: url(\"../images/Rikki.jpg\");\n      }\n    }\n\n    .m-50 {\n      margin-top: 50px;\n      @include mq(mobile) {\n        margin-top: 0px;\n      }\n    }\n\n    .m-100 {\n      margin-top: 100px;\n      @include mq(mobile) {\n        margin-top: 30px;\n      }\n    }\n\n    .m-150 {\n      margin-top: 150px;\n      @include mq(mobile) {\n        margin-top: 120px;\n      }\n    }\n\n    .m-200 {\n      margin-top: 200px;\n      @include mq(mobile) {\n        margin-top: 140px;\n      }\n    }\n  }\n\n  .designation {\n    margin-top: 6px;\n    font-size: 13px !important;\n    @include mq(mobile) {\n      font-size: 10px !important;\n    }\n  }\n\n  .overlapped-copy-top {\n    font-size: 100px;\n    font-family: $light;\n    // position: absolute;\n    top: 0rem;\n    left: 200px;\n    line-height: 100%;\n    // mix-blend-mode: exclusion;\n    color: white;\n    z-index: 10;\n\n    @include mq(mobile) {\n      left: 20px;\n      top: 4rem;\n\n      font-size: 34px;\n      // top: 40px;\n      font-family: $roman;\n      font-size: 40px;\n    }\n    @include mq(tab) {\n      font-size: 60px;\n    }\n  }\n\n  .overlapped-copy-bottom {\n    font-size: 100px;\n    font-family: $light;\n    // position: absolute;\n    bottom: -4rem;\n    right: 200px;\n    text-align: right;\n    line-height: 100%;\n    // mix-blend-mode: exclusion;\n    color: white;\n\n    @include mq(mobile) {\n      right: 20px;\n      font-size: 2rem;\n      bottom: 0rem;\n      font-family: $roman;\n      font-size: 40px;\n    }\n    @include mq(tab) {\n      font-size: 60px;\n    }\n  }\n}\n\n.zIndex-box {\n  display: none;\n\n  @include mq(mobile) {\n    display: block;\n    width: 100%;\n    position: fixed;\n    //height: 120vh;\n    top: 0;\n    left: 0;\n    bottom: -20%;\n    right: 0;\n    z-index: -1;\n    background-image: url(\"../images/Mobile-BG.jpg\");\n    background-repeat: repeat-y;\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n  }\n}\n\n.home-page {\n  background-image: url(\"../images/hero_bg.png\");\n  background-attachment: fixed;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n\n  @include mq(mobile) {\n    background-image: unset;\n    //background-repeat: repeat-y;\n    &:before {\n      @include mq(mobile) {\n        content: \"\";\n        display: block;\n        position: fixed;\n        left: 0;\n        top: 0;\n        width: 100%;\n        height: 100%;\n        z-index: -10;\n        // background: url(\"../images/Mobile-BG.jpg\") no-repeat center center;\n        -webkit-background-size: cover;\n        -moz-background-size: cover;\n        -o-background-size: cover;\n        background-size: cover;\n      }\n    }\n  }\n}\n.home-page-all {\n  background-image: url(\"../images/hero_bg.png\");\n  background-attachment: fixed;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  @include mq(mobile) {\n    // background-image: url(\"../images/Mobile-BG.jpg\");\n    // background-repeat: repeat;\n  }\n}\n.work-page {\n  background-image: url(\"../images/hero_bg.png\");\n  background-attachment: fixed;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  @include mq(mobile) {\n    background-image: url(\"../images/Mobile-BG.jpg\");\n    background-repeat: repeat;\n  }\n}\n\n#awards {\n  // padding: 6rem 0;\n  padding: 135px 0;\n\n  // padding-top: 10rem;Updated\n\n  @include mq(mobile) {\n    padding: 0;\n    padding: 80px 0;\n  }\n\n  .awards-heading {\n    font-family: $light;\n    font-size: 100px;\n    text-align: center;\n    margin-bottom: 4rem;\n    color: white;\n    // mix-blend-mode: exclusion;\n    line-height: 1;\n\n    @include mq(mobile) {\n      font-size: 34px;\n      margin-bottom: 2rem;\n      font-family: $roman;\n\n      font-size: 40px;\n      margin-bottom: 2rem;\n      font-family: \"Neue Haas Grotesk Display Pro Roman\";\n      line-height: 1;\n    }\n    @include mq(tab) {\n      font-size: 60px;\n    }\n  }\n\n  .awards-wrapper {\n    max-width: 900px;\n    margin: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5rem;\n\n    .custom-tooltip {\n      background-color: red;\n      color: #fff;\n      padding: 10px;\n      border-radius: 5px;\n      font-size: 14px;\n      // box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n    }\n\n    .custom-tooltip-arrow {\n      color: #333; /* Matches the background color of the tooltip */\n    }\n\n    .slick-slide {\n      padding: 0 40px;\n      @include mq(mobile) {\n        padding: 0 20px;\n      }\n    }\n\n    @include mq(mobile) {\n      max-width: unset;\n      gap: 20px;\n    }\n    #tooltip {\n      font-family: $medium;\n    }\n\n    .tooltip {\n      // position: relative;\n      // display: inline-block;\n      // // border-bottom: 1px dotted black;\n      // display: flex;\n      // flex-direction: column-reverse;\n      // align-items: flex-end;\n      max-width: 83px;\n\n      p {\n        font-family: $medium;\n        margin-top: 10px;\n        text-align: center;\n        @include mq(mobile) {\n          margin-top: 12px;\n\n          font-size: 12px;\n        }\n      }\n    }\n\n    .tooltip .tooltiptext {\n      visibility: hidden;\n      width: fit-content;\n      white-space: nowrap;\n      background-color: black;\n      color: #fff;\n      text-align: center;\n      border-radius: 6px;\n      padding: 5px 5px;\n      bottom: 120%;\n      left: 50%;\n      /* margin-left: -60px; */\n      font-family: $roman;\n      font-size: 14px;\n      transform: translate(-50%, 0%);\n      /* Position the tooltip */\n      position: absolute;\n      z-index: 1;\n    }\n\n    .tooltip:hover .tooltiptext {\n      visibility: visible;\n    }\n  }\n\n  .award-slider {\n    .slick-track {\n      display: flex;\n      padding: 0 10px;\n    }\n  }\n}\n\n#offices {\n  // padding: 6rem 0;\n  // padding: 80px 0;\n  padding-bottom: 120px;\n\n  // .adr-slider-mobile {\n  //   display: none;\n  //   @include mq(mobile) {\n  //     display: block;\n  //   }\n  // }\n\n  @include mq(mobile) {\n    // padding-top: 0;\n    padding: 0px 0;\n    padding-bottom: 50px;\n  }\n\n  .offices-heading {\n    max-width: 900px;\n    font-family: $light;\n    font-size: 100px;\n    line-height: 1;\n    margin-bottom: 4rem;\n    color: white;\n    // mix-blend-mode: exclusion;\n    // text-align: ;\n\n    @include mq(mobile) {\n      margin-bottom: 2rem;\n      font-size: 34px;\n      font-family: $roman;\n      line-height: 1;\n      font-size: 40px;\n      text-align: start;\n      // padding: 0;\n    }\n    @include mq(tab) {\n      font-size: 60px;\n    }\n  }\n\n  .card-wrapper {\n    max-width: 900px;\n    display: flex;\n    justify-content: center;\n    gap: 4rem;\n\n    @include mq(mobile) {\n      flex-direction: column;\n      gap: 30px;\n      padding: 0 70px;\n    }\n\n    .card {\n      background-color: #ffffff91;\n      padding: 30px;\n      // border-radius: 10px;\n      flex: 1 1 0px;\n\n      .city {\n        font-size: 2.5rem;\n        margin-bottom: 1.2rem;\n        font-family: $roman;\n        @include mq(mobile) {\n          font-size: 26px;\n          margin-bottom: 10px;\n        }\n      }\n\n      .adj {\n        font-family: $roman;\n        border-bottom: 1px solid black;\n        line-height: 1;\n        max-width: fit-content;\n        margin-bottom: 10px;\n\n        &.adj1 {\n          border-bottom: none;\n          line-height: 1.3;\n          margin-bottom: 3px;\n        }\n\n        @include mq(mobile) {\n          font-size: 12px;\n          &.adj1 {\n            font-size: 14px;\n          }\n        }\n      }\n\n      .location {\n        font-family: $roman;\n        font-size: 21px;\n        line-height: 1;\n        margin-bottom: 10px;\n        @include mq(mobile) {\n          font-size: 17px;\n        }\n      }\n\n      .our-location {\n        // font-size: 10px;\n        font-family: $roman;\n        border-bottom: 1px solid black;\n        line-height: 1;\n        max-width: fit-content;\n        margin-bottom: 0.5rem;\n\n        &.hgb {\n          border-bottom: none;\n        }\n      }\n\n      // .adr {\n      //   font-family: $roman;\n      //   font-weight: 500;\n      //   font-size: 17px;\n      //   line-height: 1.1;\n      //   margin-bottom: 2rem;\n      // }\n\n      .lets {\n        font-family: $roman;\n        border-bottom: 1px solid black;\n        line-height: 1;\n        max-width: fit-content;\n        margin-bottom: 0.5rem;\n      }\n\n      .name {\n        font-family: $roman;\n        font-size: 21px;\n        line-height: 1;\n        margin-bottom: 1.4rem;\n      }\n\n      .post {\n        line-height: 1;\n        font-size: 1.2rem;\n        font-family: $roman;\n        margin-bottom: 5px;\n      }\n\n      .email {\n        font-family: $roman;\n        line-height: 80%;\n      }\n    }\n  }\n\n  .adr-slider-mobile {\n    display: none;\n    @include mq(mobile) {\n      display: block;\n      // padding: 0 70px;\n      .slick-list {\n        padding: 0 50px; /* Optional: Adjust padding to control visibility of side slides */\n      }\n      .slick-track {\n        display: flex;\n      }\n\n      .slick-slide {\n        margin: 0 20px;\n        max-width: 300px;\n        transform: translateZ(0);\n      }\n      .swiper-wrapper {\n        display: flex;\n      }\n\n      .card {\n        background-color: #ffffff91;\n        padding: 30px;\n        // border-radius: 10px;\n        flex: 1 1 0px;\n        height: 290px;\n        margin: 0 20px;\n        .city {\n          font-size: 2.5rem;\n          margin-bottom: 1.2rem;\n          font-family: $roman;\n          @include mq(mobile) {\n            font-size: 26px;\n            margin-bottom: 10px;\n          }\n        }\n\n        .adj {\n          font-family: $roman;\n          border-bottom: 1px solid black;\n          line-height: 1;\n          max-width: fit-content;\n          margin-bottom: 10px;\n\n          &.adj1 {\n            border-bottom: none;\n            line-height: 1.3;\n            margin-bottom: 3px;\n          }\n\n          @include mq(mobile) {\n            font-size: 12px;\n            &.adj1 {\n              font-size: 14px;\n            }\n          }\n        }\n\n        .location {\n          font-family: $roman;\n          font-size: 21px;\n          line-height: 1;\n          margin-bottom: 10px;\n          @include mq(mobile) {\n            font-size: 17px;\n          }\n        }\n\n        .our-location {\n          // font-size: 10px;\n          font-family: $roman;\n          border-bottom: 1px solid black;\n          line-height: 1;\n          max-width: fit-content;\n          margin-bottom: 0.5rem;\n\n          &.hgb {\n            border-bottom: none;\n          }\n        }\n\n        // .adr {\n        //   font-family: $roman;\n        //   font-weight: 500;\n        //   font-size: 17px;\n        //   line-height: 1.1;\n        //   margin-bottom: 2rem;\n        // }\n\n        .lets {\n          font-family: $roman;\n          border-bottom: 1px solid black;\n          line-height: 1;\n          max-width: fit-content;\n          margin-bottom: 0.5rem;\n        }\n\n        .name {\n          font-family: $roman;\n          font-size: 21px;\n          line-height: 1;\n          margin-bottom: 1.4rem;\n        }\n\n        .post {\n          line-height: 1;\n          font-size: 1.2rem;\n          font-family: $roman;\n          margin-bottom: 5px;\n        }\n\n        .email {\n          font-family: $roman;\n          line-height: 80%;\n        }\n      }\n    }\n  }\n}\n\n#news {\n  // padding: 6rem 0;\n  padding-top: 200px;\n  padding-bottom: 60px;\n\n  .news-heading {\n    font-size: 180px;\n    font-family: $roman;\n    line-height: 100%;\n    // color: white;\n    text-transform: uppercase;\n    line-height: 0.8;\n    padding-bottom: 10px;\n    margin-left: -5px;\n    @include mq(mobile) {\n      line-height: 1.4;\n    }\n    @include mq(tab) {\n      font-size: 100px;\n    }\n    @include mq(desktop) {\n      font-size: 140px;\n    }\n  }\n\n  .news-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n\n    @include mq(mobile) {\n      flex-direction: column;\n      gap: 20px;\n    }\n    .filter-wrapper {\n      display: flex;\n      align-items: center;\n      gap: 1.5rem;\n      align-self: flex-end;\n      .label {\n        font-family: $roman;\n      }\n      @include mq(mobile) {\n        gap: 10px;\n        span {\n          font-size: 14px;\n        }\n      }\n      .select-div {\n        border: 1px black solid;\n        border-radius: 50px;\n        padding: 4px 20px;\n        // padding-left: 15px;\n        display: flex;\n        align-items: center;\n        gap: 2rem;\n        @include mq(mobile) {\n          padding: 4px 14px;\n          display: flex;\n          align-items: center;\n          gap: 10px;\n        }\n        select {\n          text-transform: capitalize;\n          border: none;\n          font-size: 20px;\n          font-family: $roman;\n          @include mq(mobile) {\n            font-size: 16px;\n          }\n        }\n      }\n    }\n\n    &.news-one {\n      display: flex;\n      flex-direction: column;\n      // gap: 30px;\n      padding: 20px 0;\n      padding-top: 17px;\n      @include mq(mobile) {\n        padding-top: 14px;\n        padding-bottom: 40px;\n      }\n      .news-individual {\n        padding-top: 60px;\n        padding-bottom: 60px;\n        border-top: black 1px solid;\n        display: flex;\n        gap: 2rem;\n        transition: all 0.3s ease;\n        &:hover {\n          p.copy {\n            text-decoration: underline;\n          }\n        }\n\n        .news-image {\n          flex: 1;\n          overflow: hidden;\n          .news-img-class {\n            border-radius: 20px;\n            overflow: hidden;\n            width: 100%;\n          }\n          &.news-image-copy {\n            flex: 2;\n            display: flex;\n            align-items: flex-start;\n            flex-direction: column;\n            justify-content: space-between;\n            // padding: 20px 0;\n            @include mq(mobile) {\n              gap: 20px;\n            }\n            .award-copy-wrap {\n              display: flex;\n              flex-direction: column;\n              align-items: flex-start;\n              gap: 40px;\n              .award {\n                border: 1px black solid;\n                border-radius: 50px;\n                padding: 3px 20px;\n                // padding-left: 15px;\n                text-align: center;\n                font-family: $roman;\n                text-transform: capitalize;\n              }\n              .copy {\n                font-family: $roman;\n                font-size: 26px;\n                line-height: 1.4;\n              }\n\n              @include mq(mobile) {\n                gap: 20px;\n\n                .copy {\n                  font-size: 18px;\n                  line-height: 1.4;\n                }\n              }\n            }\n            .date {\n              font-family: $roman;\n              font-size: 18px;\n              line-height: 1.1;\n            }\n            @include mq(mobile) {\n              .date {\n                font-size: 16px;\n              }\n            }\n          }\n        }\n        @include mq(mobile) {\n          flex-direction: column;\n          gap: 20px;\n          padding-top: 40px;\n          padding-bottom: 20px;\n        }\n      }\n    }\n  }\n  .show-more {\n    text-align: center;\n    display: block;\n    text-decoration: underline;\n    font-family: $roman;\n  }\n\n  @include mq(mobile) {\n    padding-top: 140px;\n    padding-bottom: 0;\n    .news-heading {\n      font-size: 60px;\n      margin: 0;\n      padding: 0;\n    }\n  }\n}\n\n#initatives {\n  padding-top: 200px;\n  padding-bottom: 60px;\n  @include mq(mobile) {\n    padding-top: 140px;\n  }\n  .initatives-wrapper {\n    .initatives-flex {\n      display: flex;\n      flex-direction: column;\n\n      .flex-item {\n        display: flex;\n        justify-content: space-between;\n\n        &.flx-center {\n          align-items: center;\n        }\n        @include mq(mobile) {\n          flex-direction: column;\n          align-items: flex-start;\n          &.flx-center {\n            align-items: flex-start;\n          }\n        }\n        .it-copy {\n          font-size: 23px;\n          line-height: 1.4;\n          font-family: $roman;\n          @include mq(mobile) {\n            font-size: 22px;\n            line-height: 1.3;\n          }\n        }\n        .it-heading {\n          font-size: 180px;\n          font-family: $light;\n          line-height: 100%;\n          text-transform: lowercase;\n          // margin-bottom: 50px;\n          @include mq(mobile) {\n            font-size: 60px;\n            // margin-bottom: 20px;\n            line-height: 1.4;\n          }\n          @include mq(tab) {\n            font-size: 100px;\n            // margin-bottom: 20px;\n          }\n          @include mq(desktop) {\n            font-size: 140px;\n          }\n        }\n        &.flex-item-it {\n          // border-top: 1px black solid;\n          padding-top: 50px;\n          // display: flex;\n          // flex-wrap: wrap;\n          // justify-content: space-between;\n          gap: 20px;\n          row-gap: 40px;\n          min-height: 340px;\n\n          display: flex;\n          flex-direction: column;\n\n          @include mq(mobile) {\n            padding-top: 20px;\n            gap: 40px;\n          }\n          .it-card {\n            // flex-basis: calc(50% - 20px);\n            display: flex;\n            // flex-direction: column;\n            // gap: 20px;\n            background: rgba(255, 255, 255, 0.568627451);\n            // border-radius: 30px;\n            // border-bottom-left-radius: 15px;\n            // border-top-left-radius: 15px;\n            height: 380px;\n            overflow: hidden;\n            @include mq(mobile) {\n              flex: auto;\n              flex-direction: column;\n              height: unset;\n              // border-radius: 15px;\n            }\n\n            h3 {\n              font-family: $bold;\n              font-size: 35px;\n              margin-bottom: 0px;\n              @include mq(mobile) {\n                font-size: 24px;\n              }\n            }\n            p {\n              font-family: $roman;\n              font-size: 20px;\n              @include mq(mobile) {\n                font-size: 16px;\n              }\n            }\n            .img-wrap {\n              display: flex;\n              // border-radius: 30px;\n              overflow: hidden;\n              img {\n                flex: 1;\n              }\n              @include mq(mobile) {\n                border-radius: 20px;\n              }\n            }\n            .hover-image-container {\n              transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);\n              border-radius: 0;\n\n              flex: 70%;\n              margin-bottom: 0;\n              display: flex;\n              align-items: center;\n\n              @include mq(mobile) {\n                border-bottom-right-radius: 0;\n              }\n\n              @include mq(tab) {\n                align-items: unset;\n              }\n              img {\n                @include mq(desktop) {\n                  transition: all 0.2s ease-in-out;\n                }\n                @include mq(tab) {\n                  object-fit: cover;\n                }\n              }\n            }\n\n            &:hover .discr {\n              // animation: upToDown 0.45s;\n              // transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);\n            }\n            &:hover img {\n              transform: scale(1.02);\n            }\n\n            .hover-image-container:nth-child(even) {\n              border-radius: 0;\n              // border-top-right-radius: ;\n              // border-bottom-right-radius: 15px;\n              overflow: hidden;\n            }\n            .hover-image-container:nth-child(odd) {\n              // border-radius: 0;\n              // border-top-right-radius: 0;\n              // border-bottom-right-radius: 0;\n\n              // border-top-left-radius: 0px;\n              // border-bottom-left-radius: 0px;\n              overflow: hidden;\n              @include mq(mobile) {\n                border-bottom-left-radius: 0;\n              }\n            }\n\n            .copy-wrapper {\n              padding: 30px 40px;\n              flex: 30%;\n              display: flex;\n              flex-direction: column;\n              justify-content: space-between;\n              align-items: flex-start;\n              @include mq(mobile) {\n                padding: 20px 20px;\n                gap: 40px;\n                flex-direction: column;\n                align-items: flex-start;\n              }\n            }\n            .top-copy {\n              .tags-container {\n                font-size: 16px;\n                font-family: $roman;\n                // background-color: white;\n                border: 1px black solid;\n                padding: 5px 18px;\n                border-radius: 50px;\n                width: max-content;\n                color: black;\n                margin-bottom: 10px;\n                @include mq(mobile) {\n                  font-size: 14px;\n                  padding: 5px 15px;\n                  margin-bottom: 10px;\n                  width: max-content;\n                }\n              }\n              .tag {\n                background-color: black;\n                width: fit-content;\n                color: white;\n                padding: 3px 10px;\n                border-radius: 50px;\n                margin-bottom: 20px;\n              }\n              .copy-discription {\n                line-height: 1.25;\n                font-size: 17px;\n                @include mq(mobile) {\n                  text-overflow: ellipsis;\n                  // text-overflow: ellipsis;\n                  // overflow: hidden;\n                  // white-space: nowrap;\n                  font-size: 13px;\n                }\n              }\n\n              @include mq(mobile) {\n                flex: 1;\n              }\n            }\n            .more {\n              display: flex;\n              align-items: flex-end;\n              gap: 10px;\n              img {\n                transform: translate(-10px, 10px); /* Move the arrow from bottom left */\n                opacity: 0; /* Start with the arrow hidden */\n                transition:\n                  transform 0.3s ease-in-out,\n                  opacity 0.3s ease-in-out;\n              }\n\n              @include mq(mobile) {\n                gap: 5px;\n              }\n\n              p {\n                font-size: 16px;\n                // border-bottom: 1px solid black;\n                padding-bottom: 2px;\n                line-height: 1;\n                width: max-content;\n                position: relative;\n                @include mq(mobile) {\n                  font-size: 13px;\n                  flex: 2 0;\n                  width: max-content;\n                }\n              }\n              p::after {\n                content: \"\";\n                position: absolute;\n                width: 0;\n                height: 2px;\n                background: black;\n                left: 0;\n                bottom: -1px; /* Adjust to position underline closer to text */\n                transition: width 0.3s ease;\n              }\n\n              img {\n                width: 10px;\n                padding-bottom: 5px;\n\n                @include mq(mobile) {\n                  width: 7px;\n                }\n              }\n            }\n\n            &:hover {\n              .more {\n                img {\n                  transform: translate(0, 0); /* Move to original position and reset rotation */\n                  opacity: 1;\n                }\n                p::after {\n                  // width: 100%;\n                }\n              }\n            }\n          }\n          /* Apply flex-direction: row-reverse; to every second .it-card */\n          .it-card:nth-child(even) {\n            flex-direction: row-reverse;\n            // border-top-left-radius: 15px;\n            // border-bottom-left-radius: 15px;\n            // border-top-right-radius: 15px;\n            // border-bottom-right-radius: 15px;\n            overflow: hidden;\n            @include mq(mobile) {\n              flex-direction: column;\n            }\n          }\n          // .it-card:nth-child(odd) {\n          //   border-radius: 15px;\n          //   overflow: hidden;\n          // }\n        }\n      }\n    }\n  }\n}\n\n#contact-page {\n  padding-top: 200px;\n  padding-bottom: 60px;\n  @include mq(mobile) {\n    padding-top: 140px;\n  }\n\n  .contact-wrapper {\n    .world-contact-map {\n      display: flex;\n      flex-direction: column;\n      .heading-contact {\n        font-size: 100px;\n        font-family: $light;\n        line-height: 100%;\n        text-transform: lowercase;\n        margin-bottom: 50px;\n        text-align: center;\n        @include mq(mobile) {\n          font-size: 40px;\n        }\n        @include mq(tab) {\n          font-size: 60px;\n        }\n      }\n      .world-map {\n        width: 1180px;\n        margin: auto;\n      }\n      .info-card {\n        margin-top: 4rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: #ffffff91;\n        padding: 30px 30px;\n        // border-radius: 20px;\n        @include mq(mobile) {\n          flex-direction: column;\n          gap: 20px;\n          align-items: stretch;\n        }\n        .card-item {\n          flex: 1;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          flex-direction: column;\n          border-right: 1px solid black;\n          @include mq(mobile) {\n            border-bottom: 1px solid black;\n            border-right: none;\n            padding-bottom: 20px;\n            &:last-child {\n              border-bottom: none;\n            }\n          }\n          &:last-child {\n            border-right: none;\n          }\n          h4 {\n            font-family: $medium;\n            font-size: 24px;\n            margin-bottom: 5px;\n            @include mq(mobile) {\n              font-size: 20px;\n            }\n          }\n          a {\n            font-family: $roman;\n            font-size: 18px;\n            transition: all 0.2s ease;\n            @include mq(mobile) {\n              font-size: 14px;\n            }\n            &:hover {\n              color: $Blue;\n            }\n          }\n\n          @include mq(mobile) {\n            &:last-child {\n              padding-bottom: 0;\n            }\n          }\n        }\n      }\n    }\n    .our-offices {\n      margin-top: 50px;\n      .office-head {\n        font-size: 90px;\n        font-family: $light;\n        text-transform: lowercase;\n        @include mq(mobile) {\n          font-size: 40px;\n        }\n      }\n      .filter {\n        display: flex;\n        gap: 30px;\n        margin-top: 40px;\n        margin-bottom: 60px;\n        @include mq(mobile) {\n          // flex-direction: column;\n          flex-wrap: wrap;\n          gap: 10px;\n          justify-content: flex-start;\n          margin-top: 20px;\n          margin-bottom: 0px;\n        }\n        .timezone-filter {\n          border: 1px solid rgba(19, 19, 19, 0.737);\n          padding: 10px 40px;\n          border-radius: 30px;\n          font-size: 18px;\n          font-family: $roman;\n          transition: all 0.3s ease;\n          &:hover {\n            background: white;\n            color: black;\n            border: 1px solid white;\n          }\n          @include mq(mobile) {\n            font-size: 14px;\n            padding: 8px 18px;\n          }\n        }\n        .reset-timezones {\n          border: 1px solid rgba(19, 19, 19, 0.737);\n          padding: 10px 40px;\n          border-radius: 30px;\n          font-size: 18px;\n          font-family: $roman;\n          transition: all 0.3s ease;\n          &:hover {\n            background: white;\n            color: black;\n            border: 1px solid white;\n          }\n          @include mq(mobile) {\n            font-size: 14px;\n            padding: 8px 35px;\n          }\n        }\n\n        .timezone-filter.active {\n          background: white;\n          color: black;\n          border: 1px solid white;\n        }\n        .reset-timezones {\n          font-size: 18px;\n          font-family: $roman;\n          // text-decoration: underline;\n          align-self: center;\n          transition: all 0.2s ease;\n          background-color: white;\n          color: black;\n          border: white 1px solid;\n          &:hover {\n            color: gray;\n          }\n          @include mq(mobile) {\n            @include flexbox();\n            flex: 1;\n            justify-content: end;\n          }\n        }\n      }\n\n      .adress-wrapper {\n        .address-item {\n          display: none;\n          padding: 80px 0;\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          border-bottom: black solid 1px;\n          gap: 20px;\n          @include mq(mobile) {\n            flex-direction: column;\n            align-items: flex-start;\n\n            padding: 40px 0;\n            gap: 20px;\n            &:last-child {\n              padding-bottom: 0;\n            }\n          }\n\n          .hover-image-container {\n            transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);\n            border-radius: 15px;\n          }\n          &:hover .hover-image-container {\n            border-radius: 0;\n          }\n          &:hover .address-item {\n            animation: upToDown 0.45s;\n            transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);\n          }\n          &:hover img {\n            transform: scale(1.1);\n          }\n          .city {\n            flex: 1.3;\n            font-family: $light;\n            font-size: 80px;\n            line-height: 0.8;\n            @include mq(mobile) {\n              font-size: 32px;\n            }\n          }\n          .adress {\n            flex: 2;\n            display: flex;\n            align-items: flex-start;\n            flex-direction: column;\n            align-items: stretch;\n\n            @include mq(mobile) {\n              width: 100%;\n            }\n\n            h4 {\n              display: none;\n              font-family: $roman;\n              font-size: 20px;\n              font-weight: 600;\n              margin-bottom: 10px;\n              @include mq(mobile) {\n                font-size: 18px;\n              }\n            }\n            .adr-tag-wrap {\n              display: flex;\n              justify-content: space-between;\n              align-items: flex-end;\n\n              .icon {\n                img {\n                  transform: translate(-30px, 30px); /* Move the arrow from bottom left */\n                  opacity: 0; /* Start with the arrow hidden */\n                  transition:\n                    transform 0.3s ease-in-out,\n                    opacity 0.3s ease-in-out;\n                }\n              }\n\n              .hover-image-container {\n                transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);\n                border-radius: 15px;\n              }\n              &:hover .hover-image-container {\n                border-radius: 0;\n              }\n              .rolling-copy-wrap {\n                width: 100%;\n                display: flex;\n                align-items: flex-end;\n                // padding-right: 10px;\n              }\n              &:hover .text {\n                // animation: upToDown 0.45s;\n                transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);\n              }\n              &:hover .icon {\n                // animation: upToDown 0.45s;\n                // transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);\n              }\n              &:hover img {\n                // transform: scale(1.1);\n                transform: translate(0, 0); /* Move to original position and reset rotation */\n                opacity: 1;\n              }\n              .icon {\n                flex: 0.1;\n                display: block;\n                // transform: rotate(-45deg);\n                font-weight: 400;\n                display: flex;\n                justify-content: flex;\n                // padding-right: 5px;\n                padding-bottom: 8px;\n\n                img {\n                  width: 20px;\n                  @include mq(mobile) {\n                    padding-bottom: 5px;\n                    width: 14px;\n                  }\n                }\n              }\n              .text {\n                flex: 1.2;\n                font-size: 30px;\n                font-family: $roman;\n                line-height: 1.2;\n                // text-align: center;\n\n                @include mq(mobile) {\n                  font-size: 22px;\n                }\n              }\n              @include mq(mobile) {\n                font-size: 16px;\n              }\n            }\n          }\n\n          &:last-child {\n            border-bottom: none;\n          }\n        }\n      }\n      .filter-applied {\n        .address-item {\n          border-bottom: 0;\n        }\n      }\n    }\n  }\n}\n\n#people {\n  padding-top: 200px;\n  padding-bottom: 150px;\n  @include mq(mobile) {\n    padding-top: 140px;\n  }\n  .people-wrapper {\n    .people-head-wrap {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      @include mq(mobile) {\n        flex-direction: column;\n        align-items: flex-start;\n      }\n      p {\n        font-family: $roman;\n        font-size: 23px;\n        line-height: 1.4;\n        @include mq(mobile) {\n          font-size: 21px;\n          line-height: 1.3;\n        }\n      }\n    }\n    .contact-heading {\n      font-size: 180px;\n      font-family: $light;\n      line-height: 100%;\n      text-transform: lowercase;\n      @include mq(mobile) {\n        font-size: 60px;\n        line-height: 1.4;\n      }\n      @include mq(tab) {\n        font-size: 100px;\n      }\n      @include mq(desktop) {\n        font-size: 140px;\n      }\n    }\n\n    .people-card-wrapper {\n      padding-top: 50px;\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      column-gap: 100px;\n      row-gap: 65px;\n\n      @include mq(mobile) {\n        grid-template-columns: repeat(1, 1fr);\n        // column-gap: 35px;\n        // row-gap: 65px;\n      }\n      @include mq(tab) {\n        grid-template-columns: repeat(2, 1fr);\n        column-gap: 35px;\n        row-gap: 65px;\n      }\n    }\n    .img-wrap {\n      flex: 1;\n      overflow: hidden;\n      img {\n        transition: transform 0.3s ease-in-out; /* Smooth scaling transition */\n        transform: scale(1); /* Start at normal size */\n        will-change: transform; /* Optimize for smooth animations */\n        transform-origin: center;\n      }\n    }\n    .name {\n      padding: 20px;\n      // margin-top: 16px;\n      font-family: $roman;\n      font-size: 28px;\n      // line-height: 100%;\n      display: flex;\n      align-items: flex-end;\n      justify-content: space-between;\n      line-height: 1.1;\n      gap: 10px;\n\n      .arrow-png {\n        // display: none;\n        padding-bottom: 12px;\n        // width: 50px;\n        transform: translate(-30px, 30px); /* Move the arrow from bottom left */\n        opacity: 0; /* Start with the arrow hidden */\n        transition:\n          transform 0.3s ease-in-out,\n          opacity 0.3s ease-in-out;\n\n        @include mq(mobile) {\n          width: 20px;\n          // opacity: 1;\n          transform: translateY(0); /* Move to original position */\n          opacity: 1;\n          padding-bottom: 4px;\n        }\n        img {\n          width: 50px;\n        }\n      }\n\n      @include mq(mobile) {\n        font-size: 18px;\n        padding: 10px;\n      }\n    }\n    .reverse {\n      flex-direction: row-reverse; /* Apply reverse order */\n      @include mq(mobile) {\n        flex-direction: row;\n      }\n    }\n    .reverse-mobile {\n      @include mq(mobile) {\n        flex-direction: row-reverse !important;\n      }\n    }\n    .normal-mobile {\n      @include mq(mobile) {\n        flex-direction: row !important;\n      }\n    }\n    .people-card {\n      display: flex;\n      background-color: rgba(255, 255, 255, 0.568627451);\n\n      &:hover {\n        cursor: pointer;\n        .arrow-png {\n          transform: translateY(0); /* Move to original position */\n          opacity: 1; /* Fully visible */\n        }\n        .img-wrap {\n          overflow: hidden;\n          img {\n            transform: scale(1.03);\n          }\n        }\n      }\n    }\n    .people-info {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      // padding: 30px;\n    }\n\n    .designation {\n      padding: 20px;\n\n      font-family: $roman;\n      font-size: 16px;\n      line-height: 1.4;\n      // line-height: 1;\n      @include mq(mobile) {\n        font-size: 12px;\n        padding: 10px;\n      }\n    }\n  }\n}\n\n.footer-home {\n  padding: 100px 0;\n  @include mq(mobile) {\n    padding: 40px 0;\n  }\n\n  .footer-wrapper {\n    max-width: 1100px;\n    display: flex;\n    justify-content: space-between;\n    gap: 2rem;\n\n    @include mq(mobile) {\n      // flex-wrap: wrap;\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      column-gap: 60px;\n    }\n    .internet-logo {\n      img {\n        width: 120px;\n      }\n    }\n\n    .footer-item {\n      // flex: 1 1 0px;\n\n      img {\n        width: 130px;\n      }\n\n      a {\n        line-height: 1.2;\n        &:hover {\n          color: $Blue;\n        }\n      }\n\n      h4 {\n        line-height: 1.2;\n      }\n\n      .head {\n        font-family: $medium;\n        font-size: 15px;\n        // border-bottom: 1px solid black;\n        max-width: fit-content;\n        text-transform: capitalize;\n        margin-bottom: 0.5rem;\n        @include mq(mobile) {\n          font-size: 13px;\n          margin-bottom: 0.3rem;\n        }\n      }\n\n      .head-b {\n        font-family: $medium;\n        font-size: 16px;\n        // border-bottom: 1px solid black;\n        max-width: fit-content;\n        text-transform: capitalize;\n        margin-bottom: 0.5rem;\n        @include mq(mobile) {\n          font-size: 13px;\n          margin-bottom: 0.3rem;\n        }\n      }\n\n      .email {\n        font-family: $roman;\n        margin-bottom: 1rem;\n        font-size: 16px;\n        display: block;\n        transition: all 0.2s ease;\n        cursor: pointer;\n        &:hover {\n          color: $Blue;\n        }\n        @include mq(mobile) {\n          font-size: 13px;\n        }\n      }\n\n      .city {\n        font-family: $roman;\n        // margin-bottom: 0.3rem;\n        font-size: 16px;\n        display: block;\n        line-height: 1.6;\n        @include mq(mobile) {\n          font-size: 13px;\n        }\n      }\n\n      .link {\n        font-size: 16px;\n        font-family: $roman;\n        margin-bottom: 0.3rem;\n        transition: all 0.2s ease;\n        cursor: pointer;\n        @include mq(mobile) {\n          font-size: 13px;\n        }\n        &:hover {\n          color: $Blue;\n          @include mq(mobile) {\n            color: unset;\n          }\n        }\n      }\n\n      &.order-2 {\n        @include mq(mobile) {\n          order: 1;\n        }\n      }\n      &.order-3 {\n        @include mq(mobile) {\n          order: 0;\n        }\n      }\n      &.order-0 {\n        @include mq(mobile) {\n          order: 0;\n        }\n      }\n      &.order-1 {\n        @include mq(mobile) {\n          order: 2;\n        }\n      }\n\n      @include mq(mobile) {\n        // display: flex;\n      }\n    }\n  }\n}\n\n//\n//\n//\n.cursor-circle {\n  position: fixed;\n  content: \"drag\";\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  top: 0;\n  left: 0;\n  background-color: rgb(185, 181, 181);\n  z-index: 1000;\n  cursor: none;\n  // pointer-events: none;\n  will-change: transform;\n  &::after {\n    content: \"drag\";\n    font-family: $roman;\n    font-size: 15px;\n    text-transform: capitalize;\n    left: 50%;\n    top: 50%;\n    position: absolute;\n    transform: translate(-50%, -50%);\n  }\n}\n\n.work-page {\n  padding-top: 200px;\n  padding-bottom: 80px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  @include mq(mobile) {\n    padding-top: 140px;\n  }\n  .work-wrapper {\n    .work-banner {\n      display: flex;\n      align-items: center;\n      margin-bottom: 50px;\n      gap: 110px;\n      justify-content: space-between;\n      @include mq(mobile) {\n        flex-direction: column;\n        align-items: flex-start;\n        padding: 0px 0;\n        gap: 20px;\n      }\n      @include mq(tab) {\n        align-items: flex-start;\n        flex-direction: column;\n      }\n      h2 {\n        // flex: 1.5;\n        font-family: $light;\n        text-transform: lowercase;\n        font-size: 180px;\n        line-height: 0.85;\n        @include mq(mobile) {\n          font-size: 60px;\n        }\n        @include mq(tab) {\n          font-size: 100px;\n        }\n        @include mq(desktop) {\n          font-size: 140px;\n        }\n      }\n      p {\n        // flex: 1;\n        font-family: $roman;\n        font-size: 23px;\n        line-height: 1.4;\n        @include mq(mobile) {\n          font-size: 16px;\n        }\n      }\n    }\n  }\n\n  .work-ct {\n    .total-slide {\n      color: black;\n      font-family: $roman;\n      position: absolute;\n      right: 0;\n      top: -65px;\n      font-size: 20px;\n      @include mq(mobile) {\n        font-size: 15px;\n        top: -50px;\n      }\n    }\n  }\n\n  .select-ct {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    // margin-bottom: 100px;\n\n    .btn-filter {\n      border-radius: 50px;\n      border: 1px solid black;\n      font-family: $roman;\n      padding: 7px 20px;\n      cursor: pointer;\n      font-size: 18px;\n      color: black;\n      &:hover {\n        border: white;\n        background-color: white;\n        color: black;\n        border: 1px solid white;\n      }\n    }\n    .btn-filter.active {\n      background-color: white;\n      color: black;\n      border: 1px solid white;\n    }\n\n    @include mq(mobile) {\n      // flex-direction: column;\n      gap: 10px;\n      margin-bottom: 20px;\n      // align-items: stretch;\n    }\n\n    .label-select {\n      font-family: $roman;\n\n      @include mq(mobile) {\n        font-size: 13px;\n      }\n    }\n\n    .select-wrapper {\n      display: flex;\n      gap: 20px;\n      @include mq(mobile) {\n        // flex-wrap: wrap;\n        gap: 5px;\n      }\n      li {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        position: relative;\n\n        @include mq(mobile) {\n          padding: 5px 0px;\n\n          // padding-left: 10px;\n          // padding-right: 10px;\n        }\n\n        .custom-select {\n          min-width: 180px;\n          max-width: 200px;\n          border: none;\n          outline: none;\n          font-family: $roman;\n          font-size: 16px;\n          // text-align: center;\n\n          .css-13cymwt-control {\n            background-color: transparent;\n            border: 1px solid black;\n            border-radius: 50px;\n            cursor: pointer;\n          }\n          .css-t3ipsp-control {\n            background-color: transparent !important;\n            border-color: black !important;\n            border-radius: 50px;\n            box-shadow: none;\n          }\n          .css-b62m3t-container {\n            background-color: transparent;\n          }\n          .css-tipsp-control {\n            background-color: transparent;\n          }\n          .css-1xc3v61-indicatorContainer {\n            color: black;\n            background-color: transparent;\n          }\n          .css-1y632ze-singleValue {\n            padding-left: 5px;\n          }\n\n          @include mq(mobile) {\n            // width: 65px;\n            font-size: 13px;\n            // padding-right: 15px;\n            min-width: 90px;\n            max-width: 200px;\n          }\n        }\n        span {\n          position: absolute;\n          right: 10px;\n          @include mq(mobile) {\n            font-size: 10px;\n          }\n        }\n      }\n    }\n  }\n  .work-card {\n    margin-top: 40px;\n    margin-bottom: 40px;\n    position: relative;\n    min-height: 340px;\n    @include mq(mobile) {\n      margin-top: 20px;\n      margin-bottom: 40px;\n    }\n    .card-wrapper {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      gap: 120px;\n      row-gap: 60px;\n\n      @media (max-width: 1200px) {\n        &.card-wrapper {\n          grid-template-columns: repeat(2, 1fr);\n        }\n      }\n\n      @media (max-width: 900px) {\n        &.card-wrapper {\n          grid-template-columns: repeat(2, 1fr);\n        }\n      }\n\n      @media (max-width: 600px) {\n        &.card-wrapper {\n          grid-template-columns: 1fr;\n        }\n      }\n\n      @include mq(mobile) {\n        gap: 40px;\n      }\n      @include mq(tab) {\n        justify-content: space-between;\n      }\n      // .card-item {\n      //   // flex: 0 0 280px;\n      //   // height: 450px;\n      //   padding-left: 30px;\n      //   padding-bottom: 30px;\n      //   background-color: white;\n\n      //   .copy-wrap {\n      //     padding-right: 30px;\n      //     margin-top: 40px;\n      //     display: flex;\n      //     align-items: flex-end;\n      //     align-items: flex-start;\n      //     justify-content: space-between;\n\n      //     .img-wrapper {\n      //       // flex: 1.5;\n      //       display: none;\n      //       img {\n      //         width: 90px;\n      //       }\n      //     }\n      //     .rolling-copy-wrap {\n      //       padding-top: 0;\n      //       // flex: 1.2;\n      //       width: 400px;\n      //     }\n      //   }\n\n      //   .hover-image-container {\n      //     flex: 1;\n      //     transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);\n      //     // border-radius: 15px;\n      //     display: flex;\n      //     justify-content: flex-end;\n      //     aspect-ratio: unset;\n      //   }\n\n      //   &:hover .hover-image-container {\n      //     border-radius: 0;\n      //   }\n      //   &:hover .discr {\n      //     animation: upToDown 0.45s;\n      //     transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);\n      //   }\n      //   &:hover .hover-img {\n      //     transform: scale(1.05);\n      //   }\n\n      //   &:hover {\n      //     transition: all ease 0.2s;\n      //     .img-wrapper {\n      //       width: 90px;\n      //       display: flex;\n      //       justify-content: flex-end;\n      //       flex-grow: 0;\n      //     }\n      //   }\n\n      //   @include mq(mobile) {\n      //     flex: auto;\n      //   }\n      //   @include mq(tab) {\n      //     flex: 0 0 340px;\n      //   }\n\n      //   .name {\n      //     flex: 1;\n      //     margin-top: 20px;\n      //     font-family: $roman;\n      //     font-size: 22px;\n      //     // padding: 0 20px;\n      //     @include mq(mobile) {\n      //       font-size: 14px;\n      //     }\n      //   }\n      //   .discr {\n      //     font-family: $roman;\n      //     font-size: 40px;\n      //     line-height: 1.2;\n      //     word-wrap: break-word;\n      //     white-space: normal;\n      //   }\n      //   img {\n      //     //border-radius: 20px;\n      //   }\n      // }\n    }\n  }\n\n  //\n  .Slider-heading {\n    font-family: $roman;\n    font-size: 26px;\n    margin-top: 100px;\n    margin-bottom: 20px;\n\n    @include mq(mobile) {\n      margin-top: 50px;\n      font-size: 20px;\n      // margin-bottom: 30px;\n    }\n  }\n  .slider-wrapper {\n    .work-card-wrapper {\n      display: flex;\n      @include mq(mobile) {\n        gap: 10px;\n      }\n\n      .name {\n        padding-left: 20px;\n        font-family: $roman;\n        font-size: 18px;\n        @include mq(mobile) {\n          font-size: 14px;\n          padding-left: 10px;\n        }\n      }\n    }\n    .card-item {\n      .copy-wrap {\n        padding: 0 20px;\n        padding-bottom: 20px;\n        flex: 1;\n        display: flex;\n        height: 130px;\n        align-items: flex-end;\n        justify-content: space-between;\n        .img-wrapper {\n          // flex: 1.5;\n          transform: translate(-30px, 30px); /* Move the arrow from bottom left */\n          opacity: 0; /* Start with the arrow hidden */\n          transition:\n            transform 0.3s ease-in-out,\n            opacity 0.3s ease-in-out;\n          @include mq(mobile) {\n            display: block;\n          }\n          img {\n            width: 50px;\n            @include mq(mobile) {\n              width: 30px;\n            }\n          }\n        }\n        .img-wrapper-1 {\n          padding-bottom: 7px;\n          img {\n            width: 50px;\n          }\n        }\n        .rolling-copy-wrap {\n          padding-top: 0;\n          // flex: 1.2;\n          width: 400px;\n          display: flex;\n        }\n        @include mq(mobile) {\n          height: 70px;\n          padding: 0 10px;\n          padding-bottom: 10px;\n        }\n      }\n\n      .hover-image-container {\n        flex: 2.3;\n        transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);\n        // border-radius: 15px;\n        display: flex;\n        justify-content: flex-end;\n        aspect-ratio: unset;\n\n        .hover-img {\n          transition: all 0.2s ease-in-out;\n        }\n      }\n\n      &:hover .hover-image-container {\n        border-radius: 0;\n      }\n      &:hover .discr {\n        // animation: upToDown 0.45s;\n        // transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);\n      }\n      &:hover .hover-img {\n        transform: scale(1.02);\n        // transform: scale(1);\n      }\n\n      &:hover {\n        transition: all ease 0.2s;\n        .img-wrapper {\n          // width: 90px;\n          transform: translate(0, 0); /* Move to original position and reset rotation */\n          opacity: 1;\n        }\n      }\n    }\n\n    @include mq(mobile) {\n      flex: auto;\n    }\n    @include mq(tab) {\n      flex: 0 0 340px;\n    }\n    .name-wrap {\n      margin-top: 20px;\n    }\n\n    .category {\n      margin-top: 20px;\n    }\n\n    .name {\n      flex: 1;\n      font-family: $roman;\n      font-size: 34px;\n      line-height: 1.2;\n\n      // padding-left: 30px;\n      // padding: 0 20px;\n      @include mq(mobile) {\n        font-size: 22px;\n        margin-top: 10px;\n      }\n    }\n    .discr {\n      font-family: $roman;\n      font-size: 40px;\n      line-height: 1.2;\n      word-wrap: break-word;\n      white-space: normal;\n    }\n    img {\n      //border-radius: 20px;\n    }\n    button {\n      // background-color: #007bff; /* Blue background */\n      // color: white; /* White text */\n      border: none; /* Remove borders */\n      // padding: 10px 20px; /* Padding */\n      border-radius: 5px; /* Rounded corners */\n      cursor: pointer; /* Change cursor to pointer */\n      &.left-arrow {\n        width: 55px;\n        transform: rotate(180deg);\n        // position: \"absolute\": top: \"-50px\", right: \"100px\"\n        position: absolute;\n        top: -62px;\n        right: 60px;\n        padding: 10px;\n        padding-right: 0;\n        width: 40px;\n        position: absolute;\n        top: -45px;\n        @include mq(mobile) {\n          width: 25px;\n          right: 50px;\n          top: -30px;\n          padding: 5px;\n        }\n      }\n      &.right-arrow {\n        width: 55px;\n        position: absolute;\n        top: -62px;\n        right: 10px;\n        padding: 10px;\n        padding-right: 0;\n        width: 40px;\n        position: absolute;\n        top: -45px;\n        right: 0;\n        @include mq(mobile) {\n          width: 25px;\n          top: -30px;\n          padding: 5px;\n        }\n      }\n    }\n\n    button:hover {\n      // background-color: #0056b3; /* Darker blue on hover */\n    }\n  }\n  .show-more-btn {\n    border-bottom: 1px solid black;\n  }\n\n  .empty-filter-result {\n    font-family: $roman;\n    font-size: 20px;\n  }\n}\n\n.user-card {\n  .card-wrapper {\n    display: flex;\n  }\n}\n.wrapper-player {\n  .player {\n    padding: 5rem 0;\n    padding-top: 140px;\n    width: 90%;\n    @include mq(desktop) {\n      min-height: 100vh;\n    }\n\n    @include mq(mobile) {\n      padding-right: 15px;\n      padding-left: 15px;\n      padding-bottom: 40px;\n      width: 100%;\n    }\n    .player-copy-wrapper {\n      // display: flex;\n      gap: 30px;\n\n      .player-gif {\n        cursor: url(\"../images/Playbutton.png\"), auto;\n        width: 100%;\n        height: auto;\n      }\n      @include mq(mobile) {\n        flex-direction: column;\n        gap: 10px;\n      }\n      .page-copy {\n        flex: 1.2;\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        justify-content: center;\n        gap: 10px;\n        margin-bottom: 20px;\n        @include mq(mobile) {\n          gap: 10px;\n        }\n\n        .top-left-copy {\n          font-size: 55px;\n          font-family: $roman;\n          line-height: 1.2;\n          @include mq(mobile) {\n            font-size: 28px;\n          }\n        }\n        .top-bottom-copy {\n          font-size: 22px;\n          font-family: $roman;\n          line-height: 1;\n          @include mq(mobile) {\n            font-size: 16px;\n          }\n        }\n      }\n    }\n    .player-container {\n      flex: 2;\n      // max-width: 860px;\n      margin: 0 auto;\n      // display: flex;\n      @include mq(mobile) {\n        margin: unset;\n      }\n    }\n    .player-head {\n      font-size: 46px;\n      font-family: $roman;\n      @include mq(mobile) {\n        font-size: 30px;\n      }\n    }\n    .nav-work-wrapper {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      a {\n        font-family: $roman;\n        text-decoration: underline;\n      }\n    }\n    .player-para {\n      font-size: 24px;\n      font-family: $roman;\n    }\n    .player-wrapper-small {\n      position: relative;\n      padding-top: 56.25%;\n      background: #000;\n      // border-radius: 10px;\n      overflow: hidden;\n      // margin-top: 20px;\n      .spinner span {\n        border: 3px solid white;\n        border-right-color: rgba(119, 119, 119, 0.702);\n      }\n      .react-player {\n        position: absolute;\n        top: 0;\n        left: 0;\n      }\n    }\n\n    .copy-thumbnail {\n      font-family: $roman;\n      font-size: 22px;\n      margin-top: 20px;\n      @include mq(mobile) {\n        // text-align: center;\n        font-size: 16px;\n      }\n    }\n    .video-thumbnails {\n      margin-top: 20px;\n      gap: 20px;\n      display: flex;\n      justify-content: flex-start;\n      cursor: pointer;\n      @include mq(mobile) {\n        flex-wrap: wrap;\n        gap: 10px;\n        margin-top: 10px;\n      }\n      .thumbnail-item {\n        // border-radius: 10px;\n        overflow: hidden;\n        max-width: 140px;\n        border: 1px solid transparent;\n        transition: all 0.3s ease;\n        position: relative;\n        &:hover {\n          border: 1px solid white;\n        }\n        .vimeo-play-icon {\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n          transition: all 0.3 ease;\n          color: #ffffffc2;\n          font-size: 24px;\n        }\n        &:hover .vimeo-play-icon {\n          color: white;\n        }\n        @include mq(mobile) {\n          flex: 0 0 24%;\n        }\n      }\n      .thumbnail-item.active {\n        // border: 1px solid white;\n      }\n    }\n  }\n\n  .video-details {\n    background-color: white;\n    padding: 64px 0;\n    @include mq(mobile) {\n      padding-top: 40px;\n      padding-bottom: 40px;\n    }\n    .video-detail-wrapper {\n      max-width: 1110px;\n      display: flex;\n\n      gap: 130px;\n      flex-direction: row-reverse;\n      @include mq(mobile) {\n        gap: 50px;\n        flex-direction: column-reverse;\n      }\n      .detail-item {\n        display: flex;\n        flex-direction: column;\n        flex: 1.2;\n        gap: 2rem;\n        // display: flex;\n        .client {\n          font-family: $roman;\n          // border-bottom: 1px solid black;\n          width: max-content;\n          line-height: 1;\n          margin-bottom: 5px;\n          font-size: 30px;\n          @include mq(mobile) {\n            font-size: 28px;\n          }\n        }\n        .work-title {\n          font-family: $roman;\n          color: black;\n          font-size: 17px;\n          margin-top: 12px;\n          @include mq(mobile) {\n            font-size: 16px;\n            margin-top: 7px;\n          }\n        }\n      }\n      .detail-item-2 {\n        flex: 2;\n      }\n    }\n  }\n\n  .shoot-image {\n    background-image: url(\"../images/hero_bg.png\");\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    padding: 64px 0;\n    padding-bottom: 6rem;\n    @include mq(mobile) {\n      padding-top: 40px;\n      padding-bottom: 40px;\n    }\n\n    .head-copy {\n      font-family: $roman;\n      font-size: 60px;\n      margin-bottom: 32px;\n      line-height: 1;\n      text-align: center;\n      @include mq(mobile) {\n        font-size: 40px;\n        margin-bottom: 20px;\n      }\n    }\n    .image-wrapper {\n      // display: flex;\n      // flex-wrap: wrap;\n      // gap: 3rem;\n      position: relative;\n      .slick-slide {\n        // margin: 0 20px;\n        padding: 0 20px;\n      }\n      .img-flex-item {\n        flex: 1 0 48%;\n        // border-radius: 20px;\n        overflow: hidden;\n\n        img {\n          width: 100%;\n        }\n        @include mq(mobile) {\n          // border-radius: 10px !important;\n        }\n      }\n    }\n  }\n\n  .all-details {\n    background-color: white;\n    padding: 4rem 0;\n    padding-top: 32px;\n    @include mq(mobile) {\n      padding-top: 20px;\n      padding-bottom: 20px;\n    }\n    .all-details-wrapper {\n      max-width: 1110px;\n      .wrapper-flex {\n        .flex-item-wrapper {\n          padding: 40px 0;\n          display: flex;\n          // border-bottom: 0.5px solid $grayC;\n          align-items: flex-start;\n          @include mq(mobile) {\n            flex-direction: column;\n            padding: 20px 0;\n            row-gap: 10px;\n            align-items: flex-start;\n          }\n          &:last-child {\n            border-bottom: none;\n          }\n          .title {\n            flex: 1.5 0;\n            h4 {\n              font-family: $roman;\n              font-size: 34px;\n              // border-bottom: 1px solid black;\n              width: fit-content;\n              @include mq(mobile) {\n                font-size: 28px;\n              }\n            }\n          }\n\n          .copy {\n            flex: 2;\n            display: flex;\n            justify-content: space-between;\n            flex-wrap: wrap;\n\n            .copy-item {\n              flex: 1 1 28%;\n              display: flex;\n              flex-direction: column;\n              align-items: flex-start;\n\n              @include mq(mobile) {\n                // align-items: center;\n\n                gap: 0px;\n                width: 100%;\n              }\n\n              .copy-head {\n                font-size: 48px;\n                font-family: $roman;\n                img {\n                  width: 100px;\n                }\n                margin-bottom: 5px;\n                line-height: 1.2;\n                @include mq(mobile) {\n                  font-size: 38px;\n                  margin-bottom: 0;\n                  line-height: 1.2;\n                  img {\n                    width: 80px;\n                  }\n                }\n              }\n              .copy-para {\n                font-size: 14px;\n                font-family: $roman;\n                // font-weight: 700;\n                color: black;\n                // text-transform: uppercase;\n                @include mq(mobile) {\n                  text-align: start;\n                }\n              }\n              .copy-meta {\n                @include flexbox();\n                align-items: center;\n                column-gap: 10px;\n                flex-wrap: wrap;\n                justify-content: flex-start;\n                color: $grayC;\n\n                p {\n                  font-size: 14px;\n                }\n                @include mq(mobile) {\n                  justify-content: center;\n                }\n              }\n            }\n            &.copy-text {\n              font-family: $roman;\n              line-height: 1.4;\n              font-size: 20px;\n              color: black;\n              @include mq(mobile) {\n                font-size: 16px;\n                margin-top: 0px;\n              }\n            }\n\n            &.award-mobile {\n              display: grid;\n              grid-template-columns: repeat(3, 1fr);\n              gap: 30px;\n              justify-items: flex-start;\n\n              @include mq(mobile) {\n                width: 100%;\n                margin-top: 20px;\n                // flex-direction: column;\n                align-items: center;\n                gap: 20px;\n              }\n\n              .copy-item {\n                // align-items: center;\n                @include mq(mobile) {\n                  gap: 10px;\n                }\n              }\n            }\n\n            @media (max-width: 1200px) {\n              &.award-mobile {\n                grid-template-columns: repeat(3, 1fr);\n                gap: 30px;\n              }\n            }\n\n            @media (max-width: 900px) {\n              &.award-mobile {\n                grid-template-columns: repeat(2, 1fr);\n              }\n            }\n\n            @media (max-width: 600px) {\n              &.award-mobile {\n                grid-template-columns: repeat(2, 1fr);\n                gap: 20px;\n                row-gap: 30px;\n                width: 100%;\n                align-items: flex-start;\n              }\n            }\n            &.result-mobile {\n              display: grid;\n              grid-template-columns: repeat(3, 1fr);\n              justify-items: start;\n              gap: 30px;\n\n              @include mq(mobile) {\n                display: grid;\n                grid-template-columns: repeat(2, 1fr);\n                gap: 10px;\n                margin-top: 20px;\n                align-self: center;\n                // flex-direction: column;\n                gap: 20px;\n              }\n              @media (max-width: 1200px) {\n                &.result-mobile {\n                  grid-template-columns: repeat(3, 1fr);\n                  gap: 30px;\n                }\n              }\n\n              @media (max-width: 900px) {\n                &.result-mobile {\n                  grid-template-columns: repeat(2, 1fr);\n                }\n              }\n\n              @media (max-width: 600px) {\n                &.result-mobile {\n                  grid-template-columns: repeat(2, 1fr);\n                  gap: 20px;\n                  row-gap: 30px;\n                  width: 100%;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .related-work {\n    padding: 64px 0;\n    @include mq(mobile) {\n      padding: 40px 0;\n    }\n\n    .related-work-wrapper {\n      .head-copy {\n        font-family: $roman;\n        font-size: 60px;\n        margin-bottom: 2rem;\n        text-align: center;\n        @include mq(mobile) {\n          font-size: 40px;\n        }\n      }\n      .wrapper-flex {\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        gap: 40px;\n        @include mq(mobile) {\n          grid-template-columns: repeat(1, 1fr);\n\n          gap: 40px;\n        }\n\n        .flex-item {\n          flex: 1 0 48%;\n          display: flex;\n          flex-direction: column;\n\n          .hover-image-container {\n            transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);\n            // border-radius: 15px;\n            @include mq(mobile) {\n              // border-radius: 7px;\n            }\n          }\n          &:hover .hover-image-container {\n            border-radius: 0;\n          }\n          &:hover .discr,\n          &:hover .arrow-wrapper > img {\n            // animation: upToDown 0.45s;\n            transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);\n          }\n          &:hover img {\n            transform: scale(1.1);\n          }\n\n          .main-image {\n            // border-radius: 15px;\n            margin-bottom: 10px;\n          }\n          .img-title {\n            .name {\n              margin-top: 0px;\n              font-family: $roman;\n              font-size: 16px;\n              @include mq(mobile) {\n                font-size: 14px;\n              }\n            }\n            h4 {\n              font-family: $roman;\n              font-size: 20px;\n              line-height: 1.2;\n              margin-bottom: 5px;\n              @include mq(mobile) {\n                font-size: 22px;\n                margin-bottom: 0px;\n              }\n            }\n            .view-more {\n              font-family: $roman;\n              font-size: 13px;\n              border-bottom: 1px solid black;\n              max-width: fit-content;\n            }\n          }\n          .rolling-copy-wrap {\n            .arrow-png {\n              width: 20px;\n              transform: translate(-10px, 10px); /* Move the arrow from bottom left */\n              opacity: 0; /* Start with the arrow hidden */\n              transition:\n                transform 0.3s ease-in-out,\n                opacity 0.3s ease-in-out;\n            }\n            .arrow-png-1 {\n              @include mq(mobile) {\n                width: 20px;\n                padding-bottom: 5px;\n              }\n            }\n          }\n\n          &:hover {\n            .arrow-png {\n              transform: translate(0, 0); /* Move to original position and reset rotation */\n              opacity: 1;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.spinner {\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  // top: 85%;\n\n  span {\n    display: block;\n    width: 30px;\n    height: 30px;\n    border: 3px solid transparent;\n    border-radius: 50%;\n    border-right-color: #000000b3;\n    animation: spinner-anim 0.8s linear infinite;\n  }\n\n  &.spinner-int {\n    top: 85%;\n  }\n  &.spinner-news {\n    top: 85%;\n  }\n}\n\n@keyframes spinner-anim {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.reset-btn {\n  font-family: $bold;\n  text-decoration: underline;\n}\n\n.scroll-down-svg {\n  left: 50%;\n  transform: translateY(0%) rotate(45deg);\n  opacity: 1;\n}\n\n.scroll-down-svg1 {\n  width: 2em;\n  height: 2em;\n  background-color: transparent;\n  z-index: 80;\n  bottom: 40px;\n  position: absolute;\n  border-width: 0 0.25em 0.25em 0;\n  border-style: solid;\n  border-color: rgb(0, 0, 0);\n  animation: scrolldown 1.2s ease-in-out infinite;\n}\n\n.scroll-down-svg2 {\n  width: 2em;\n  height: 2em;\n  background-color: transparent;\n  z-index: 80;\n  bottom: 60px;\n  position: absolute;\n  border-width: 0 0.16em 0.16em 0;\n  border-style: solid;\n  border-color: white;\n  // animation: scrolldown 1.2s ease-in-out infinite 0.15s;\n  @include mq(mobile) {\n    bottom: 20px;\n    width: 1em;\n    height: 1em;\n    border-width: 0 0.14em 0.14em 0;\n  }\n}\n\n@keyframes scrolldown {\n  0% {\n    transform: translateY(20%) rotate(45deg);\n    opacity: 0.7;\n  }\n  50% {\n    transform: translateY(0%) rotate(45deg);\n    opacity: 0.1;\n  }\n  100% {\n    transform: translateY(20%) rotate(45deg);\n    opacity: 0.7;\n  }\n}\n\n.hover-image-container {\n  position: relative;\n  margin-bottom: 10px;\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n  // border-radius: 15px;\n  // background: #e4e4e4;\n  &::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background: #e5e5e5;\n    opacity: 0;\n    transition: 0.4s ease all;\n  }\n  .main-image {\n    transition: 0.4s ease all;\n    width: 100%;\n    object-fit: cover;\n  }\n}\n\n.rolling-copy-wrap {\n  // padding-top: 40px;\n  overflow: hidden;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  // padding-right: 20px;\n\n  @include mq(mobile) {\n    padding-top: 5px;\n    padding-top: 5px;\n    align-items: flex-end;\n    padding-right: 5px;\n  }\n}\n\n@keyframes upToDown {\n  49% {\n    transform: translateY(-100%);\n  }\n  50% {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n  51% {\n    opacity: 1;\n  }\n}\n\n.divider {\n  border-bottom: 1px solid;\n}\n\n#news {\n  padding-top: 200px;\n  padding-bottom: 60px;\n  @include mq(mobile) {\n    padding-top: 140px;\n    padding-bottom: 40px;\n  }\n  .news-header {\n    h2 {\n      font-size: 140px;\n      font-family: $light;\n      text-transform: lowercase;\n      line-height: 100%;\n      margin-bottom: 50px;\n    }\n    @include mq(mobile) {\n      h2 {\n        font-size: 60px;\n        margin-bottom: 5px;\n      }\n    }\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    .filter-wrapper {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      margin-bottom: 9px;\n      font-family: $roman;\n      @include mq(mobile) {\n        // display: none;\n        margin-bottom: 0px;\n      }\n    }\n  }\n  .news-list {\n    min-height: 340px;\n    @include flexbox();\n    gap: 40px;\n    flex-wrap: wrap;\n    // margin-top: 60px;\n    row-gap: 60px;\n    // display: grid;\n    // grid-template-columns: repeat(3, 1fr);\n\n    .news-item {\n      @include flexbox();\n      // flex-direction: column;\n      // justify-content: flex-start;\n      // flex-basis: calc(30% - 10px);\n      align-items: flex-start;\n      gap: 35px;\n      border-bottom: 1px solid black;\n      padding-bottom: 60px;\n\n      @include mq(mobile) {\n        flex-direction: column !important;\n        gap: 20px !important;\n      }\n\n      &:last-child {\n        border-bottom: none;\n      }\n\n      .tumbnail-img {\n        flex: 1;\n        @include mq(mobile) {\n          flex: unset;\n        }\n      }\n\n      .copy-wrap {\n        flex: 2.7;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        align-items: flex-start;\n        // flex-grow: 1;\n        height: 100%;\n        .rolling-copy-wrap {\n          display: block !important;\n        }\n        @include mq(mobile) {\n          gap: 5px;\n        }\n      }\n      .top-wrap {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        align-items: flex-start;\n        gap: 5px;\n        @include mq(mobile) {\n          gap: 5px;\n        }\n      }\n      .arrow-wrapper-test {\n        flex: 0.07;\n        align-self: center;\n        margin-left: 10px;\n        @include mq(mobile) {\n          margin-left: 5px;\n        }\n        img {\n          transform: translate(-20px, 20px); /* Move the arrow from bottom left */\n          opacity: 0; /* Start with the arrow hidden */\n          transition:\n            transform 0.3s ease-in-out,\n            opacity 0.3s ease-in-out;\n          display: inline-block;\n          width: 18px;\n          @include mq(mobile) {\n            width: 12px;\n          }\n        }\n      }\n      //\n      .hover-image-container {\n        // transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);\n        // border-radius: 15px;\n        margin-bottom: 0;\n\n        img {\n          transition: transform 0.3s ease-in-out; /* Smooth scaling transition */\n          transform: scale(1); /* Start at normal size */\n          will-change: transform; /* Optimize for smooth animations */\n          transform-origin: center;\n        }\n        @include mq(mobile) {\n          // border-radius: 7px;\n        }\n      }\n      // Image animation only on thumbnail or title hover\n      .hover-image-container:hover img {\n        transform: scale(1.03);\n      }\n      &:has(.rolling-copy-wrap:hover) .hover-image-container img {\n        transform: scale(1.03);\n      }\n      .rolling-copy-wrap:hover .arrow-wrapper-test > img {\n        // transform: scale(1.1);\n        transform: translate(0, 0); /* Move to original position and reset rotation */\n        opacity: 1;\n      }\n      &:has(.hover-image-container:hover) .arrow-wrapper-test > img {\n        transform: translate(0, 0);\n        opacity: 1;\n      }\n\n      //\n      .news-title {\n        font-family: $roman;\n        font-size: 28px;\n        line-height: 1.4;\n        @include mq(mobile) {\n          font-size: 18px;\n        }\n      }\n      .date {\n        font-family: $roman;\n        font-size: 14px;\n        // margin-top: 20px;\n        @include mq(mobile) {\n          font-size: 12px;\n        }\n      }\n      .title {\n        font-size: 16px;\n        font-family: $roman;\n        border: 1px black solid;\n        padding: 5px 18px;\n        border-radius: 50px;\n        width: max-content;\n        color: black;\n        margin-bottom: 10px;\n        @include mq(mobile) {\n          margin-bottom: 0px;\n          font-size: 12px;\n          padding: 3px 15px;\n        }\n      }\n      @include mq(mobile) {\n        // flex-basis: calc(50% - 10px);\n        flex-direction: row;\n        gap: 10px;\n        padding-bottom: 30px;\n        border-bottom: 0.7px solid;\n      }\n    }\n    @include mq(mobile) {\n      margin-top: 15px;\n      row-gap: 25px;\n    }\n  }\n\n  @media (max-width: 1200px) {\n    .news-list {\n      // grid-template-columns: repeat(2, 1fr);\n    }\n  }\n\n  @media (max-width: 900px) {\n    .news-list {\n      // grid-template-columns: repeat(2, 1fr);\n    }\n  }\n\n  @media (max-width: 600px) {\n    .news-list {\n      // grid-template-columns: 1fr;\n    }\n  }\n}\n\n/* LIGHTBOX  */\n.yarl__button.yarl__navigation_next,\n.yarl__button.yarl__navigation_prev {\n  display: none;\n}\n\n.yarl__portal_open {\n  z-index: 100000;\n}\n\n.show-more-button {\n  border: 1px solid rgba(19, 19, 19, 0.737);\n  border: none;\n  padding: 4px 12px;\n  // border-radius: 25px;\n  font-size: 16px;\n  font-family: $roman;\n  transition: all 0.3s ease;\n  padding: 0;\n  // padding-bottom: ;\n  border-bottom: 1px solid;\n  cursor: pointer;\n  &:hover {\n    // background: black;\n    color: white;\n  }\n}\n\n.show-more-wrap {\n  position: relative;\n  @include flexbox();\n  margin-top: 60px;\n  justify-content: center;\n  @include mq(mobile) {\n    margin-top: 25px;\n  }\n}\n\n.react-player {\n  width: 100% !important;\n  height: 100% !important;\n  .Button_module_button__a2d215de {\n    display: none;\n  }\n}\n\n.react-player iframe {\n  width: 100%;\n  height: 100%;\n}\n\n.back-link {\n  transition: all 0.2s ease;\n  &:hover {\n    color: white;\n  }\n}\n\n/* SCATTER ANIMATION */\n\n.scatter-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 770px;\n  position: relative;\n  overflow: unset;\n  // padding-top: 80px;\n  // padding-bottom: 80px;\n\n  @include mq(mobile) {\n    overflow: hidden;\n    padding-top: 0px;\n    padding-bottom: 0px;\n    height: 650px;\n  }\n\n  .image-container {\n    position: absolute;\n    // display: flex;\n    // gap: 5px;\n    // align-items: flex-start;\n    // justify-content: flex-start;\n    // width: 150px;\n    border-radius: 10px;\n    cursor: pointer;\n    flex-direction: column;\n\n    .image {\n      width: 100%;\n      // border-radius: 15px;\n      @include mq(mobile) {\n        // border-radius: 10px;\n      }\n    }\n\n    .text-overlay {\n      // position: absolute;\n      // bottom: 10px;\n      // left: 6px;\n      // // background: rgba(0, 0, 0, 0.6);\n      // color: white;\n      // padding: 2px 5px;\n      // border-radius: 5px;\n      margin-top: 10px;\n      font-family: $roman;\n      font-size: 15px;\n\n      @include mq(mobile) {\n        bottom: 5px;\n        left: 3px;\n        font-size: 10px;\n        font-family: $roman;\n        margin-top: 7px;\n      }\n    }\n  }\n\n  .center-text {\n    font-size: 100px;\n    font-family: $light;\n    line-height: 100%;\n    color: white;\n    text-align: center;\n    z-index: 1;\n\n    @include mq(mobile) {\n      font-size: 34px;\n      font-family: $roman;\n      font-size: 40px;\n    }\n\n    @include mq(tab) {\n      font-size: 60px;\n    }\n  }\n}\n\n.skeleton-wrap span {\n  border-radius: 0;\n}\n\n.add-accounts-page-css {\n  .container-ad {\n    max-width: 1200px;\n    margin: 0 auto;\n    width: 90%;\n    // padding: 0 15px;\n\n    @include mq(tab) {\n      // max-width: 768px;\n    }\n\n    @include mq(mobile) {\n      max-width: 320px;\n    }\n  }\n  header {\n    padding: 52px 0;\n    @include mq(mobile) {\n      padding: 20px 0;\n    }\n    .logo {\n      @include mq(mobile) {\n        width: 120px;\n      }\n    }\n    nav {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n    }\n\n    .nav-list {\n      display: flex;\n      align-items: center;\n\n      .nav-item {\n        font-size: 14px;\n        font-family: $medium;\n        margin-right: 31px;\n        letter-spacing: 0%;\n        color: #6e5e7e;\n        @include mq(mobile) {\n          margin-right: 0;\n        }\n      }\n    }\n\n    a {\n      display: block;\n    }\n\n    .login-btn,\n    .getin-btn {\n      font-family: $Mregular;\n      font-size: 15px;\n      line-height: 20px;\n      padding: 12px 25px;\n      border-radius: 40px;\n      letter-spacing: -0.23px;\n    }\n\n    .login-btn {\n      border: 1px solid black;\n      margin-right: 10px;\n      margin-left: 97px;\n      @include mq(mobile) {\n        margin-left: 0;\n        margin-right: 0;\n      }\n    }\n\n    .getin-btn {\n      // border: 1px solid black;\n      // background-color: black;\n      background: rgb(143, 55, 200);\n      background: linear-gradient(\n        0deg,\n        rgba(143, 55, 200, 1) 0%,\n        rgba(159, 63, 181, 1) 8%,\n        rgba(210, 89, 125, 1) 22%,\n        rgba(242, 105, 91, 1) 39%,\n        rgba(255, 112, 78, 1) 51%,\n        rgba(255, 101, 104, 1) 65%,\n        rgba(255, 94, 125, 1) 79%,\n        rgba(255, 143, 107, 1) 98%\n      );\n      color: white;\n    }\n\n    .hamburger-1 {\n      display: none;\n      flex-direction: column;\n      justify-content: space-between;\n      width: 34px;\n      height: 18px;\n      background: none;\n      border: none;\n      cursor: pointer;\n      z-index: 1000;\n\n      .bar {\n        width: 100%;\n        height: 2px;\n        background-color: #5c3688;\n        transition: all 0.3s ease;\n      }\n\n      &.active .bar:nth-child(1) {\n        transform: rotate(45deg) translate(5px, 5px);\n      }\n\n      &.active .bar:nth-child(2) {\n        opacity: 0;\n      }\n\n      &.active .bar:nth-child(3) {\n        transform: rotate(-45deg) translate(5px, -5px);\n      }\n    }\n\n    @media screen and (max-width: 768px) {\n      .nav-list {\n        position: fixed;\n        top: -100%;\n        right: 0;\n        width: 100%;\n        background-color: white;\n        flex-direction: column;\n        align-items: center;\n        padding: 20px;\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n        transition: top 0.4s ease;\n\n        &.active {\n          // top: 52px;\n          padding-top: 100px;\n          top: 0;\n          display: flex;\n          flex-direction: column;\n          height: 100vh;\n          background-color: white;\n          gap: 20px; // Adjust this value based on your header height\n          z-index: 5;\n        }\n      }\n\n      .hamburger-1 {\n        display: flex;\n      }\n    }\n  }\n  .no-scroll {\n    overflow: hidden;\n    height: 100%;\n    position: fixed;\n    width: 100%;\n  }\n\n  .scroll-top-btn {\n    background-color: red;\n    background: linear-gradient(\n      0deg,\n      rgb(143, 55, 200) 0%,\n      rgb(159, 63, 181) 8%,\n      rgb(210, 89, 125) 22%,\n      rgb(242, 105, 91) 39%,\n      rgb(255, 112, 78) 51%,\n      rgb(255, 101, 104) 65%,\n      rgb(255, 94, 125) 79%,\n      rgb(255, 143, 107) 98%\n    );\n    // padding: 20px;\n    font-size: 25px;\n    color: white;\n    width: 50px;\n    height: 50px;\n    border-radius: 50px;\n  }\n\n  // main\n  main {\n    #home {\n      .hero-copy {\n        margin-top: 12px;\n        font-family: $Msemibold;\n        font-size: 57px;\n        line-height: 70px;\n        color: #5c3688;\n        margin-bottom: 40px;\n        @include mq(mobile) {\n          text-align: center;\n\n          font-size: 32px;\n          line-height: 1.2;\n          margin-top: 40px;\n          margin-bottom: 50px;\n        }\n        @include mq(tab) {\n          font-size: 50px;\n          text-align: center;\n          line-height: 70px;\n        }\n      }\n      .services {\n        // display: f;\n        display: grid;\n        grid-template-columns: repeat(2, 2fr);\n        gap: 35px;\n        // gap: 60px;\n        @include mq(mobile) {\n          // flex-direction: column;\n          display: grid;\n          grid-template-columns: repeat(2, 2fr);\n          gap: 35px;\n        }\n      }\n      .wrapper {\n        display: flex;\n        gap: 20px;\n        @include mq(mobile) {\n          align-items: center;\n          flex-direction: column;\n        }\n      }\n      .orange-ring {\n        width: 60px;\n        height: 60px;\n        border: 2px solid #f17380;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        p {\n          // text-align: center;\n          font-family: $Mregular;\n          color: #6e5e7e;\n          font-size: 30px;\n        }\n      }\n      .copy {\n        color: #6e5e7e;\n        font-family: $Mregular;\n        line-height: 28px;\n        font-size: 28px;\n        font-weight: 600;\n        @include mq(mobile) {\n          line-height: 1.2;\n          font-size: 20px;\n          text-align: center;\n        }\n      }\n      .homepage-btn {\n        margin-top: 52px;\n        display: flex;\n        justify-content: center;\n        @include mq(mobile) {\n          margin-top: 40px;\n        }\n      }\n      .login-btn {\n        font-family: $Mregular;\n        font-size: 15px;\n        line-height: 20px;\n        padding: 22px 44px;\n        border: 1px solid black;\n        border-radius: 40px;\n        margin-right: 20px;\n        letter-spacing: -0.23px;\n      }\n      .getin-btn {\n        font-family: $Mregular;\n        font-size: 15px;\n        line-height: 20px;\n        padding: 22px 83px;\n        // border: 1px solid black;\n        border-radius: 40px;\n        // background-color: black;\n        background: rgb(143, 55, 200);\n        background: linear-gradient(\n          0deg,\n          rgba(143, 55, 200, 1) 0%,\n          rgba(159, 63, 181, 1) 8%,\n          rgba(210, 89, 125, 1) 22%,\n          rgba(242, 105, 91, 1) 39%,\n          rgba(255, 112, 78, 1) 51%,\n          rgba(255, 101, 104, 1) 65%,\n          rgba(255, 94, 125, 1) 79%,\n          rgba(255, 143, 107, 1) 98%\n        );\n        color: white;\n        letter-spacing: -0.23px;\n      }\n\n      .wrapper-form-banner {\n        display: flex;\n        gap: 0px;\n        align-items: start;\n        @include mq(mobile) {\n          flex-direction: column;\n          align-items: stretch;\n        }\n\n        .wrapper-form-form {\n          flex: 1;\n          padding: 15px 40px;\n          margin-top: 10px;\n          background: linear-gradient(\n            0deg,\n            rgb(143, 55, 200) 0%,\n            rgb(159, 63, 181) 8%,\n            rgb(210, 89, 125) 22%,\n            rgb(242, 105, 91) 39%,\n            rgb(255, 112, 78) 51%,\n            rgb(255, 101, 104) 65%,\n            rgb(255, 94, 125) 79%,\n            rgb(255, 143, 107) 98%\n          );\n\n          @include mq(mobile) {\n            padding: 20px;\n          }\n        }\n        .wrapper-form-copy {\n          flex: 1.6;\n        }\n\n        .form-wrapper-get-in-touch {\n          // margin: 60px 0;\n          // margin-top: 80px;\n          margin-bottom: 0;\n          // padding: 30px 0;\n          padding-bottom: 0px;\n          display: flex;\n          flex-direction: column;\n          // -webkit-box-shadow: inset 0px 5px 16px -15px rgba(0, 0, 0, 0.57);\n          // -moz-box-shadow: inset 0px 5px 16px -15px rgba(0, 0, 0, 0.57);\n          // box-shadow: inset 0px 5px 16px -15px rgba(0, 0, 0, 0.57);\n          div {\n            // max-width: 500px;\n            // margin: auto;\n            // padding: 20px;\n            // background-color: #f9f9f9;\n            border-radius: 8px;\n            // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n            width: 100%;\n\n            @include mq(mobile) {\n              // padding: 10px;\n            }\n          }\n          .input-wrapper {\n            // max-width: 400px;\n            margin-top: 7px;\n            margin-bottom: 15px;\n            display: flex;\n            flex-direction: column;\n            // gap: 10px;\n\n            @include mq(mobile) {\n              gap: 5px;\n\n              label {\n                text-align: center;\n              }\n            }\n          }\n\n          .wrapper-radio-btn {\n            display: flex;\n            justify-content: center;\n            flex-direction: column;\n            padding: 0;\n            gap: 0px;\n            @include mq(mobile) {\n              display: grid;\n              grid-template-columns: repeat(2, 1fr);\n            }\n          }\n\n          .error-form {\n            font-family: $Msemibold;\n            font-size: 13px;\n            padding-top: 5px;\n            text-align: left;\n          }\n          .error-wrapper {\n            padding: 0;\n            margin-top: 10px;\n          }\n\n          .radio-btn-section {\n            // display: flex;\n            justify-content: center;\n            // gap: 40px;\n            padding: 0;\n          }\n\n          h2 {\n            text-align: center;\n            font-family: $Msemibold;\n            color: white;\n            font-size: 20px;\n            padding-bottom: 20px;\n\n            @include mq(mobile) {\n              // font-size: 20px;\n            }\n          }\n\n          form {\n            display: flex;\n            flex-direction: column;\n            gap: 5px;\n          }\n          .form-grid {\n            display: flex;\n            flex-direction: column;\n            gap: 10px;\n            // grid-template-columns: repeat(2, 1fr);\n            @include mq(mobile) {\n              display: flex;\n              flex-direction: column;\n            }\n          }\n\n          label {\n            font-weight: bold;\n            color: white;\n            margin-bottom: 5px;\n            font-family: $Msemibold;\n            font-size: 30px;\n            @include mq(mobile) {\n              font-size: 22px;\n            }\n          }\n          select {\n            // color: #5c3688 !important;\n            padding: 7px 20px;\n            border: 1px solid white;\n            border-radius: 50px;\n            font-size: 18px;\n            width: 100%;\n            color: white !important;\n            font-family: $DMregular;\n          }\n\n          input[type=\"text\"],\n          input[type=\"number\"] {\n            padding: 7px 20px;\n            border: 1px solid white;\n            border-radius: 50px;\n            font-size: 18px;\n            width: 100%;\n            color: white !important;\n            font-family: $DMregular;\n          }\n\n          input::placeholder {\n            color: white; /* Placeholder text color */\n            // font-style: italic; /* Italic style */\n            font-size: 18px; /* Font size */\n            opacity: 0.8; /* Thoda transparent effect */\n            font-family: $DMregular;\n            text-transform: capitalize;\n            // text-align: center;\n          }\n\n          .radio-label {\n            display: inline-flex;\n            align-items: center;\n            margin-right: 15px;\n            font-size: 22px;\n            font-family: $Msemibold;\n            @include mq(mobile) {\n              font-size: 15px;\n            }\n          }\n\n          .radio-input {\n            width: 16px;\n            height: 16px;\n            margin-right: 15px;\n            padding: 10px;\n            border-radius: 50%;\n            border: 2px solid #5c3688;\n            transition:\n              background-color 0.3s,\n              border 0.3s;\n            @include mq(mobile) {\n              padding: 7px;\n            }\n          }\n\n          .radio-input:checked {\n            background-color: #4f1d89;\n            border-color: #4f1d89;\n          }\n\n          .radio-input:checked + .radio-label {\n            font-weight: bold;\n          }\n\n          p {\n            color: red;\n            font-size: 14px;\n            margin: 0;\n          }\n\n          button {\n            padding: 10px 20px;\n            background-color: #4caf50;\n            color: white;\n            border: none;\n            border-radius: 5px;\n            cursor: pointer;\n            font-size: 16px;\n            transition: background-color 0.3s;\n          }\n\n          button:hover {\n            background-color: #45a049;\n          }\n\n          div > div {\n            text-align: center;\n            // background-color: white;\n            // padding: 20px;\n            border-radius: 8px;\n            // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n            @include mq(mobile) {\n              text-align: center;\n              padding-bottom: 0;\n            }\n          }\n\n          .back-plate {\n            padding: 40px;\n            // -webkit-box-shadow: 0px -4px 24px -7px rgba(0, 0, 0, 0.57);\n            // -moz-box-shadow: 0px -4px 24px -7px rgba(0, 0, 0, 0.57);\n            // box-shadow: 0px -4px 24px -7px rgba(0, 0, 0, 0.57);\n          }\n\n          h4 {\n            color: #5c3688;\n            font-family: $Msemibold;\n            font-size: 40px;\n            margin-bottom: 10px;\n            @include mq(mobile) {\n              font-size: 28px;\n            }\n          }\n          .success-p {\n            color: #5c3688;\n            font-family: $Mregular;\n            font-size: 30px;\n            margin-bottom: 20px;\n            @include mq(mobile) {\n              font-size: 18px;\n            }\n          }\n\n          button {\n            background-color: white;\n            padding: 15px 20px;\n            font-size: $Mregular;\n            font-size: 22px;\n\n            color: #5c3688;\n            font-size: 20px;\n            line-height: 20px;\n            padding: 12px 25px;\n            border-radius: 40px;\n            letter-spacing: -0.23px;\n            margin: auto;\n          }\n\n          button:hover {\n            background-color: #470e89;\n          }\n        }\n      }\n    }\n\n    .msg-btn {\n      position: fixed;\n      bottom: 0;\n      width: 90px;\n      bottom: 20px;\n      right: 20px;\n      width: 90px;\n      z-index: 10;\n      // border: 1px solid white;\n      // border-radius: 50%;\n      img {\n        border-radius: 50%;\n        border: solid 1px white;\n      }\n      @include mq(mobile) {\n        width: 40px;\n      }\n    }\n\n    #about {\n      position: relative;\n\n      .swiper-container {\n        margin-top: 134px;\n        width: 100%;\n        overflow: hidden;\n        @include mq(mobile) {\n          margin-top: 60px;\n        }\n      }\n\n      .swiper-slide {\n        width: auto;\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      .hero-img {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n      }\n      .dot-img {\n        flex-grow: 1;\n      }\n    }\n\n    #partnership {\n      padding-top: 167px;\n      .partnership-wrapper {\n        text-align: center;\n      }\n      .head-copy {\n        font-size: 80px;\n        line-height: 90px;\n        font-family: $Msemibold;\n        @include mq(mobile) {\n          font-size: 40px;\n          line-height: 50px;\n        }\n      }\n      .copy {\n        margin-top: 33px;\n        font-size: 30px;\n        font-family: $medium;\n        line-height: 40px;\n      }\n    }\n\n    #mediaSpend {\n      margin-top: 120px;\n      @include mq(mobile) {\n        margin-top: 50px;\n      }\n      .spand-wrapper {\n        // position: relative;\n        display: flex;\n        justify-content: center;\n      }\n      .img-wrapper {\n        position: relative;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n      .copy-wrapper {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n\n        h4 {\n          color: #5c3688;\n          font-size: 100px;\n          line-height: 100px;\n          font-weight: 600;\n          font-family: $Mregular;\n          text-align: center;\n          @include mq(mobile) {\n            font-size: 60px;\n            line-height: 1.2;\n          }\n        }\n        p {\n          color: #5c3688;\n          font-size: 60px;\n          line-height: 70px;\n          font-weight: 600;\n          font-family: $Mregular;\n          text-align: center;\n          @include mq(mobile) {\n            font-size: 45px;\n            line-height: 1.2;\n          }\n        }\n      }\n    }\n\n    #knowmore {\n      padding-top: 157px;\n      .knowmore-wrapper {\n        max-width: 1071px;\n        margin: auto;\n      }\n      .card-wrapper {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 137px;\n        @include mq(mobile) {\n          flex-direction: column;\n        }\n      }\n      .card-img {\n        flex: 1;\n      }\n      .card-copy {\n        flex: 1;\n      }\n      .card-title {\n        font-size: 40px;\n        line-height: 90px;\n        font-family: $Msemibold;\n        @include mq(mobile) {\n          line-height: 50px;\n        }\n      }\n      .card-discription {\n        font-size: 20px;\n        font-family: $medium;\n        line-height: 30px;\n        // letter-spacing: 0%;\n        width: 338px;\n      }\n      .learnmore-btn {\n        margin-top: 11px;\n        font-size: 15px;\n        font-family: $Mregular;\n        line-height: 30px;\n\n        display: flex;\n        align-items: center;\n        gap: 10px;\n      }\n    }\n\n    #sliderContainer {\n      padding-top: 0px;\n      padding-bottom: 160px;\n      box-shadow: rgba(0, 0, 0, 0.35) 0px -4px 11px -4px inset;\n      @include mq(mobile) {\n        padding-top: 0;\n        padding-bottom: 120px;\n        box-shadow: rgb(0 0 0 / 19%) 1px -10px 11px -4px inset;\n      }\n      .wrapper {\n        position: relative;\n        display: flex;\n        justify-content: center;\n        @include mq(mobile) {\n          display: block;\n        }\n      }\n      .heading-slider-2 {\n        font-family: $Msemibold;\n        font-size: 60px;\n        line-height: 90px;\n        text-align: center;\n        color: #5c3688;\n        margin-bottom: 60px;\n        @include mq(mobile) {\n          font-size: 40px;\n          line-height: 1.2;\n          margin-bottom: 40px;\n        }\n      }\n      .swiper-container {\n        display: flex;\n        position: absolute;\n        justify-content: center;\n        align-items: center;\n        top: 61px;\n        bottom: 0;\n        @include mq(mobile) {\n          position: static;\n          display: block;\n          width: 100%;\n          position: absolute;\n          display: block;\n          left: 50%;\n          // trasform: tran;\n          left: 50%;\n          top: 0;\n          transform: translate(-50%, 0);\n          bottom: unset;\n        }\n      }\n      .swiper-wrapper {\n        max-width: 1200px;\n      }\n      .swiper-slide {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        overflow: visible;\n        @include mq(mobile) {\n          padding: 0 40px;\n          width: 100%;\n        }\n      }\n      .swiper-button-next:after {\n        content: unset;\n      }\n      .swiper-button-prev:after {\n        content: unset;\n      }\n      .swiper-button-next2,\n      .swiper-button-prev2 {\n        background-size: contain;\n        background-repeat: no-repeat;\n        background-position: center;\n        width: 44px;\n        height: 44px;\n        position: absolute; /* Ensure absolute positioning */\n        top: 50%;\n        transform: translateY(-50%); /* Center vertically */\n        z-index: 10; /* Ensure buttons are on top */\n        cursor: pointer;\n      }\n      // .swiper-button-next,\n      // .swiper-button-prev {\n      //   display: none;\n      // }\n      .swiper-button-next2 {\n        background-image: url(\"../images/ad-images/arrowRight.svg\");\n        @include mq(mobile) {\n          width: 30px;\n          right: -5px;\n        }\n        @include mq(tab) {\n          right: 150px;\n        }\n      }\n\n      .swiper-button-prev2 {\n        background-image: url(\"../images/ad-images/leftArrow.svg\");\n        @include mq(mobile) {\n          width: 30px;\n          left: -5px;\n        }\n        @include mq(tab) {\n          left: 150px;\n        }\n      }\n      .heading,\n      .city {\n        font-size: 28px;\n        line-height: 34px;\n        font-family: $Mregular;\n        font-weight: 600;\n        color: #5c3688;\n        @include mq(mobile) {\n          text-align: center;\n        }\n      }\n      .para {\n        font-size: 18px;\n        line-height: 24px;\n        margin-top: 16px;\n        font-family: $Mregular;\n        font-weight: 400;\n        color: #5c3688;\n        text-align: center;\n        margin-bottom: 16px;\n        @include mq(mobile) {\n          font-size: 14px;\n          line-height: 18px;\n          margin-bottom: 10px;\n          margin-top: 10px;\n        }\n      }\n    }\n\n    #multichannel {\n      padding-top: px;\n      .multichannel-wrapper {\n      }\n      .head-title {\n        font-size: 80px;\n        line-height: 90px;\n        font-family: $Msemibold;\n        text-align: center;\n        @include mq(mobile) {\n          font-size: 35px;\n          line-height: 45px;\n        }\n      }\n\n      .head-copy {\n        font-size: 30px;\n        line-height: 40px;\n        font-family: $Msemibold;\n        text-align: center;\n        margin-bottom: 93px;\n      }\n\n      .card-wrapper {\n        margin-top: 93px;\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        column-gap: 339px;\n        row-gap: 199px;\n        position: relative;\n\n        @include mq(mobile) {\n          grid-template-columns: unset;\n        }\n      }\n      .center-img {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n\n        transform: translate(-50%, -50%);\n      }\n      .card-title {\n        font-size: 40px;\n        font-family: $Msemibold;\n        line-height: 90px;\n        @include mq(mobile) {\n          line-height: 50px;\n        }\n      }\n      .card-copy {\n        font-size: 20px;\n        font-family: $Msemibold;\n        line-height: 30px;\n      }\n    }\n\n    #cardSection {\n      padding-top: 80px;\n      .heading-cardSection {\n        font-size: 60px;\n        line-height: 90px;\n        color: #5c3688;\n        font-family: $Msemibold;\n        text-align: center;\n        margin-bottom: 32px;\n        @include mq(mobile) {\n          font-size: 40px;\n          line-height: 1.2;\n        }\n      }\n      .card-container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        width: 100%;\n        max-width: 1200px;\n        margin: 0 auto;\n      }\n\n      .row {\n        display: flex;\n        width: 100%;\n        // justify-content: space-around;\n        // align-items: center;\n        position: relative;\n        // margin-bottom: 20px;\n        @include mq(mobile) {\n          flex-direction: column;\n        }\n      }\n\n      .top-cards .card {\n        width: 30%;\n        @include mq(mobile) {\n          width: 100%;\n        }\n      }\n\n      .center-card {\n        position: relative;\n      }\n\n      .center-card .card {\n        width: 45%;\n        @include mq(mobile) {\n          width: 100%;\n        }\n      }\n\n      .card {\n        // background-color: #f2f2f2;\n        padding: 16px;\n        padding-top: 23px;\n        padding-bottom: 76px;\n        // border-radius: 5px;\n        // text-align: center;\n        // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n        // margin: 10px;\n        flex-grow: 1;\n        position: relative;\n      }\n      .heading-card {\n        font-size: 28px;\n        font-family: $Msemibold;\n        line-height: 34px;\n        color: #5c3688;\n        margin-bottom: 15px;\n      }\n      .copy-card {\n        font-size: 18px;\n        font-family: $Mregular;\n        line-height: 24px;\n        color: #5c3688;\n        position: relative;\n        z-index: 5;\n      }\n\n      .top-cards .card {\n        border-bottom: 1px solid #5c368833;\n        z-index: 5; /* Add border-right to all cards except the last one */\n      }\n      .top-cards .card:not(:last-child) {\n        border-right: 1px solid #5c368833; /* Add border-right to all cards except the last one */\n        z-index: 5; /* Add border-right to all cards except the last one */\n      }\n      .center-card .card:not(:last-child) {\n        border-right: 1px solid #5c368833; /* Add border-right to all cards except the last one */\n        z-index: 5; /* Add border-right to all cards except the last one */\n      }\n\n      .card-container .row .card::after {\n        content: \"\";\n        position: absolute;\n        width: 7px;\n        height: 7px;\n        background-color: #5c368833;\n        border-radius: 50%;\n        z-index: 10;\n      }\n      .top-cards .card:not(:last-child)::after {\n        top: 100%;\n        right: -4px;\n        transform: translateY(-50%);\n        z-index: 10;\n      }\n\n      .center-card .card:not(:last-child)::after {\n        top: 100%;\n        right: -4px;\n        transform: translateY(-50%);\n        top: 0;\n        z-index: 10;\n      }\n      .circle-pink {\n        margin-bottom: 30px;\n      }\n\n      .card-4 {\n        padding-left: 211px;\n        @include mq(mobile) {\n          padding-left: 16px;\n          border-bottom: 1px solid rgba(92, 54, 136, 0.2);\n        }\n      }\n      .card-5 {\n        padding-right: 211px;\n        @include mq(mobile) {\n          padding: 16px;\n        }\n      }\n\n      .card-5::after {\n        content: unset !important;\n        width: unset;\n      }\n      .card-3::after {\n        content: unset !important;\n        width: unset;\n      }\n    }\n  }\n\n  //\n  .scroll-container {\n    @include mq(mobile) {\n      padding-top: 60px;\n    }\n  }\n\n  .section {\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .pin-section {\n    position: relative;\n    height: 100vh;\n    display: flex;\n    overflow: hidden;\n    justify-content: center;\n    flex-direction: row-reverse;\n    gap: 40px;\n\n    @include mq(mobile) {\n      flex-direction: column-reverse;\n      gap: 20px;\n    }\n    .card-copy {\n      flex: 1;\n    }\n\n    .learnmore-btn {\n      margin-top: 11px;\n      font-size: 15px;\n      font-family: $Mregular;\n      line-height: 30px;\n\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n  }\n  .text-container,\n  .image-container {\n    flex: 1;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    @include mq(mobile) {\n      align-items: unset;\n      top: 30px;\n    }\n  }\n  .text-container {\n    overflow: hidden;\n  }\n  .text-slide {\n    // font-size: 2rem;\n    position: absolute;\n    width: 100%;\n    // text-align: center;\n    opacity: 0;\n    color: #5c3688;\n\n    .card-title {\n      font-size: 40px;\n      line-height: 90px;\n      font-family: $Msemibold;\n      @include mq(mobile) {\n        font-size: 24px;\n        line-height: 50px;\n      }\n    }\n    .card-discription {\n      font-size: 20px;\n      font-family: $medium;\n      line-height: 30px;\n      // letter-spacing: 0%;\n      width: 338px;\n      @include mq(mobile) {\n        font-size: 15px;\n        line-height: 1.4;\n      }\n    }\n  }\n  .image-slide {\n    position: absolute;\n    width: 400px;\n    height: 400px;\n    background-size: cover;\n    background-position: center;\n    opacity: 0;\n    padding: 100px 0;\n    @include mq(mobile) {\n      width: 300px;\n      height: 300px;\n    }\n    @include mq(tab) {\n      width: 300px;\n      height: 300px;\n    }\n\n    &.backmeta {\n      background-image: url(\"../images/ad-images/backMeta.svg\");\n    }\n    &.google-ads {\n      background-image: url(\"../images/ad-images/google_ads.svg\");\n    }\n    &.tiktok {\n      background-image: url(\"../images/ad-images/Tiktok.svg\");\n    }\n    &.tabola {\n      background-image: url(\"../images/ad-images/Taboola.svg\");\n    }\n    &.snap {\n      background-image: url(\"../images/ad-images/Snap.svg\");\n    }\n  }\n  //\n\n  // .accordion-section {\n  //   padding-top: 89px;\n  //   .heading-acc {\n  //     font-size: 60px;\n  //     line-height: 90px;\n  //     color: #5c3688;\n  //     font-family: $Msemibold;\n  //     text-align: center;\n  //     margin-bottom: 50px;\n  //     @include mq(mobile) {\n  //       font-size: 40px;\n  //       line-height: 1.2;\n  //     }\n  //   }\n  //   .accordion {\n  //     width: 80%;\n  //     margin: 0 auto;\n  //   }\n\n  //   .accordion-item {\n  //     border: 1px solid #5c368833;\n  //     margin-bottom: 20px;\n  //     border-radius: 20px;\n  //   }\n\n  //   .accordion-button {\n  //     // background-color: #f1f1f1;\n  //     border: none;\n  //     padding: 30px 100px;\n  //     text-align: left;\n  //     cursor: pointer;\n  //     width: 100%;\n  //     outline: none;\n  //     font-size: 16px;\n  //     position: relative;\n  //     // padding-left: 30px;\n  //     display: flex;\n  //     flex-direction: row-reverse;\n  //     justify-content: flex-end;\n  //     align-items: center;\n  //     color: #5c3688;\n  //     border-radius: 20px;\n  //     span {\n  //       font-size: 28px;\n  //       width: 36px;\n  //     }\n\n  //     .btn-copy {\n  //       font-family: $Msemibold;\n  //       font-size: 28px;\n  //       line-height: 34px;\n  //     }\n  //     @include mq(mobile) {\n  //       padding: 30px;\n  //       gap: 5px;\n  //       .btn-copy {\n  //         font-size: 18px;\n  //         line-height: 22px;\n  //       }\n  //     }\n  //   }\n\n  //   .accordion-button .plus-minus {\n  //     // position: absolute;\n  //     // left: 10px; /* Adjust the position to your liking */\n  //     // font-size: 20px;\n  //     // line-height: 1;\n  //     // top: 50%;\n  //     // transform: translateY(-50%);\n  //   }\n\n  //   .accordion-content {\n  //     max-height: 0;\n  //     overflow: hidden;\n  //     transition: max-height 0.4s ease-out;\n  //     padding: 0 100px;\n  //     margin-left: 36px;\n  //     @include mq(mobile) {\n  //       padding: 0 20px;\n  //     }\n  //   }\n\n  //   .accordion-content p {\n  //     // margin: 10px 0;\n  //     font-family: $Mregular;\n  //     font-size: 18px;\n  //     line-height: 24px;\n  //     color: #5c3688;\n  //     margin-bottom: 30px;\n  //   }\n\n  //   .accordion-content.show {\n  //     max-height: 1000px; /* Arbitrarily large value to ensure content is visible */\n  //   }\n  // }\n\n  .accordion-section {\n    padding-top: 89px;\n\n    .heading-acc {\n      font-size: 60px;\n      line-height: 90px;\n      color: #5c3688;\n      text-align: center;\n      margin-bottom: 50px;\n      font-family: $Msemibold;\n\n      @include mq(mobile) {\n        font-size: 40px;\n        line-height: 1.2;\n      }\n    }\n\n    .accordion {\n      width: 80%;\n      margin: 0 auto;\n    }\n\n    .accordion-item {\n      border: 1px solid #5c368833;\n      margin-bottom: 20px;\n      border-radius: 20px;\n    }\n\n    .accordion-button {\n      border: none;\n      padding: 30px;\n      padding: 30px 100px;\n      text-align: left;\n      cursor: pointer;\n      width: 100%;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      color: #5c3688;\n      font-size: 28px;\n      background: transparent;\n      display: flex;\n      flex-direction: row-reverse;\n      justify-content: flex-end;\n\n      span {\n        font-size: 28px;\n        width: 36px;\n      }\n\n      @include mq(mobile) {\n        padding: 30px;\n        gap: 5px;\n        .btn-copy {\n          font-size: 18px;\n          line-height: 22px;\n        }\n      }\n    }\n\n    .accordion-content {\n      max-height: 0;\n      overflow: hidden;\n      transition: max-height 0.4s ease;\n      padding: 0 30px;\n      font-size: 18px;\n      color: #5c3688;\n      padding: 0 100px;\n      margin-left: 36px;\n\n      &.show {\n        max-height: 1000px; // Large enough to cover content but not fixed\n        // padding: 20px 30px; // Adjust padding only when expanded\n      }\n      p {\n        font-family: $Mregular;\n      }\n\n      @include mq(mobile) {\n        padding: 0 20px;\n      }\n    }\n\n    .accordion-content p {\n      // margin: 10px 0;\n      font-family: $Mregular;\n      font-size: 18px;\n      line-height: 24px;\n      color: #5c3688;\n      margin-bottom: 30px;\n    }\n\n    .accordion-content.show {\n      max-height: 1000px; /* Arbitrarily large value to ensure content is visible */\n    }\n  }\n\n  #cardContact {\n    padding-top: 116px;\n    @include mq(mobile) {\n      padding-top: 60px;\n    }\n    @include mq(tab) {\n      padding: 64px 50px;\n    }\n    .wrapper {\n      display: flex;\n      background-color: #f17380;\n      justify-content: space-between;\n      padding: 83px 121px;\n      border-radius: 20px;\n      @include mq(mobile) {\n        flex-direction: column;\n        padding: 30px;\n      }\n\n      a {\n        font-family: $Mregular;\n        font-size: 18px;\n        line-height: 34px;\n        font-weight: 600;\n        color: white;\n      }\n      p {\n        font-family: $Mregular;\n        font-size: 18px;\n        line-height: 34px;\n        font-weight: 600;\n        color: white;\n        @include mq(mobile) {\n          font-size: 14px;\n        }\n      }\n    }\n  }\n\n  .footer-add {\n    margin-top: 106px;\n    padding-top: 56px;\n    padding-bottom: 80px;\n    background-color: #5c3688;\n    position: relative;\n    background-image: url(\"../images/ad-images/footerback.png\");\n    background-position: top;\n    background-size: cover;\n    background-repeat: no-repeat;\n    @include mq(mobile) {\n      background-image: url(\"../images/ad-images/footerback.png\");\n      background-position: bottom;\n      background-size: contain;\n      background-repeat: no-repeat;\n      padding-bottom: 80px;\n      margin-top: 80px;\n    }\n    .footer-wrapper-ad {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      // margin-bottom: 19px;\n      @include mq(mobile) {\n        flex-direction: column;\n        gap: 30px;\n      }\n\n      .privacy-policy {\n        font-family: $DMregular;\n        font-size: 16px;\n        color: white;\n      }\n    }\n    .logo {\n      width: 200px;\n      @include mq(mobile) {\n        width: 150px;\n      }\n    }\n    .nav-list {\n      display: flex;\n      align-items: center;\n      a {\n        display: block;\n      }\n\n      @include mq(mobile) {\n        flex-direction: column;\n        gap: 20px;\n      }\n    }\n    .nav-item {\n      font-size: 14px;\n      font-family: $medium;\n      margin-right: 31px;\n      letter-spacing: 0%;\n      color: white;\n      @include mq(mobile) {\n        margin-right: 0;\n      }\n    }\n\n    .footer-hero-img {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: absolute;\n      left: 50%;\n      transform: translate(-50%, 0);\n      width: 100%;\n      bottom: 10px;\n      img {\n        flex-grow: 1;\n      }\n      @include mq(mobile) {\n        bottom: 10px;\n      }\n    }\n\n    .copyright-copy {\n      color: white;\n      font-size: 14px;\n      font-family: $medium;\n      line-height: 40px;\n      text-align: center;\n\n      bottom: 32px;\n      // width: 100%;\n      @include mq(mobile) {\n        // width: 100%;\n        font-size: 14px;\n        width: 100%;\n        left: unset;\n        transform: unset;\n        text-align: center;\n        bottom: 10px;\n      }\n    }\n  }\n}\n.privacy-policy-media-solution {\n  padding: 40px 0;\n  .privacy-policy-wrapper {\n    h1 {\n      font-family: $bold;\n      font-size: 30px;\n      text-align: center;\n      padding-bottom: 40px;\n    }\n    p {\n      font-family: $light;\n      font-size: 20px;\n    }\n    h2 {\n      font-family: $DMbold;\n      font-size: 24px;\n      margin: 20px 0;\n    }\n    h3 {\n      font-family: $DMregular;\n      font-size: 24px;\n      margin: 20px 0;\n    }\n  }\n}\n\n// ecom-page\n.build-ecomm-page-css {\n  @mixin commonBackground {\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  //\n\n  .container_ecom {\n    max-width: 900px;\n    margin: 0 auto;\n    width: 90%;\n\n    @include mq(tab) {\n      width: 90%;\n      max-width: 768px;\n      margin: 0 auto;\n    }\n\n    @include mq(mobile) {\n      width: 320px;\n      // padding: 0 20px;\n      margin: 0 auto;\n    }\n  }\n\n  .container-1 {\n    max-width: 1200px;\n    margin: 0 auto;\n    width: 90%;\n\n    @include mq(tab) {\n      width: 90%;\n      max-width: 768px;\n      margin: 0 auto;\n    }\n\n    @include mq(mobile) {\n      width: 320px;\n      // padding: 0 20px;\n      margin: 0 auto;\n    }\n  }\n\n  .banner {\n    background-image: url(\"../images/blinkecom-images/gredient.png\");\n    background-size: cover;\n    @include commonBackground();\n\n    .wrapper {\n      padding: 6rem 0;\n      max-width: 1100px;\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      @include mq(mobile) {\n        padding-bottom: 3rem;\n        padding-top: 3rem;\n      }\n\n      .gredient_back {\n        position: absolute;\n        width: 400px;\n        right: 0px;\n        z-index: 5;\n\n        @include mq(mobile) {\n          width: 225px;\n          bottom: 10px;\n          position: absolute;\n          right: 0;\n        }\n\n        .time {\n          width: 100%;\n          position: absolute;\n          z-index: 7;\n          left: 50%;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          gap: 10px;\n\n          i {\n            font-size: 50px;\n          }\n\n          h4 {\n            text-align: center;\n            font-family: $DMbold;\n            font-size: 20px;\n            line-height: 1.3;\n\n            @include mq(mobile) {\n              font-size: 12px;\n            }\n          }\n        }\n      }\n\n      .logo-section {\n        position: relative;\n        z-index: 10;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n        width: fit-content;\n\n        p {\n          text-align: end;\n          margin-bottom: 5px;\n          font-family: $DMregular;\n          font-size: 12px;\n          margin-right: -4px;\n\n          @include mq(mobile) {\n            padding-right: unset;\n          }\n        }\n\n        .flex-second {\n          @include flexbox();\n          align-items: stretch;\n          gap: 20px;\n\n          .logo {\n            // border: 1px solid black;\n            display: flex;\n            border: 1px solid black;\n            align-items: center;\n            padding: 10px 20px;\n            border-radius: 8px;\n\n            &.logo-p {\n              position: relative;\n\n              p {\n                position: absolute;\n                top: -10px;\n                // top: 50%;\n                right: 50%;\n                transform: translate(-50%, -50%);\n                font-size: 14px;\n              }\n            }\n\n            .blink_logo {\n              width: 250px;\n            }\n\n            .olm_logo {\n              width: 65px;\n            }\n          }\n        }\n      }\n\n      .hero-copy {\n        margin-top: 20px;\n        margin-bottom: 20px;\n        position: relative;\n        z-index: 10;\n\n        a {\n          display: block;\n          margin: 0 auto;\n        }\n\n        h2 {\n          font-size: 4rem;\n          font-family: $DMbold;\n          // text-transform: capitalize;\n          line-height: 1;\n          text-align: center;\n\n          @include mq(mobile) {\n            font-size: 2rem;\n          }\n        }\n      }\n\n      .para {\n        position: relative;\n        z-index: 10;\n        font-family: $DMregular;\n        font-size: 20px;\n\n        @include mq(mobile) {\n          font-size: 14px;\n        }\n      }\n\n      .btn {\n        position: relative;\n        z-index: 10;\n        display: inline-block;\n        font-size: 1.5rem;\n        font-family: $DMregular;\n        background-color: black;\n        color: $DmPink;\n        padding: 15px 30px;\n        border: 1px solid black;\n        border-radius: 50px;\n        margin: 20px 0;\n        margin: auto;\n\n        @include mq(mobile) {\n          font-size: 16px;\n          padding: 10px 30px;\n        }\n\n        &:hover {\n          background-color: transparent;\n          color: black;\n          transition: 0.5s;\n        }\n      }\n    }\n  }\n\n  .why_us {\n    .wrapper {\n      padding: 4rem 0;\n\n      .flex-logo-wrapper {\n        margin-top: 4rem;\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        row-gap: 50px;\n        column-gap: 50px;\n        @include mq(mobile) {\n          grid-template-columns: repeat(2, 1fr);\n          margin-top: 2rem;\n\n          gap: 10px;\n        }\n      }\n      .logo-copy-item {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        background-color: #f1f1f3;\n        padding: 30px;\n        text-align: center;\n        border-radius: 10px;\n        gap: 10px;\n        @include mq(mobile) {\n          padding: 15px;\n          gap: 5px;\n        }\n        img {\n          width: 80px;\n          @include mq(mobile) {\n            width: 40px;\n          }\n        }\n      }\n      h2 {\n        font-size: 3rem;\n        font-family: $DMbold;\n        margin-bottom: 10px;\n        background: linear-gradient(345deg, #e5b400, #e05300, #e977c1, #516beb);\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n\n        @include mq(mobile) {\n          font-size: 24px;\n          text-align: center;\n        }\n      }\n\n      p {\n        font-size: 20px;\n        font-family: $DMregular;\n        padding-top: 20px;\n\n        @include mq(mobile) {\n          font-size: 14px;\n          padding-top: 5px;\n        }\n      }\n    }\n  }\n\n  .agenda {\n    // display: none;\n    padding: 4rem 0;\n    background-color: #f2f2f2;\n\n    .wrapper {\n      .head {\n        display: flex;\n        align-items: baseline;\n        font-size: 20px;\n        font-family: $DMregular;\n        margin-bottom: 30px;\n        justify-content: space-between;\n      }\n\n      h2 {\n        color: black;\n        font-size: 3rem;\n        font-family: $DMbold;\n        text-transform: uppercase;\n      }\n\n      .border-bottom {\n        // border-bottom: 1px solid #B3B3B3;\n      }\n\n      .lunch {\n        // background: rgb(229, 180, 0);\n        background: linear-gradient(90deg, #e46f2f, #e05301, #e4ad00, #c58403, #ed86ae);\n        @include flexbox();\n        padding: 10px 20px;\n        justify-content: space-between;\n\n        .copy {\n          padding-left: 50px;\n          font-size: 1.1rem;\n          font-family: $DMbold;\n          color: white;\n          text-transform: uppercase;\n\n          @include mq(mobile) {\n            padding-left: 0;\n          }\n        }\n\n        .time {\n          font-size: 1.1rem;\n          font-family: $DMbold;\n          color: white;\n          text-transform: uppercase;\n          padding-right: 50px;\n\n          @include mq(mobile) {\n            padding-right: 0;\n          }\n        }\n      }\n\n      .card-wrap {\n        display: flex;\n        flex-wrap: wrap;\n        row-gap: 0px;\n        column-gap: 2rem;\n        padding-bottom: 30px;\n        padding-top: 20px;\n        justify-content: space-between;\n\n        @include mq(mobile) {\n          flex-direction: column;\n          padding-bottom: 20px;\n        }\n\n        .card {\n          // width: 0;\n          // flex: 1 0 40%;\n          width: 48%;\n          @include flexbox();\n          align-items: flex-start;\n          padding: 20px 0;\n          gap: 20px;\n\n          @include mq(mobile) {\n            width: 100%;\n            padding: 20px 0;\n            gap: 10px;\n          }\n\n          // border-bottom: 1px solid #D7D7D7;\n\n          &:last-child {\n            // border-bottom: none;\n          }\n\n          .img-wrap {\n            img {\n              border-radius: 50%;\n              width: 100px;\n            }\n          }\n\n          .info {\n            @include flexbox();\n            // flex-direction: column;\n            justify-content: space-evenly;\n            width: 100%;\n            justify-content: space-between;\n            flex-direction: column;\n\n            .name {\n              font-size: 20px;\n              font-family: $DMbold;\n            }\n\n            .para {\n              font-size: 20px;\n              font-family: $DMregular;\n            }\n\n            .position {\n              @include flexbox();\n              gap: 14px;\n\n              @include mq(mobile) {\n                flex-direction: column;\n                gap: 5px;\n              }\n\n              .copy {\n                font-family: $DMregular;\n                color: #6d6d6d;\n\n                @include mq(mobile) {\n                  font-size: 13px;\n                }\n              }\n\n              .time {\n                font-family: $DMbold;\n\n                @include mq(mobile) {\n                  font-size: 14px;\n                }\n              }\n            }\n\n            .tag {\n              font-size: 16px;\n              font-family: $DMbold;\n              background: linear-gradient(345deg, #facc35, #ee2a23, #f58121);\n              -webkit-background-clip: text;\n              -webkit-text-fill-color: transparent;\n              // font-size: 4rem;\n              font-family: $DMbold;\n\n              @include mq(mobile) {\n                font-size: 12px;\n              }\n            }\n          }\n        }\n      }\n\n      .center-tag {\n        padding-top: 20px;\n        padding-bottom: 20px;\n\n        @include mq(mobile) {\n          padding-bottom: 0px;\n        }\n\n        .position {\n          @include flexbox();\n          gap: 3rem;\n\n          @include mq(mobile) {\n            flex-direction: column;\n            align-items: center;\n            gap: 0;\n          }\n\n          .copy {\n            font-family: $DMregular;\n            color: #6d6d6d;\n          }\n\n          .time {\n            font-family: $DMbold;\n\n            @include mq(mobile) {\n              font-size: 14px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .details {\n    padding: 4rem 0;\n    background-image: url(\"../images/blinkecom-images/gredient.png\");\n    background-size: cover;\n    @include commonBackground();\n\n    .wrapper {\n      h2 {\n        color: white;\n        font-size: 3rem;\n        font-family: $DMbold;\n        margin-bottom: 30px;\n\n        @include mq(mobile) {\n          font-size: 24px;\n          text-align: center;\n        }\n      }\n\n      iframe {\n        width: 100%;\n        .HMRMj {\n          display: none;\n        }\n        .HB1eCd-UMrnmb {\n          background-color: red;\n          .teQAzf {\n            width: 100% !important;\n          }\n          body {\n            background-color: transparent !important;\n          }\n          .D8bnZd {\n            background-color: rgba(62, 18, 107, 0) !important;\n          }\n        }\n      }\n\n      .form_container_1 {\n        @include flexbox();\n        flex-direction: column;\n        gap: 20px;\n\n        .form_container {\n          @include flexbox();\n          gap: 1rem;\n\n          @include mq(mobile) {\n            flex-direction: column;\n          }\n\n          .form_1 {\n            @include flexbox();\n            flex-wrap: wrap;\n            gap: 20px;\n            flex-grow: 1;\n            justify-content: space-between;\n\n            @include mq(mobile) {\n              flex-direction: column;\n            }\n          }\n\n          .field-wrap {\n            width: 48%;\n            position: relative;\n\n            @include mq(mobile) {\n              width: 100%;\n            }\n\n            .error_form {\n              font-size: 12px;\n              color: red;\n              position: absolute;\n              bottom: -14px;\n              margin: 0;\n            }\n\n            &.field-wrap-2 {\n              width: 100%;\n              position: relative;\n\n              .error_form {\n                font-size: 12px;\n                color: red;\n                position: absolute;\n                bottom: 5px;\n                margin: 0;\n              }\n            }\n          }\n\n          .input_css {\n            max-width: 100%;\n            width: 100%;\n            background-color: #f2f2f2;\n            font-size: 16px;\n            padding: 18px 10px;\n            border-radius: 5px;\n\n            flex-grow: 1;\n\n            &::placeholder {\n              color: #9d9d9d;\n            }\n\n            @include mq(mobile) {\n              width: 100%;\n              padding: 14px 10px;\n              font-size: 16px;\n            }\n          }\n        }\n\n        .input_css_2 {\n          background-color: #f2f2f2;\n          font-size: 24px;\n          padding: 18px 10px;\n          border-radius: 5px;\n          font-family: $DMregular;\n\n          &::placeholder {\n            color: #9d9d9d;\n            font-size: 16px;\n            vertical-align: middle;\n          }\n\n          @include mq(mobile) {\n            padding: 14px 10px;\n            font-size: 16px;\n          }\n        }\n\n        .input_css_1 {\n          background-color: #f2f2f2;\n          font-size: 16px;\n          padding: 18px 10px;\n          border-radius: 5px;\n          font-family: $DMregular;\n          width: 100%;\n\n          &::placeholder {\n            color: #9d9d9d;\n            font-size: 16px;\n            vertical-align: middle;\n          }\n\n          @include mq(mobile) {\n            padding: 14px 10px;\n            font-size: 16px;\n            height: 150px;\n          }\n        }\n      }\n\n      a {\n        display: inline-block;\n        font-size: 1.5rem;\n        font-family: $DMregular;\n        color: $DmPink;\n        padding: 15px 30px;\n        border: none;\n        border-radius: 50px;\n        margin: 40px 0;\n        // margin-top: 30px;\n        color: white;\n        background-color: transparent;\n        border: 1px solid white;\n\n        @include mq(mobile) {\n          margin: 30px 0;\n          padding: 10px 30px;\n          font-size: 17px;\n          display: block;\n          text-align: center;\n          /* margin: auto 0; */\n          margin-left: auto;\n          margin-right: auto;\n          width: fit-content;\n        }\n\n        &:hover {\n          background-color: black;\n          color: $DmPink;\n          border: 1px solid black;\n          transition: 0.5s;\n        }\n      }\n    }\n  }\n\n  .footer-ecom {\n    padding: 2rem 0;\n    position: absolute;\n    width: 100%;\n    // bottom: 0;\n    background-color: #f2f2f2;\n\n    .wrapper {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      display: flex;\n      align-items: flex-start;\n      justify-content: space-between;\n\n      @include mq(mobile) {\n        flex-direction: column;\n        gap: 20px;\n        align-items: center;\n      }\n\n      .logo {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        img {\n          width: 130px;\n        }\n        p {\n          font-family: $DMmedium;\n        }\n      }\n\n      .email_wrap {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        font-family: $DMregular;\n        p {\n          font-family: $DMmedium;\n        }\n        .flex-footer {\n          display: flex;\n          justify-content: space-between;\n          gap: 10px;\n          @include mq(mobile) {\n            flex-direction: column;\n            align-items: center;\n          }\n        }\n\n        @include mq(mobile) {\n          flex-direction: column;\n          gap: 10px;\n          align-items: center;\n        }\n      }\n    }\n  }\n}\n\n.logo-main-css {\n  .banner-relative {\n    position: relative;\n  }\n  .absolute-copy {\n    position: absolute;\n    top: 50%;\n    color: white;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-family: $Mbold;\n    font-size: 60px;\n    @include mq(mobile) {\n      font-size: 20px;\n    }\n    @include mq(tab) {\n      font-size: 24px;\n    }\n  }\n  .wrapper-logo-row {\n    padding: 80px 0;\n    display: flex;\n    flex-direction: column;\n    gap: 100px;\n    .grid-logo {\n      display: grid;\n      grid-template-columns: repeat(3, 3fr);\n      gap: 50px;\n\n      @include mq(mobile) {\n        grid-template-columns: repeat(1, 1fr);\n        padding: 0 40px;\n      }\n    }\n    .card-box {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 20px;\n    }\n    .img-box {\n      background-color: gray;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      flex-grow: 1;\n      padding: 50px;\n      justify-content: center;\n      background-color: rgb(248, 248, 248);\n      border: 1px solid rgba(0, 0, 0, 0.176);\n      border-radius: 6px;\n    }\n    .btn-dow {\n      background-color: rgba(0, 0, 0, 0);\n      color: black;\n      padding: 6px 12px;\n      font-size: 16px;\n      border: 1px solid black;\n      border-radius: 6px;\n    }\n  }\n}\n\n.not-found-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  // background-color: #f8f9fa;\n  text-align: center;\n  padding: 20px;\n}\n\n.not-found-container .container {\n  // background: #fff;\n  padding: 40px;\n  border-radius: 16px;\n  // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  max-width: 500px;\n  width: 100%;\n}\n\n.not-found-container h1 {\n  font-size: 3.2rem;\n  margin-bottom: 10px;\n  font-family: $DMbold;\n  color: #000;\n  text-transform: capitalize;\n  @include mq(mobile) {\n    font-size: 1.5rem;\n  }\n}\n\n.not-found-container p {\n  font-size: 1.1rem;\n  // color: #6c757d;\n  margin-bottom: 40px;\n  font-family: $Mlight;\n}\n\n.cta-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  // padding: 12px 24px;\n  // background-color: #007bff;\n  // color: #fff;\n  text-decoration: none;\n  text-transform: capitalize;\n  // border-radius: 8px;\n  font-weight: bold;\n  transition: background-color 0.3s ease;\n  transition: border 0.3s ease;\n  font-family: $Mregular;\n  font-size: 26px;\n  padding-bottom: 2px;\n  border-bottom: 2px solid transparent;\n  img {\n    width: 20px;\n  }\n  @include mq(mobile) {\n    font-size: 1.2rem;\n    img {\n      width: 16px;\n    }\n  }\n}\n\n.cta-button:hover {\n  // background-color: #0056b3;\n  // padding-bottom: 2px;\n  // border-bottom: 2px solid black;\n  img {\n    transform: translate(15px, -15px); /* Move the arrow from bottom left */\n    opacity: 0; /* Start with the arrow hidden */\n    transition:\n      transform 0.3s ease-in-out,\n      opacity 0.3s ease-in-out;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
